'use client';
/* eslint-disable no-return-await */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-empty */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-console */
/* eslint-disable react/no-unused-state */
import { Box } from '@mui/material';
import {
  BaseTagTooltip,
  EIoTProviders,
  GetSDK,
  iTHREE,
  NodeEventsTypes,
  SceneInitEventsTypes,
  TagEventsType,
  TagTooltipCustom,
  TagPopup,
} from '@treedis/tour-loader';
import classnames from 'classnames';
import LegalNote from 'components-new/common/LegalNote';
import _cloneDeep from 'lodash/cloneDeep';
import _debounce from 'lodash/debounce';
import _isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import dynamic from 'next/dynamic';
import Script from 'next/script';
import React, { PureComponent } from 'react';
import { toast } from 'react-toastify';
import { removeAll as removeAllTweens, update as updateTween, getAll as getAllTween } from 'three/examples/jsm/libs/tween.module';
import { v4 as uuid } from 'uuid';
import { Agent } from '@/_models/Agent';
import {
  ConditionType,
  EntityType,
  Game,
  GameCondition,
  LockLocationType,
  LockType,
} from '@/_models/Game';
import { ChapterType } from '@/_models/game/GameBook';
import { Menu as MenuObject, MenuType } from '@/_models/Menu';
import {
  CustomButtonTypeOpenAsType,
  TagDockSideType,
  Tour,
  TourMode,
  TourType,
} from '@/_models/Tour';
import {
  Avatar,
  AVATAR_CIRCLE_RADIUS,
  avatarComponentType,
  makeAvatarComponent,
} from '@/_models/virtualStaging/avatar';
import { FRFloor } from '@/_models/virtualStaging/FRFloor';
import { pointsOnCircle2D } from '@/_models/virtualStaging/helper';
import LoadingQueue from '@/_models/virtualStaging/LoadingQueue';
import {
  Polygon,
  PolygonAction,
  PolygonActionAction,
  PolygonActionMode,
  PolygonActionType,
} from '@/_models/virtualStaging/Polygon';
import { videoRendererType } from '@/_models/virtualStaging/VideoRenderer.component';
import AdminAPI from '@/api/TreedisAdminDAO';
import {
  LoadingState,
  TourAction,
  TourActionType,
  TourImage,
  TourObject,
  TourVideo,
  TourVSHtml,
  VSImage,
  VSInteractionType,
  VSObject,
  VSTourAsset,
  VSVideo,
  VSVideoType,
} from '@/_models/virtualStaging/VSObject';
import { VSSettings } from '@/_models/virtualStaging/VSSettings';
import { allowUsesCookie } from '@/components/common/CookieConsent';
import { TagManager } from '@/components/util/sdk/tag';
import file from '@/utils/file';
import PublicAPI from '../../api/TreedisPublicDAO';
import { color, getAsset, getDeviceFingerprint } from '../../utils';
import { CustomCookieConsent } from '../common/CookieConsent';

import * as all from '../util/all';
import {
  fetchData,
  getQueryVariable,
  deleteQueryVariable,
  getVersion,
  getVideoLink,
} from '../util/all';

import { sendToGA, startGA } from '../util/analytic';

import {
  closeTagEmbedTagObserver,
  closeTagPanelObserver,
  setErrorObserver,
  setMPPasswordFormObserver,
  setTagPanelObserver,
  startAddMeasurementsModeObserver,
} from '@/components/util';
import DeviceManager from '../util/deviceManager';
import * as popups from '../util/popups';
import * as sdk from '../util/sdk';
import * as navigation from '../util/navigation';
import * as pipes from '../util/pipes';
import socket from '../util/socket';
import { calculateMobileHeight } from '../util/styles';

import SoundControls from './regular/bottomBar/SoundControls';
import FullScreen from './regular/fullScreen/FullScreen';

import SetDataToZustand from '@/components/tour/components/SetDataToRecoil';
import GameAnalyticService from '@/components/tour/game/services/GameAnalyticService';
import { calculateLocation } from './calculateLocation';
import LoadTourIframe from './regular/loadTourIframe/LoadTourIframe';

import { asyncStore } from '@/_helpers/base';
import { dLog, stopLogs } from '@/_helpers/renderDebug';
import { storage } from '@/_helpers/storage';
import { Tag, TagType } from '@/_models/Tag';
import { UserSubscription } from '@/_models/User';
import {
  backpackMeshComponentType,
  makeBackpackMeshComponent,
} from '@/_models/virtualStaging/HTMLMesh/component/Backpack/BackpackMesh.component';
import {
  makeMatterTagMeshComponent,
  matterTagMeshComponentType,
} from '@/_models/virtualStaging/HTMLMesh/component/MatterTag/MatterTagMesh.component';
import {
  makeMenuMeshComponent,
  menuMeshComponentType,
} from '@/_models/virtualStaging/HTMLMesh/component/Menu/MenuMesh.component';
import {
  makePathFinderMeshComponent,
  pathFinderMeshComponentType,
} from '@/_models/virtualStaging/HTMLMesh/component/PathFinder/PathFinderMesh.component';
import { createBackpackhtml } from '@/_models/virtualStaging/HTMLMesh/utils/createBackpackhtml';
import { createMatterTagHTML } from '@/_models/virtualStaging/HTMLMesh/utils/createMatterTagHTML';
import {
  createFlowsBarHTML,
  createFlowsMenuHTML,
  createMenuHTML,
} from '@/_models/virtualStaging/HTMLMesh/utils/createMenuHTML';
import { createPathFinderHTML } from '@/_models/virtualStaging/HTMLMesh/utils/createPathFinderHTML';
import {
  hasPathFinderData,
  updateStylesAndContent,
} from '@/_models/virtualStaging/HTMLMesh/utils/pathFinderUtils';
import { ComponentInteractionType } from '@/_models/virtualStaging/Scene.component';
import {
  initPipes,
  initPipesAmericanWater,
  initPolygonUpdateFromVideo,
} from '@/_models/virtualStaging/Tube';
import { VRCameraController } from '@/_models/virtualStaging/VRCameraController';
import {
  makeVRPointerComponent,
  VRPointerComponentType,
} from '@/_models/virtualStaging/VRPointer/component/VRPointer.component';
import {
  getBarriers,
  getFlowsData,
  getNavigationSweeps,
  getPath,
  getSweepIndex,
  getSweeps,
  getTeleportGroups,
  getVSItems,
} from '@/api/queries';
import { VSHTMLPopup } from '@/components/common/VSHTMLPopup';
import { addPinnedVideoFunc } from '@/components/tour/addPinnedVideoFunc';
import CrashScreen from '@/components/tour/components/CrashScreen';
import { ScreenNavigationArrow } from '@/components/tour/game/ScreenNavigationArrow';
import { getIframeStyle } from '@/components/tour/getIframeStyle';
import { getUrlVariables } from '@/components/tour/getUrlVariables';
import { logoutHandler } from '@/components/tour/logoutHandler';
import { stopApp } from '@/components/tour/stopApp';
import { takePositionData } from '@/components/tour/takePositionData';
import {
  ExternalProvider,
  GameStatus,
  ShowcaseElement,
  TreedisSDKEvent,
  vsTriggerType,
} from '@/components/types';
import { CookieAcceptanceContext } from '@/hooks/useCookies';
import { Button } from '@/units/index';
import { extractSweepIdFromURL } from '@/utils/extractSweepIdFromURL';
import { getProjectedQuaternion } from '@/utils/getProjectedQuaternion';
import { getRPMModelId } from '@/utils/getRPMModelId';
import { randomNumberId } from '@/utils/randomNumberId';
import { AudioModule, MusicObj, MusicObjectKey } from '../../components-new/common/AudioModule';
import IotLogic from '../iot/IotLogic';
import { getLocationUrl } from '../util/getLocationUrl';
import ClipScreen from './game/ClipScreen';
import { GameBookHandle } from './game/GameBookHandle';
import { RegularPaths } from './game/RegularPaths';
import BottomBarWithRecoil from './regular/bottomBar/BottomBarWithRecoil';
import AdRedesigned from './regular/ad-redesigned/AdRedesigned';
import ConfirmDialog from './regular/confirm-dialog/ConfirmDialog';
import CustomButton from './regular/custom-button/CustomButton';
import GetInTouchButton from './regular/get-in-touch-button/GetInTouchButton';
import MenuWrapper from './regular/menu-wrapper/MenuWrapper';
import MondelezTabletVideo from './regular/mondelez-tablet-video/MondelezTabletVideo';
import { styledToast } from '@/utils/styledToast';
import { InteractedListener } from './components/InteractedListener';
import { NavigationWrapper, TeleportGroupType } from '../navigation/NavigationWrapper';
import VimeoVideo from '@/components/tour/regular/vimeoVideo';
// import { TagTooltipCustom } from '@/components/tour/components/TagTooltipCustom/TagTooltipCustom';
// import { IotTagTooltip } from '@/components/iot/IotTagTooltip/IotTagTooltip';
import { IotTourModal } from '@/components/iot/IotTourModal/IotTourModal';
import { IotLoginModal } from '@/components/iot/IotLoginModal/IotLoginModal';
import { getAllSweeps } from '@/components/util/sdk/sweep/data';
import { getPathCalculationSweeps } from '@/_models/virtualStaging/PathFinderLine/utils';
import FlowsContainer from '../flows/FlowsContainer';
import { emitter, MittEvents } from '../../events';
import { extractContentFromHTML } from '@/utils/removeHTMLTagsFromString';
import GalleryDialog from '@/components/tour/components/GalleryDialog';
import MarkerPopup from '@/components/tour/components/MarkerPopup';
import { ControllerType } from '@/_models/virtualStaging/HTMLMesh/component/Menu/types';
import {
  makeVREventManagerComponent,
  VREventManagerComponentType,
} from '@/_models/virtualStaging/VREventManager';
import { AIAvatar, AIAvatarStatus } from "@/_models/virtualStaging/AIAvater/AIAvatar";
import { storeWSAIAvatarKey, storeWSAIAvatarVoiceId } from "@/_models/virtualStaging/AIAvater/lib/services/websocketAuthManager";
import { AIAvatarStatusPanel } from '@/components/tour/regular/ai-avatar';
import { DeloreanCTBPipes } from '@/components/custom/DeloreanCTB/pipes';
import FileDialogProps from './components/FileDialog';
// import { jsonSafeParse } from '@/utils/json';

const ExperiencePopUp = dynamic(() => import('@/components/tour/components/ExperiencePopUp'), {
  ssr: false,
});

const IntroScreen = dynamic(() => import('components-new/common/intro-screen'), {
  ssr: false,
});
const Sweep = dynamic(() => import('./regular/sweep/Sweep'), {
  ssr: false,
});
const Share = dynamic(() => import('./regular/share/Share'), {
  ssr: false,
});
const DebugWindow = dynamic(() => import('../../components-new/common/DebugWindow'), {
  ssr: false,
});
const Terms = dynamic(() => import('./regular/terms/Terms'), {
  ssr: false,
});
const Help = dynamic(() => import('./regular/help/Help'), {
  ssr: false,
});
const IntroPopup = dynamic(
  () => import('@/components/tour/regular/avatar/popups').then((res) => res.IntroPopup),
  {
    ssr: false,
  },
);
const SketchfabPopup = dynamic(() => import('@/components/tour/regular/popups/SketchfabPopup'), {
  ssr: false,
});
const Minimap = dynamic(() => import('./regular/minimap/Minimap'), {
  ssr: false,
});
const Panorama = dynamic(() => import('./regular/panorama/Panorama'), {
  ssr: false,
});
const ContactPopup = dynamic(() => import('./regular/popups/Contact'), {
  ssr: false,
});
const ExternalPopup = dynamic(() => import('./regular/popups/External'), {
  ssr: false,
});

const PanoPopup = dynamic(() => import('./regular/popups/Pano'), {
  ssr: false,
});
const PathFinderPopup = dynamic(() => import('./regular/popups/pathFinder'), {
  ssr: false,
});
const TagsPopup = dynamic(() => import('./regular/popups/Tags'), {
  ssr: false,
});
const VSActionsPopup = dynamic(() => import('./regular/popups/VSActions'), {
  ssr: false,
});
const Countdown = dynamic(() => import('./regular/countdown/Countdown'), {
  ssr: false,
});
const MessengerCustomerChat = dynamic(
  () => import('./regular/messengerCustomerChat/MessengerCustomerChat'),
  {
    ssr: false,
  },
);
const MemoizedVideo = dynamic(() => import('./regular/video/Video'), {
  ssr: false,
});
const Appointment = dynamic(() => import('./regular/appointment/Appointment'), {
  ssr: false,
});
const ActionPathNavbarWithRecoil = dynamic(() => import('./components/ActionPathNavbar'), {
  ssr: false,
});
const LayersOverlay = dynamic(() => import('./layers/LayersOverlay'), {
  ssr: false,
});

declare global {
  interface Document {
    mozCancelFullScreen?: () => Promise<void>;
    msExitFullscreen?: () => Promise<void>;
    webkitExitFullscreen?: () => Promise<void>;
    mozFullScreenElement?: Element;
    msFullscreenElement?: Element;
    webkitFullscreenElement?: Element;
  }

  interface HTMLElement {
    msRequestFullscreen?: () => Promise<void>;
    mozRequestFullscreen?: () => Promise<void>;
    webkitRequestFullscreen?: () => Promise<void>;
  }
}

const DEFAULT_VS_SENSOR_RADIUS = DeviceManager.isMobile() ? 25 : 25;

const defaultLogo = getAsset('logo-white.svg');

const audioHandler = AudioModule.getInstance();

export default class BaseTour extends PureComponent<any, any> {
  static whyDidYouRender = true;

  static contextType = CookieAcceptanceContext;

  messengerQ: any = getQueryVariable(window.location.href, 'messenger');

  root: any;

  renderer: any;

  rendererRef: any;

  gamepadLRef: any;

  gamepadRRef: any;

  deferVisibilityVSObjectRef: any;

  iframe: any;

  showcase: any;

  showCaseTemp: any;

  pathResult: any;

  currentSweep: any = null;

  defaultSweep: any = null;

  prevSweep: any = null;

  avatarNodes: Map<string, any> = new Map();

  aiAvatars: Map<string, AIAvatar> = new Map();

  activeAIAvatarId: string | null = null;

  mouseCursor: any;

  playAudioTimeout: any = null;

  mainContainerWaitingForPlay = false;

  currentPanorama: any;

  panoPose: any;

  buildLink: any;

  openTagIframe: any;

  openVsObjectIframe: any;

  openVsImageIframe: any;

  openVsVideoIframe: any;

  toggleExternalPopup: any;

  openedPanoHotspot: any;

  takeScreenshot: any;

  takePano: any;

  toggleExternalPopupNull: any;

  toggleContactPopup: any;

  pose: any = {};

  sensor: any;

  tagIcons: any[];

  floor: FRFloor = new FRFloor({
    floor: 0,
    position: null, // for shadow positioning
  });

  loadModel: any;

  moveToMPLabels: any;

  setWhiteLabel: any;

  messenger: number = parseInt(this.messengerQ === false ? '1' : this.messengerQ, 10);

  visibleTags: any = {};

  hiddenTags: any = {};

  modelNodes: any[] = [];

  shadowNode: any;

  vsObjects: Array<VSTourAsset> = [];

  barriers = [];

  customSweeps = [];

  teleportPoints = [];

  isMobile: boolean = DeviceManager.isMobile();

  avatarDegree: number = null;

  lastAvatarCameraPose: any;

  connectedAvatarsLastSweep: any[] = []; // previous sweep for all other avatars in tour

  connectedAvatarsTweens: { avatarId: string; activeTween: any; activeRotationTween: any }[] = []; // amount of active animations for all other avatars in tour

  camera: any = null;

  isShadowEnabled = false;

  gameAnalytic: GameAnalyticService = null;

  calculateLocation: any;

  clickedElement: { id: string | number; type: EntityType };

  loadingQueue: LoadingQueue;

  THREE: any;

  pathFinderMeshComponent: any;

  matterTagMeshComponents = [];

  VRPointer: {
    component: any;
    target: any;
  } = {
    component: null,
    target: null,
  };

  yAxisVec3: any;

  prevPathFinderData: {
    isEnablePreviousStep: boolean;
    description: string;
  };

  menuMeshComponent: any;

  flowsMenuMeshComponent: any;

  flowsBarMeshComponent: any;

  vrEventManager: any;

  backpackMeshComponent: any;

  backpackMeshState: null | 'loading' | 'loaded' | 'error';

  // TODO Hardcoded pipes for TB-2112
  pipesData: any;

  backpack: { items: [] } = { items: [] };

  hasController: boolean;

  pathFinderLine: any;

  pathArrowRefBaseTour: any;

  cameraRotation: any;

  cameraPose: any;

  SceneVRCameraController: any;

  openedVRTag: any;

  setNavigationDestination: any;

  moveToNavigationStartingPoint: any;

  deselectTagTimeout = undefined;

  buildPipes: any;

  isGeorgiaPacificTour = false;

  showcaseAppSubscriber = null;

  showcaseSubscribers = [];

  loadShowcaseFrameAbortController: AbortController;

  tagManager: TagManager;

  selectedNoteTag: Tag | null;

  animationId: number | null = null;

  twinMakerDataInterval: NodeJS.Timeout | null = null;

  destroyAddMeasurementsModeObserver;

  constructor(props: any, tourType: TourType) {
    super(props);
    console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA');
    this.state = {
      isTagHovered: false,
      tagHovered: null,
      lastTagHovered: null,
      selectedTag: null,
      allAudio: null,
      iframeId: `iframe_${randomNumberId()}`,
      showcaseLoaded: false,
      showSketchfabPopup: false,
      tour: null,
      floors: [],
      allowGuestBeforeHost: false,
      changeMenu: false,
      pathfinderDataState: {},
      menuSettings: {},
      parentMenus: [],
      iot: {
        devices: [],
        newDoorNotification: null,
        devicePositions: [],
        sceneAssets: [], // Scene VS Images
        lockDeviceId: null,
        moveToDevice: null,
        openCamera: null,
        menuSettings: {},
        providers: [],
        favouriteCameras: [],
        openFavouriteCameras: null,
      },
      reelVideos: [],
      pinnedVideos: [],
      reel: [],
      changeReel: false,
      sweeps: [],
      mpFloors: [],
      mpLabels: [],
      translation: {},
      tourEmail: null,
      sweepGroups: [],
      host: props.rule === 'host',
      audioOnly: props.videoType === 'audio',
      isRemoteControlled: props.videoType === 'remote_control',
      minimaps: [],
      clickedTag: false,
      allTags: new Map(), // Treedis and Matter tags
      selectedNoteTag: null,
      interacted: false,
      selectedMinimap: 0,
      menuOpened: false,
      iframeUrl: null,
      menuOpen: false,
      musicPausedByUser: false,
      tourAudioPlaying: false,
      vsHTMLPopup: {
        show: false,
        src: null,
      },
      overlayOn: false,
      videoPlaying: false,
      externalPopupOn: false,
      contactPopupOn: false,
      panoramas: [],
      polygons: [],
      layers: [],
      showLayers: false,
      agents: [],
      tagPopOn: false,
      panoPopOn: false,
      gameLockPopOn: false,
      openedLock: null,
      userAnswerForGameLock: null,
      videoChatTagPopOn: false,
      vsActionPopOn: false,
      panoramaOn: false,
      openedTag: null,
      openedPanoHotspot: null,
      openedVSAction: new TourImage(),
      externalPopupUrl: null,
      minimapOn: false,
      minimapVisible: false,
      measurementsOn: false,
      markerPopupOn: false,
      sharePopupOn: false,
      tourPlaying: false,
      mapWalkerRotation: 0,
      reelStep: 0,
      mapWalkerX: null,
      mapWalkerY: null,
      activeSweepGroup: null,
      dominantSpeaker: null,
      pathResult: null,
      // user: null,
      selectedMarker: { url: null, external: null },
      tokenRemainingTime: -1,
      tokenExpiresAt: null,
      // createdAt: null,
      // clock: false,
      activePano: null,
      appointmentsModal: false,
      appointmentsHintOn: true,
      getInTouchHintOn: true,
      MenuHintOn: true,
      lock: false,
      room: props.room,
      whiteLabelData: null,
      showHelpModal: false,
      showTermsModal: false,
      activeMenu: null,
      products: [],
      tourType,
      vsSettings: new VSSettings(),
      isVSReady: false,
      containerId: 'public',
      loadingTags: true,
      game: null,
      currentFloor: null,
      panoPose: { yaw: 0, pitch: 0, hfov: 0 },
      isVSEnabled: true,
      isVSVisible: true,
      loadedOnce: false,
      showPathFinderPopup: false,
      tourMode: null,
      experiencePopUpIsOpen: false,
      onExperienceCloseCallback: () => undefined,
      currentSweep: null,
      experiencePopUpData: null,
      closedElementPopup: true,
      isEnableNextPathLock: true,
      initialDuplicates: null,
      isChangeIframe: false,
      avatar: {},
      isClickedTag: false,
      chatParticipant: {},
      gameTrialErr: null,
      crashScreen: false,
      unlockedChapterIds: [],
      clickedElements: [],
      hideSubtitlesGroupId: null,
      showBottomBar: true,
      hideBottomBarForWhile: false,
      isShowNearestProducts: true,
      nearestProducts: [],
      waitLoadingPolygons: false,
      isClickedElement: false,
      isShowProducts: false,
      isShowProduct: false,
      startScreenOn: false,
      showCookieFullScreen: false,
      hideLogo: false,
      // Needed for sepecific NYT tours
      isSubtitleVisible: false,

      mondelezTabletVideo: {
        videoId: undefined,
        sweepsHistory: [],
      },
      menuWidth: 0,
      actionPathNavbarData: {
        enableNavBar: false,
        destinationTitle: null,
        icon: null,
        autoNavigation: false,
        enableTeleportBtn: false,
      },
      showActionPathBar: false,
      actionPathNavbarPlayButtonType: 'Play',
      actionPathNavbarDistance: null,
      closeBurgerMenuFromThreads: false,
      isThreadsDrawerOpen: false,
      threadsLoaded: false,

      confirmDialog: {
        open: false,
        title: '',
        desc: '',
        showInput: false,
        onAgree: () => {},
        onCancel: () => {},
      },
      actionPathFinished: false,
      navigationStartPosition: null,
      navigationTarget: null,
      isNavigationBackgroundVisible: true,
      shouldNavReset: false,
      showTeleportLoading: false,
      endTeleportName: '',
      endTpType: TeleportGroupType.Elevator,
      isTpUp: false,
      iotModalOpen: false,
      iotModalShowDescription: false,
      tagPopupOpen: false,
      tagPopupShowDescription: false,
      // flows
      flowIsActive: false,
      mainFlow: null,
      flows: [],
      flowsObjects: [],
      flowAssetsToDisableAction: [],
      flowsVisibleAssets: { videos: [], objects: [] },
      startFlowFromAsset: null,
      enableFlowRunOnLaunch: false,

      aiAvatarStatusPanel: {
        visible: false,
        status: 'connecting' as AIAvatarStatus,
        aiAvatarId: null,
      },
    };

    this.loadingQueue = LoadingQueue.getInstance();
    this.loadingQueue.subscribe((loaded: number | boolean) => {
      if (loaded === true) {
        // commented untill find good solution for youtube embed scroll fix for windows that will not affect other attachments
        // const style = document.createElement('style');
        // style.innerText = '.tag-media .attachment-carousel .attachment-carousel-view .attachment {height: 205px;}';
        // this.iframe.contentDocument.head.appendChild(style);
        this.setState({ loaded: true });
      }
    });

    this.rendererRef = React.createRef();
    this.gamepadLRef = React.createRef();
    this.gamepadRRef = React.createRef();
    this.cameraPose = React.createRef();
    this.pathArrowRefBaseTour = React.createRef();
    this.deferVisibilityVSObjectRef = React.createRef();
    this.deferVisibilityVSObjectRef.current = [];
    this.calculateLocation = calculateLocation.bind(this);
    this.buildLink = all.buildLink.bind(this); // need this code ??
    this.openTagIframe = sdk.openTagIframe.bind(this);
    this.openVsObjectIframe = sdk.openVsObjectIframe.bind(this);
    this.openVsImageIframe = sdk.openVsImageIframe.bind(this);
    this.openVsVideoIframe = sdk.openVsVideoIframe.bind(this);
    this.loadModel = sdk.loadModel.bind(this);
    this.moveToMPLabels = sdk.moveToMPLabels.bind(this);
    this.setWhiteLabel = all.setWhiteLabel.bind(this);
    document.addEventListener('keydown', this.takePosition);
    this.toggleExternalPopup = popups.toggleExternalPopup.bind(this);
    this.toggleExternalPopupNull = popups.toggleExternalPopup.bind(this, null);
    this.toggleContactPopup = popups.toggleContactPopup.bind(this);
    this.takeScreenshot = sdk.takeScreenshot.bind(this);
    this.takePano = sdk.takePano.bind(this);
    this.openedPanoHotspot = sdk.openedPanoHotspot.bind(this);
    this.setNavigationDestination = navigation.setNavigationDestination.bind(this);
    this.moveToNavigationStartingPoint = navigation.moveToStartingPoint.bind(this);
    this.buildPipes = pipes.buildPipes.bind(this);

    const { room } = this.state;
    this.prevPathFinderData = {
      isEnablePreviousStep: false,
      description: '',
    };

    this.animate();

    socket.on('move_avatar', (data: any) => {
      const { tour } = this.state;
      const { THREE } = this;
      if (!tour?.enableAvatar) return;
      const avatar = this.avatarNodes.get(data.avatarId);

      // Is the avatar moving into my sweep? (sweep id...)
      // if it does, use relative position, avatar.relative
      const [myX, myZ] = pointsOnCircle2D(
        AVATAR_CIRCLE_RADIUS,
        180 + this.avatarDegree,
        data?.pose?.position?.x,
        data.pose?.position?.z,
      );
      const [x, z] = pointsOnCircle2D(AVATAR_CIRCLE_RADIUS, data.degree, myX, myZ);

      if (avatar && avatar[1] && avatar[1].outputs.loadingState === LoadingState.Loaded) {
        console.log(avatar[1].inputs.bodyType);

        if (avatar[1].inputs.bodyType === 'fullbody') {
          if (data.pose.sweep.sid !== '') {
            // check if avatar sweep has changed
            const shouldAnimationPlay = this.didAvatarSweepChange(avatar[1].id, data.pose.sweep.id);
            if (shouldAnimationPlay) {
              const targetPosVec3 = new THREE.Vector3(
                data.degree && this.avatarDegree ? x : data.pose.sweep.position.x,
                data.pose.sweep.position.y,
                data.degree && this.avatarDegree ? z : data.pose.sweep.position.z,
              );
              this.moveAvatarToPoint(avatar, targetPosVec3, THREE);
            }
            avatar[0].obj3D.children[0].children[0].rotation.set(-Math.PI / 2, 0, 0);
          }

          const vec3 = new THREE.Vector3(0, 0, 1);
          const quaternion = new THREE.Quaternion(
            data.pose.quaternion[0],
            data.pose.quaternion[1],
            data.pose.quaternion[2],
            data.pose.quaternion[3],
          );
          vec3.applyQuaternion(quaternion);
          const vec3Projected = vec3.clone();
          vec3Projected.projectOnPlane(this.yAxisVec3);
          vec3Projected.negate().normalize();
          const mx = new THREE.Matrix4().lookAt(
            vec3Projected,
            new THREE.Vector3(0, 0, 0),
            new THREE.Vector3(0, 1, 0),
          );
          const qt = new THREE.Quaternion().setFromRotationMatrix(mx);

          avatar[1].rotateTo(
            qt,
            (tween) => {
              // If there is active tween, stops it. Replaces/adds this tween to avatarId
              const avatarTweenData = this.connectedAvatarsTweens.find(
                (el) => el.avatarId === avatar[1].id,
              );
              if (avatarTweenData) {
                if (avatarTweenData.activeRotationTween) avatarTweenData.activeRotationTween.stop();
                if (avatarTweenData.activeTween) tween.stop();
                avatarTweenData.activeRotationTween = tween;
              } else
                this.connectedAvatarsTweens.push({
                  avatarId: avatar[1].id,
                  activeTween: null,
                  activeRotationTween: tween,
                });
            },
            () => {
              const avatarTweenData = this.connectedAvatarsTweens.find(
                (el) => el.avatarId === avatar[1].id,
              );
              avatarTweenData.activeRotationTween = null;
            },
          );

          // uncomment if performance is bad due to rotation smoothing
          // avatar[0].obj3D.children[0].quaternion.set(qt.x, qt.y, qt.z, qt.w);
          // avatar[0].obj3D.children[0].rotateX(-Math.PI / 2);
        }
        if (avatar[1].inputs.bodyType === 'halfbody') {
          avatar[1].avatarHasMoved = true;
          avatar[1].root.visible = true;
          avatar[0].obj3D.position.set(
            data.degree && this.avatarDegree ? x : data.pose.sweep.position.x,
            data.pose.position.y,
            data.degree && this.avatarDegree ? z : data.pose.sweep.position.z,
          );
          avatar[0].obj3D.children[0].position.set(0, -0.6, 0);
          avatar[0].obj3D.quaternion.set(
            data.pose.quaternion[0],
            data.pose.quaternion[1],
            data.pose.quaternion[2],
            data.pose.quaternion[3],
          );
          avatar[0].obj3D.children[0]?.rotation.set(0, Math.PI, 0);
        }
        if (avatar[1].inputs.bodyType === 'image') {
          avatar[1].avatarHasMoved = true;
          avatar[1].root.visible = true;
          avatar[0].obj3D.position.set(
            // data.degree && this.avatarDegree ? x : data.pose.sweep.position.x,
            x || data.pose.sweep.position.x,
            data.pose.position.y,
            z || data.pose.sweep.position.z,
            // data.degree && this.avatarDegree ? z : data.pose.sweep.position.z,
          );

          // avatar[0].obj3D.children[0].position.set(0, -0.6, 0);
        }
      }
    });

    socket.on('move_avatar_face', (data: any) => {
      const { tour } = this.state;
      if (!tour?.enableAvatar) return;
      const avatar = this.avatarNodes.get(data.avatarId);
      if (avatar) {
        avatar[1].updateFromResults(data.pose);
      }
    });

    socket.on('all_users', (users: any) => {
      const { tour } = this.state;
      if (tour.enableAvatar) {
        // first we set our degree
        if (this.avatarDegree === null) {
          const myself = users.find((user: any) => {
            return user.socketId === socket.id;
          });
          this.avatarDegree = myself.degree;
          console.log('Assigned degree', this.avatarDegree);
        }
        // then we add all avatars
        users.forEach((user, i) => {
          if (user.socketId !== socket.id) {
            // user.degree = (i+1)*7;
            this.addAvatar(user);
          }
        });
      }
    });

    socket.on('user_leave', async (data: any) => {
      const { tour } = this.state;
      if (tour?.enableAvatar) {
        await this.onRemoveAvatar(data.avatarId);
      }
    });

    socket.on('move', (pose: any) => {
      if (this.state.lock) {
        this.moveToSweepIO(pose);
      }
    });

    if (room) {
      socket.on('menu', (menu: any) => {
        this.loadModel(menu);
      });

      socket.on('tag_click', (tag: { sid: string; action: string }) => {
        if (this.state.lock) {
          this.moveToTagIO(tag, tag.action === 'click');
          const { allTags } = this.state;
          const allTagsArray = Array.from(allTags, ([, value]: any) => value);
          const foundTag = allTagsArray.find((t) => t.sid === tag.sid || t.defaultSid === tag.sid);
          this.setState({ selectedTag: foundTag });
        }
      });

      socket.on('tag_hover', (tag: { sid: string; action: string }) => {});

      socket.on('vs', (data) => {
        if (this.state.lock) {
          const { vsImageId, vsVideoId, vsObjectId, eventData, type, btnType } = data;
          let instance = null;
          let searchId = vsImageId;

          if (vsImageId) {
            instance = this.showCaseTemp.scene?.sceneImage;
            searchId = vsImageId;
          } else if (vsVideoId) {
            instance = this.showCaseTemp.scene?.sceneVideo;
            searchId = vsVideoId;
          } else if (vsObjectId) {
            instance = this.showCaseTemp.scene?.sceneObject;
            searchId = vsObjectId;
          }

          if (instance && instance?.assets) {
            instance.assets.forEach(([assetKey, node]) => {
              if (assetKey.id === searchId) {
                const [, component] = node;
                component.onEvent(type, eventData);
                if (type === NodeEventsTypes.VIDEO_BUTTON_CLICK) {
                  const btnComponentMap = { play: node[1].playBtn, mute: node[1].muteBtn };
                  this.handleVideoButtonClick({
                    eventData,
                    component,
                    preventEmit: true,
                    data: { id: vsVideoId, node: node[1] },
                    btnComponent: btnComponentMap[btnType],
                  });
                }
              }
            });
          }
        }
      });

      socket.on('polygon', (data) => {
        if (this.state.lock) {
          const { type, assetId, eventData } = data;
          const [, component] = this.showCaseTemp.scene.scenePolygon.assets.get(assetId);

          if (component && type) {
            component.onEvent(type, eventData);
          }
        }
      });

      socket.on('lock', (_lock: boolean) => {
        if (this.state.lock !== _lock) {
          this.setState({ lock: _lock });
        }
      });

      socket.on('close-tag', () => {
        this.setState({ tagPopOn: false, tagPopupOpen: false });
      });
      socket.on(
        'close-embed-tag',
        _debounce(() => {
          const embedTagContentElem = this.getShowcaseElement(ShowcaseElement.TagEmbedMedia);
          if (embedTagContentElem?.firstChild) {
            setTimeout(() => {
              embedTagContentElem.firstChild.click();
            }, 500);
          }
        }, 100),
      );

      socket.on('close-polygon', () => {
        this.closeActionPop();
      });
      socket.on('close-pano-pop', () => {
        this.setState({ panoPopOn: false });
      });

      socket.on('toggle-pano', (data: any) => {
        this.setState(data);
      });
      socket.on('move-pano', (data: any) => {
        this.setState({
          panoPose: data.panoPose,
          activePano: data.currentPanorama.id,
        });
      });
      socket.on('pano-hotspot-click', (data: any) => {
        this.setState({ panoramaOn: false, activePano: null }, () => {
          this.getTour({
            slug: data.id,
            changeMenu: data.changeMenu,
            changeMinimap: data.changeMinimap,
            changePanorama: data.changePanorama,
            url: data.url,
            tourData: props.tourData,
          });
        });
      });
    }
    socket.on('disconnect', (reason) => {
      console.error(`Socket disconnected`, reason);
    });

    socket.io.on('reconnect', () => {
      console.log('Reconnecting socket.. enabling avatar again');
      this.initAvatar().catch((e: any) => {
        console.error('Error enabling avatar', e);
      });
    });

    // @ts-ignore
    window.startTime = Date.now();

    window.addEventListener('beforeunload', () => {
      // Make sure window has tourInfo!

      // @ts-ignore
      if (!window.tourId) {
        // @ts-ignore
        window.tourId = props.tourData.id;
      }

      sendToGA(
        'event',
        {
          // @ts-ignore
          tourId: window.tourId,
          eventCategory: 'TourTime',
          eventAction: 'timeTrack',
          eventLabel: 'timeTrack',
          time: {
            // @ts-ignore
            startTime: window.startTime,
            endTime: Date.now(),
          },
        },
        true, // skip google analytics
      ).catch((err) => {
        console.error(err);
      });

      logoutHandler({
        ticket: this.state?.tour?.ticket,
      }).catch((err) => {
        console.error(err);
      });
    });
    calculateMobileHeight();
    window.addEventListener('resize', calculateMobileHeight);
    document.addEventListener('click', this.hideTreedisTagTooltip);
    document.addEventListener('touchstart', this.hideTreedisTagTooltip);

    emitter.on(MittEvents.AUDIO_MUTE, (e) => {
      const { mute } = e;
      if (mute) this.muteAllVsVideos();
    });
    emitter.on(MittEvents.TOUR_AUDIO_PLAY, (e) => {
      const play = e.isTourMusic;
      this.setState({
        tourAudioPlaying: play,
      });
    });
  }

  get isFreeUser(): boolean {
    // If subscription is unknown/undefined yet, we shouldn't block any features
    if (
      ![
        UserSubscription.Free,
        UserSubscription.Growth,
        UserSubscription.Business,
        UserSubscription.Enterprise,
      ].includes(this.state.tour?.user?.subscription)
    ) {
      return false;
    }
    return (
      this.state.tour?.user?.subscription === UserSubscription.Free && !this.state.tour?.isSample
    );
  }

  animate = () => {
    this.animationId = requestAnimationFrame(this.animate);
    if (getAllTween().length === 0) return;
    updateTween();
  };

  didAvatarSweepChange = (avatarId, newSweepId) => {
    let shouldAnimationPlay: boolean;
    const avatarLastSweepIndex = this.connectedAvatarsLastSweep.findIndex(
      (obj) => obj && obj.id === avatarId,
    );
    if (avatarLastSweepIndex !== -1) {
      const targetAvatarLastSweep = this.connectedAvatarsLastSweep[avatarLastSweepIndex];
      shouldAnimationPlay = targetAvatarLastSweep.sweepId !== newSweepId;
      this.connectedAvatarsLastSweep[avatarLastSweepIndex].sweepId = newSweepId;
    } else {
      shouldAnimationPlay = true;
      this.connectedAvatarsLastSweep.push({ id: avatarId, sweepId: newSweepId });
    }
    return shouldAnimationPlay;
  };

  moveAvatarToPoint(avatar, targetPosVec3, THREE) {
    // Make avatar look at direction of target sweep while in animation
    const qt = getProjectedQuaternion(
      avatar[0].obj3D.position,
      targetPosVec3,
      this.yAxisVec3,
      THREE,
    );

    avatar[1].moveToPos(
      targetPosVec3,
      qt,
      (tween) => {
        // If there is active tween, stops it. Replaces/adds this tween to avatarId
        const avatarTweenData = this.connectedAvatarsTweens.find(
          (el) => el.avatarId === avatar[1].id,
        );
        if (avatarTweenData) {
          if (avatarTweenData.activeTween) avatarTweenData.activeTween.stop();
          avatarTweenData.activeTween = tween;
        } else
          this.connectedAvatarsTweens.push({
            avatarId: avatar[1].id,
            activeTween: tween,
            activeRotationTween: null,
          });
      },
      () => {
        const avatarTweenData = this.connectedAvatarsTweens.find(
          (el) => el.avatarId === avatar[1].id,
        );
        avatarTweenData.activeTween = null;
      },
    );
  }

  componentWillUnmount() {
    // Stop animation loop
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }

    // Clear all timeouts and intervals
    if (this.playAudioTimeout) {
      clearTimeout(this.playAudioTimeout);
      this.playAudioTimeout = null;
    }
    if (this.ticketTimeout) {
      clearTimeout(this.ticketTimeout);
      this.ticketTimeout = null;
    }
    if (this.deselectTagTimeout) {
      clearTimeout(this.deselectTagTimeout);
      this.deselectTagTimeout = undefined;
    }
    if (this.twinMakerDataInterval) {
      clearInterval(this.twinMakerDataInterval);
      this.twinMakerDataInterval = null;
    }

    // Stop all Tween animations
    removeAllTweens();

    // Clean up avatar tweens
    this.connectedAvatarsTweens.forEach(({ activeTween, activeRotationTween }) => {
      if (activeTween) activeTween.stop();
      if (activeRotationTween) activeRotationTween.stop();
    });
    this.connectedAvatarsTweens = [];

    // Clean up avatars
    this.avatarNodes.forEach(([avatar]) => {
      if (avatar && avatar.stop) {
        avatar.stop();
      }
    });
    this.avatarNodes.clear();

    this.aiAvatars.forEach((aiAvatar, aiAvatarId) => {
      try {
        aiAvatar.destroy();
      } catch (error) {
        console.error(`Error destroying AIAvatar ${aiAvatarId}:`, error);
      }
    });
    this.aiAvatars.clear();

    // Remove all socket event listeners
    if (socket) {
      socket.off('move_avatar');
      socket.off('move_avatar_face');
      socket.off('all_users');
      socket.off('user_leave');
      socket.off('move');
      socket.off('menu');
      socket.off('tag_click');
      socket.off('tag_hover');
      socket.off('vs');
      socket.off('polygon');
      socket.off('lock');
      socket.off('close-tag');
      socket.off('close-embed-tag');
      socket.off('close-polygon');
      socket.off('close-pano-pop');
      socket.off('toggle-pano');
      socket.off('move-pano');
      socket.off('pano-hotspot-click');
      socket.off('disconnect');
    }

    // Clean up showcase subscribers
    this.showcaseSubscribers.forEach((unsubscribe) => {
      try {
        unsubscribe();
      } catch (e) {
        console.warn('Error unsubscribing from showcase event:', e);
      }
    });
    this.showcaseSubscribers = [];

    // Clean up showcase and renderer resources
    if (this.showCaseTemp?.showcase) {
      try {
        this.showCaseTemp.showcase.disconnect();
      } catch (e) {
        console.warn('Error disconnecting showcase:', e);
      }
    }

    // Clean up WebGL contexts
    if (this.renderer) {
      try {
        this.renderer.dispose();
        this.renderer.forceContextLoss();
      } catch (e) {
        console.warn('Error disposing renderer:', e);
      }
    }

    // Clean up iframe resources
    this.cleanupIframeResources();

    // Remove DOM event listeners
    window.removeEventListener('resize', calculateMobileHeight);
    document.removeEventListener('click', this.hideTreedisTagTooltip);
    document.removeEventListener('touchstart', this.hideTreedisTagTooltip);
    document.removeEventListener('keydown', this.takePosition);

    // Remove emitter listeners
    emitter.off(MittEvents.AUDIO_MUTE);
    emitter.off(MittEvents.TOUR_AUDIO_PLAY);

    // Clear references to prevent memory leaks
    this.showCaseTemp = null;
    this.showcase = null;
    this.renderer = null;
    this.camera = null;
    this.iframe = null;
    this.vsObjects = [];
    this.modelNodes = [];
    this.barriers = [];
    this.customSweeps = [];
    this.teleportPoints = [];
    this.matterTagMeshComponents = [];
    this.tagManager = null;
    this.gameAnalytic = null;
    this.loadingQueue = null;

    // Force garbage collection if available
    if (window.gc) {
      try {
        window.gc();
      } catch (e) {
        console.warn('Unable to force garbage collection:', e);
      }
    }
  }

  getCameraRotation = async () => {
    // TODO: pass in props this.camera, not the function
    return {
      rotation: this.camera?.rotation,
      quaternion: this.camera?.quaternion,
    };
  };

  renderCrashScreen = () => (
    <CrashScreen
      show={this.state.crashScreen}
      backgroundImage={`${process.env.NEXT_PUBLIC_CDN}/tours/${this.state.tour?.id}/images/${this.state.tour?.mainImage}`}
    />
  );

  setPathfinderDataState = (data: any) => {
    this.setState({ pathfinderDataState: data });
  };

  handleLogin = (password: string) => {
    const { tour } = this.state;
    if (tour.password === password) {
      styledToast('Login successful', 'success');
      this.setState({ tour: { ...tour, password: null }, interacted: true });
      return true;
    }

    styledToast('Wrong password', 'error');
    return false;
  };

  onPlayClick = async (data: {
    password?: string;
    name?: string;
    phone?: string;
    email?: string;
    legalBookingBox?: boolean;
    legalBookingBox2?: boolean;
  }) => {
    const { tour, game, tourType, showIntro, tourEmail } = this.state;
    try {
      const hasIC = game?.introClip && (game?.introClipUrl || game?.uploadedIntroUrl);
      if (data.password) {
        const loginSuccess = this.handleLogin(data.password);

        if (!loginSuccess) return;

        if (!hasIC) {
          this.showcaseLoad();
        } else if (!tour.introScreen) {
          this.setState({ showIntro: true });
        }
        if (!tour.introScreen && (tour.mpPasswordActive || !hasIC)) {
          this.onIntroScreenFinished();
        }

        return;
      }

      if (!showIntro && hasIC) {
        this.setState({ showIntro: hasIC });
      }

      if (tour?.id && tour?.collectLeads) {
        try {
          sendToGA('event', {
            eventCategory: 'Lead',
            eventAction: 'submit',
            eventLabel: 'entry',
          });
          await fetchData('public/setTourLead', 'POST', {
            tourId: tour.id,
            ...data,
          });

          await PublicAPI.sendEmail({
            data: {
              to: (tourEmail && tourEmail.leadForms) || (tour.client && tour.client.email),
              params: Object.assign(data, {
                tour: tour.title,
                userId: tour.userId,
                link: window.location.href,
                clientId: tour?.client?.id,
              }),
            },
          });
        } catch (err) {
          console.error(err.message);
        }
      } else if (TourType.Game === tourType) {
        this.handleGameStartOnIntroModal(data?.name);
      }

      sendToGA('event', {
        eventCategory: 'IntroScreen',
        eventAction: 'click',
        eventLabel: 'introButton',
      });
    } finally {
    }
  };

  /** Fetches sweeps, teleport groups, barriers. Processes them and puts into state */
  async loadTourEntities() {
    const { tour, iframeUrl } = this.state;
    const { slug, matterId } = tour;
    const actualMatterId = getQueryVariable(iframeUrl, 'm') || matterId;

    const promises = [
      getTeleportGroups(tour.id),
      getBarriers(tour.id),
      getSweeps(String(actualMatterId), slug),
      getNavigationSweeps(tour.id),
    ];

    const [teleportGroupsRes, barrierData, mpSweeps, navigationSweepsRes] = await Promise.all(
      promises,
    );

    const teleportGroups = teleportGroupsRes || [];
    const navigationSweeps = navigationSweepsRes || [];

    const allSweeps = getAllSweeps(mpSweeps, navigationSweeps);
    const floors: FRFloor[] = [];

    if (mpSweeps?.length) {
      const isMatterportLink = getQueryVariable(iframeUrl, 'm') !== matterId;
      const frFloorsRes = !isMatterportLink ? await AdminAPI.getFRFloors(slug) : { data: [] };
      // using sweep.floor_position to get the floor height position
      mpSweeps.forEach((sweep) => {
        if (!floors[sweep.floor_index]) {
          const frFloor = frFloorsRes?.data.find((i: any) => i.floor === sweep.floor_index);

          const floor = {
            floor: sweep.floor_index,
            position: sweep.floor_position,
          };
          floors[sweep.floor_index] = frFloor
            ? new FRFloor({
                ...frFloor,
                ...floor,
              })
            : new FRFloor(floor);
        }
        floors[sweep.floor_index].sweeps?.push(sweep);
      });
    }

    this.setState({
      sweeps: mpSweeps,
      navigationSweeps,
      allSweeps,
      floors,
      sweepsLoaded: true,
      teleportGroups,
      barrierData,
    });
  }

  onIntroScreenFinished = () => {
    const { showIntro, showcaseLoaded } = this.state;

    if (showIntro) {
      this.setState({ startScreenOn: false }, async () => {
        if (showcaseLoaded) {
          await this.playTourAudio().catch(() => {});
        }
      });
    } else {
      this.setState({ startScreenOn: false, forcePlayGameIntro: true }, async () => {
        if (showcaseLoaded) {
          await this.processTourMusic(true);
        }
      });
    }
    if (this.state.tourType === TourType.Game) {
      this.setState({
        gameStatus: GameStatus.Started,
      });
    }
  };

  onIntroScreenUnmount = () => {
    this.hideLoadingScreenIfExists();

    let alreadyPlaying = false;

    // Forcing autoplay for vsVideos (TB-3663)
    this.vsObjects.forEach((vsObject: any) => {
      if (!(vsObject instanceof TourVideo) || !vsObject.isVisible || !vsObject?.node) return;

      const { video } = vsObject.node;

      if (vsObject.autoplay) {
        video.play();
      }
      // isDefaultMuted Only for videos with hidden mute button
      if (vsObject.hideMuteButton && !vsObject.isDefaultMuted && !alreadyPlaying) {
        video.muted = false;
        alreadyPlaying = true;
      }
    });
  };

  setParentState(attr: any, val: any) {
    this.setState({ [attr]: val });
  }

  updateIotState = (iotState: any) => {
    if (iotState.devices?.length && this.pipesData) {
      if (this.pipesData.update) this.pipesData.update(iotState.devices);
    }
    this.setState((prevState) => ({ iot: { ...prevState.iot, ...iotState } }));
  };

  getTour = async ({
    slug,
    changeMenu = true,
    changeMinimap = true,
    changePanorama = true,
    url = null,
    hideIntroScreen = false,
    tourData,
    bypassCookieCheck,
    changeReel = false,
  }: {
    slug: string;
    changeMenu?: boolean;
    changeMinimap?: boolean;
    changePanorama?: boolean;
    changeReel?: boolean;
    url?: any | null;
    hideIntroScreen?: boolean;
    tourData?: any;
    bypassCookieCheck?: boolean;
  }) => {
    // cancel any previous initStarting ( for case when we are loading another tour before previous one is fully loaded)
    this.setState({ startingInitialized: false });
    const urlParams = new URLSearchParams(window.location.search)
    const aiAvatarWSKey = urlParams.get("aiKey");
    const aiAvatarVoiceId = urlParams.get("aiVoice");
    if (aiAvatarWSKey) {
      storeWSAIAvatarKey(aiAvatarWSKey);
    }
    if (aiAvatarVoiceId) {
      storeWSAIAvatarVoiceId(aiAvatarVoiceId);
    }

    // If the user has not yet accepted cookies, and loadTourAfterCookie is true, do not load tour in background (it will be loaded after cookie is accepted)
    if (
      tourData?.tour?.cookieIsMandatory &&
      tourData?.tour?.loadTourAfterCookie &&
      !allowUsesCookie() &&
      !bypassCookieCheck
    ) {
      this.setState({ tour: tourData?.tour });
      // Doing this here because we need translations for the cookie popup
      this.initTourInfo(tourData?.tour?.id);
      return;
    }
    this.setState({ showcaseLoaded: !changeMenu });
    try {
      this.loadingQueue.setLoadingQueueProgress(10);

      const data =
        tourData ||
        (await PublicAPI.getTour({
          data: {
            slug,
            mode: this.state.tourType,
            excludeTranslation: true,
            pmeToken: urlParams.get('pmeToken'),
          },
        }));

      this.loadingQueue.setLoadingQueueProgress(15);

      if (!data || !data.tour) {
        toast.error("Couldn't find this tour in our databases");
        return;
      }

      if (bypassCookieCheck) {
        // when tour was embedded into website cookie does not work, so react-cookie-consent can not detect it
        data.tour.hideCookie = true;
      }

      window.localStorage.setItem('userCountry', data?.tour?.user?.country);

      if (data.tour.fontFamily) {
        document.documentElement.style.setProperty(
          '--custom-font-family',
          `${data.tour.fontFamily}`,
        );
      }

      this.setWhiteLabel(data.tour);
      this.initTourInfo(data.tour.id);

      if (data.tour.menuEnabled && changeMenu) {
        const parentMenuResponse = await PublicAPI.getParentMenu({
          data: {
            id: data.tour.id,
          },
        });

        this.setState({
          menuSettings: parentMenuResponse?.menuSettings || {},
          parentMenus: parentMenuResponse?.parentMenus || []
        });
      }

      // IOT
      if (data.tour.enableIot) {
        const menuRes = await PublicAPI.getIoTMenu({
          query: {
            tourId: data.tour.id,
          },
        });

        if (menuRes?.data) {
          this.updateIotState({
            menuSettings: {
              ...menuRes.data,
              colorSettings: JSON.parse(menuRes.data?.colorSettings || '{}'),
            },
          });
        }
      }

      if (
        data?.tour?.languageCode === 51 ||
        (data?.tour?.initialDuplicates?.length > 0 &&
          data?.tour?.initialDuplicates[0]?.languageCode === 'fr')
      ) {
        window.localStorage.setItem('rightPriceSymbol', '1');
      } else {
        window.localStorage.removeItem('rightPriceSymbol');
      }

      if (url) {
        // Support for matterport->treedis->matterport
          const iframeId = getQueryVariable(this.state.iframeUrl, 'm');
          const s = getQueryVariable(url, 's');
          const x = getQueryVariable(url, 'x');
          const y = getQueryVariable(url, 'y');

          if (iframeId !== data.tour.matterId) {
            this.setState({ isChangeIframe: true });
            // Setting vsObjects to empty if we load another tour
            this.vsObjects = [];
          }

          if (hideIntroScreen) {
            data.tour.introScreen = null;
          }

          // eslint-disable-next-line eqeqeq
          if (iframeId == data.tour.matterId && s && x && y) {
            // We move inside the tour
            const menuOpenForDevice =
              this.state.tourType === TourType.Regular &&
              !!(DeviceManager.isMobile()
                ? data.tour.menuEnabled && data.tour.menuAlwaysOpenMobile
                : data.tour.menuEnabled && data.tour.menuAlwaysOpenDesktop);
            this.setState({
              menuOpen: changeMenu ? menuOpenForDevice : this.state.menuOpen,
              showcaseLoaded: true,
            });

            if (this.showcase.App.Phase.PLAYING.includes(this.state.appState)) {
              await this.moveToSweep(String(s), { x: parseFloat(x), y: parseFloat(y) });
            }

            return;
          }
        }

      return this.loadData(data.tour, changeMenu, changeMinimap, changePanorama, url, changeReel);
    } catch (err) {
      console.error(err.message);
    }
  };

  initTourInfo = (id: number) => {
    fetchData(`public/getTranslations/${id}`, 'GET')
      .then((data) => {
        this.setState({ translation: data.translations });
      })
      .catch((err) => {
        console.error(err.message);
      });

    fetchData(`public/getEmails/${id}`, 'GET')
      .then((data) => {
        this.setState({ tourEmail: data.emails });
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  getTagIconId = (tag) => {
    if (tag.isThread) {
      return 'thread';
    }

    const iconName =
      tag.iconFile ||
      (tag.customIcon === 'null' || tag.customIcon === null ? null : tag.customIcon);
    const iconSid = tag.sid;

    if (iconName && iconSid) {
      return `${iconName}__${iconSid}`;
    }

    return null;
  };

  addMattertag = async (tag: any) => {
    const sid = null;
    try {
      const iconId = this.getTagIconId(tag);
      const rgb = all.hexToRgb(tag.iconColor);
      const addDetails: any = {
        label: tag.title || '',
        description: tag.description || '',
        anchorPosition: {
          x: tag.positionX,
          y: tag.positionY,
          z: tag.positionZ,
        },
        stemVector: {
          x: tag.stemVectorX || 0,
          y: tag.stemVectorY == null ? 0.3 : tag.stemVectorY,
          z: tag.stemVectorZ || 0,
        },
        color: {
          r: rgb.r / 255,
          g: rgb.g / 255,
          b: rgb.b / 255,
        },
        stemVisible: typeof tag.stemVisible === 'boolean' ? tag.stemVisible : true,
      };

      if (iconId) addDetails.iconId = iconId;

      const addRes = await this.showcase.Tag.add(addDetails).catch((e) => {
        console.error(e);
      });

      if (addRes && addRes[0]) {
        // eslint-disable-next-line prefer-destructuring
        tag.sid = addRes[0];
        await this.editTagMedia(tag);
        return tag.sid;
      }
    } catch (err) {
      console.error(err);
    }
    return sid;
  };

  registerIcon = async ({ iconId, url }) => {
    console.log('URL', url);
    await this.showcase.Asset.registerTexture(iconId, url).catch((e) => {
      console.error(e);
    });
  };

  editTagMedia = async (tag: any) => {
    if (!tag) return;
    await this.setTagAllowAction(tag);
    if (tag.opacity !== null && typeof tag.opacity === 'number') {
      await this.showcase.Tag.editOpacity(tag.sid, tag.opacity / 100).catch((e) => {
        console.error(e);
      });
    }
    if (tag.treedisStyle) return;
    const label = tag.mpTitle ? tag.title : '';
    const { description } = tag;

    if (tag.videoUrl) {
      await this.tagManager
        .addAttachment(
          {
            originName: tag.videoUrl,
            url: tag.videoUrl,
          },
          tag.sid,
        )
        .catch(console.error);
    }

    if (tag.type === TagType.Iframe) {
      const t = await this.showcase.Tag.registerSandbox(
        `
        <style>
          body {
            overflow-x: hidden;
            margin: 0;
            padding: 0 10px;
          }
          .container {
            display: flex;
            width: 100%;
            height: 100%;
            flex-direction: column;
            background: white;
          }
          .item {
            border: none;
            margin: 0;
            padding: 0;
          }
          ::-webkit-scrollbar {
              width: 0px;
              height: 0px;
          }
        </style>
        <div class="container">
            <iframe allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay; fullscreen; camera; microphone; clipboard-read; clipboard-write; display-capture; geolocation; xr-spatial-tracking" class="item" src=${tag.url} ></iframe>
        </div>
      `,
      ).catch(console.error);
      if (t) {
        const [sandboxId] = t;
        await this.showcase.Tag.attach(tag.sid, sandboxId).catch(console.error);
      }
    } else if (tag.tagGalleries?.length) {
      try {
        const attachments = tag.tagGalleries
          .filter(({ url }) => !url.includes('mp4') && !url.includes('pdf'))
          .map((gallery) => ({
            originName: gallery.name,
            url: `${process.env.NEXT_PUBLIC_CDN}${gallery.url}`,
          }));
        await this.tagManager.addAttachments(attachments, tag.sid).catch(console.error);
      } catch (e) {
        console.error(e.message);
      }
    }

    await this.showcase.Tag.editBillboard(tag.sid, {
      label,
      description: tag.treedisStyle ? description : extractContentFromHTML(description),
    }).catch(console.error);
  };

  editMattertag = async (tag: any) => {
    try {
      const iconId = this.getTagIconId(tag);

      if (iconId) {
        await this.showcase.Tag.editIcon(tag.sid, iconId).catch((e) => {
          console.error(e);
        });
      } else {
        await this.showcase.Tag.resetIcon(tag.sid).catch((e) => {
          console.error(e);
        });
      }

      await this.showcase.Tag.editPosition(tag.sid, {
        anchorPosition: {
          x: tag.positionX,
          y: tag.positionY,
          z: tag.positionZ,
        },
        stemVector: {
          x: tag.stemVectorX || 0,
          y: tag.stemVectorY == null ? 0.3 : tag.stemVectorY,
          z: tag.stemVectorZ || 0,
        },
        stemVisible: typeof tag.stemVisible === 'boolean' ? tag.stemVisible : true,
      });

      if (tag.iconColor && /#\w*/i.test(tag.iconColor)) {
        const rgb = all.hexToRgb(tag.iconColor);
        await this.showcase.Tag.editColor(tag.sid, {
          r: rgb.r / 255,
          g: rgb.g / 255,
          b: rgb.b / 255,
        }).catch(console.error);
      }
      await this.editTagMedia(tag);
    } catch (err) {
      console.error(err);
    }
  };

  processTags = async (_tags: Array<any>) => {
    const loadedMattertags: Map<any, any> = this.tagManager.getMatterTags();
    const { allTags } = this.state;
    const models = await this.showCaseTemp.showcase.Scene.query(['model']);

    // eslint-disable-next-line array-callback-return
    const promises = _tags
      .filter((tag) => {
        // Don't render threads that are attached to the tag
        return !(tag.isThread && tag.tagId);
      })
      .map(async (tag) => {
        // dummy object for LOS checks
        const geometry = new this.THREE.SphereGeometry(0.1, 32, 16);
        const material = new this.THREE.MeshBasicMaterial({ color: 0xffff00 });
        const helperSphere = new this.THREE.Mesh(geometry, material);
        helperSphere.position.set(
          tag.positionX + tag.stemVectorX,
          tag.positionY + tag.stemVectorY,
          tag.positionZ + tag.stemVectorZ,
        );
        helperSphere.visible = false;
        models?.[0]?.parent?.add?.(helperSphere);
        const editedTag = { ...tag, dummyObject: helperSphere };

        if (
          (editedTag.modifiedTag && loadedMattertags.has(tag.sid)) ||
          (tag?.media?.type === TagType.Popup && tag?.media?.src?.includes('yout'))
        ) {
          // modified mp tag
          await this.editMattertag(editedTag);
          allTags.set(editedTag.sid, editedTag);

          return;
        }
        if (!editedTag.modifiedTag && !loadedMattertags.has(tag.sid)) {
          // pure treedis tag
          const foundAddTag = Array.from(allTags, ([, value]: any) => value).find(
            (item: { id: number; added: boolean }) => item.id === tag.id && item.added,
          );
          if (!foundAddTag) {
            editedTag.defaultSid = editedTag.sid;
            allTags.delete(editedTag.sid);
            editedTag.sid = await this.addMattertag(editedTag);
            editedTag.added = true;
          }
        }

        allTags.set(editedTag.sid, editedTag);
      });

    await Promise.all(promises);
    return allTags;
  };

  initTags = async (_tags: Array<any>) => {
    try {
      if (!_tags.length) {
        this.setState({ loadingTags: false });
        return _tags;
      }
      const tagsSize = _tags.length;
      this.tagIcons = [];

      for (let i = 0; i < tagsSize; i += 1) {
        const tag = _tags[i];
        const iconId = this.getTagIconId(tag);

        if (iconId && !this.tagIcons.some((icon) => icon?.iconId === iconId)) {
          let tagIconUrl;
          if (tag.iconFile) {
            if (tag.iconFile.startsWith('http')) {
              tagIconUrl = `${tag.iconFile}`;
            } else {
              tagIconUrl = `${process.env.NEXT_PUBLIC_CDN}/tours/${tag.tourId}/tags/icons/${tag.iconFile}`;
            }
          } else if (tag.customIcon) {
            const baseUrl = `${process.env.NEXT_PUBLIC_API}/v1/public/icons/${tag.customIcon}`;

            if (iconId === 'thread') {
              tagIconUrl = tag.iconColor
                ? `${baseUrl}?hex=${encodeURIComponent(tag.iconColor)}&circle=${tag.whiteCircle}`
                : baseUrl;
            } else {
              tagIconUrl = tag.iconColor
                ? `${baseUrl}?hex=${encodeURIComponent(tag.iconColor)}&circle=${
                    tag.whiteCircle
                  }&size=64`
                : `${baseUrl}?size=64`;
            }
          }

          this.tagIcons.push({
            iconId,
            url: tagIconUrl,
          });
        }
      }

      const registerIconsPromises = this.tagIcons.map(this.registerIcon);
      await Promise.all(registerIconsPromises);
      const updatedTags = await this.processTags(_tags);

      // This is gonna block the thread:
      // const promises = _tags.map(processTags);
      // const mappedTags = await Promise.all(promises);
      return updatedTags;
    } catch (err) {
      console.error(err);
    }
  };

  addThreadToSpace = async (thread) => {
    const updatedTags = new Map(this.state.allTags);
    thread.defaultSid = thread.sid;
    updatedTags.delete(thread.sid);
    thread.sid = await this.addMattertag(thread);

    thread.isThread = true;
    thread.messages = [thread.message];

    updatedTags.set(thread.sid, thread);

    this.setState({ allTags: updatedTags });

    return thread;
  };

  removeThreadFromSpace = async (thread) => {
    const { allTags } = this.state;

    const foundThreadKey = Array.from(allTags.entries()).find(
      ([, value]) =>
        value.defaultSid === thread.defaultSid ||
        value.sid === thread.defaultSid ||
        value.defaultSid === thread.sid,
    )?.[0];

    if (foundThreadKey) {
      await this.showcase.Tag.remove(foundThreadKey);

      this.setState((prevState) => {
        const updatedTags = new Map(prevState.allTags);
        updatedTags.delete(foundThreadKey);
        return { allTags: updatedTags };
      });
    }
  };

  toggleVisibleTags = (tags: any, isVisible: boolean) => {
    tags.forEach(async (_tag: any) => {
      const { sid, isThread } = _tag;
      if (!sid) return;
      // We shouldn't re-toggle tags that are already visible, waste of sources.
      if (isVisible && this.visibleTags[sid]) return;
      if (isVisible) this.visibleTags[sid] = true;
      else this.visibleTags[sid] = false;

      if (!isVisible && this.hiddenTags[sid]) return;
      if (!isVisible) this.hiddenTags[sid] = true;
      else this.hiddenTags[sid] = false;

      if (_tag.type === TagType.Music && !isVisible) {
        await audioHandler.pauseAudio(_tag.id);
      }

      !isThread
        ? await this.showcase.Tag.editOpacity(sid, isVisible ? _tag.opacity / 100 : 0).catch((e) =>
            console.error(e),
          )
        : await this.showcase.Tag.editOpacity(sid, isVisible ? 1 : 0).catch((e) =>
            console.error(e),
          );

      await this.showcase.Tag.editPosition(sid, {
        anchorPosition: {
          x: _tag.positionX,
          y: _tag.positionY,
          z: _tag.positionZ,
        },
        stemVector: {
          x: isVisible ? _tag.stemVectorX || 0 : 0,
          y: isVisible ? (_tag.stemVectorY == null ? 0.3 : _tag.stemVectorY) : 0,
          z: isVisible ? _tag.stemVectorZ || 0 : 0,
        },
        floorIndex: _tag.floor,
      }).catch((e) => {
        console.error(`Error edit position with sid: ${sid}`);
        console.error(e);
      });

      await this.setTagAllowAction(_tag);
    });
  };

  getSweepGroupPolygonIdsToHide = () => {
    const { activeSweepGroup, sweepGroups, polygons } = this.state;
    if (!activeSweepGroup) return [];
    const activeSweepGroupObj = sweepGroups.filter((item) => item?.id === activeSweepGroup)[0];
    const activeSweepGroupVsElements = activeSweepGroupObj?.vsElements || [];
    const { hidePolygons } = activeSweepGroupObj;

    const polygonIds = activeSweepGroupVsElements.reduce((acc, item) => {
      if (item?.type === 'vsPolygon') {
        acc.push(item?.elementId);
      }
      return acc;
    }, []);

    if (!polygonIds.length && !hidePolygons) {
      return [];
    }
    return (polygons || []).reduce((acc, item) => {
      if (hidePolygons || (!polygonIds.includes(item.id) && polygonIds.length)) {
        acc.push(item.id);
      }
      return acc;
    }, []);
  };

  filterPolygon = () => {
    const { tourType, polygons, isVSVisible } = this.state;
    if (TourType.Game === tourType) return;

    const sweepGroupElementIdsToHide = this.getSweepGroupPolygonIdsToHide();

    polygons.forEach((polygon: Polygon) => {
      const isVisible =
        !sweepGroupElementIdsToHide.includes(polygon.id) &&
        !polygon.isHiddenAfterClick &&
        isVSVisible;
      polygon.active = isVisible;
    });
    this.setState({ polygons }, async () => {
      await this.renderPolygons();
    });
  };

  filterTags = () => {
    const { activeSweepGroup, sweepGroups, allTags, tourType, loadingTags } = this.state;
    if (TourType.Game === tourType) return; // we skip filtering if it's game
    if (loadingTags || !sweepGroups.length) return;
    const activeGroup = Array.isArray(sweepGroups)
      ? sweepGroups.find((sg: any) => sg.id === activeSweepGroup)
      : false;
    const tagsToRemove: any = [];
    const tagsToInit: any = [];
    if (allTags && allTags.size) {
      allTags.forEach((tag: any) => {
        if (!activeGroup || activeGroup.showAllTags) {
          tagsToInit.push(tag);
        } else if (activeGroup.tags?.length === 0 && !tag.isThread) {
          tagsToRemove.push(tag);
        } else {
          const found = activeGroup?.tags?.find(
            (item) => item.tagSid === tag.sid || item.tagSid === tag.defaultSid,
          );
          if (found) {
            tagsToInit.push(tag);
          } else if (!tag.isThread) {
            tagsToRemove.push(tag);
          }
        }
      });
    }
    this.toggleVisibleTags(tagsToRemove, false);
    this.toggleVisibleTags(tagsToInit, true);
  };

  handleToggleMusic = async () => {
    try {
      const { tour, tourAudioPlaying, currentFloor } = this.state;
      const { playAudio, pauseAllMusic, isTourMusicPaused, stopTourMusic } = audioHandler;
      if (!this.isTourReadyForAudio()) {
        return;
      }

      pauseAllMusic();

      if (this.state.vsAudio) {
        this.muteVSVideo(this.state.vsAudio.component);
        this.setState({ vsAudio: null });
      }

      if (!tourAudioPlaying) {
        if (tour.musics?.length > 0 && !tour.sameMusicForAllFloors) {
          const music = tour.musics.find((item) => item.floor === currentFloor);
          if (!music || !music.isActive) {
            await playAudio({ type: MusicObj.TOUR, id: this.state.tour.id }).then(() => {
              this.setState({ tourAudioPlaying: !isTourMusicPaused() });
            });
            return;
          }
          if (music && !tour.sameMusicForAllFloors && music.isActive) {
            await playAudio({ type: MusicObj.FLOORS, id: music.id }).then(() => {
              this.setState({ tourAudioPlaying: !isTourMusicPaused() });
            });
          }
          return;
        }
        await playAudio({ type: MusicObj.TOUR, id: this.state.tour.id }).then(() => {
          this.setState({ tourAudioPlaying: !isTourMusicPaused() });
        });
      } else {
        await stopTourMusic();
      }
    } catch (e) {}
  };

  changeFloor = async (floorIndex: number, all = false) => {
    try {
      this.setState({ panoramaOn: false });
      await this.showCaseTemp.floor.changeFloor(floorIndex, this.state.tourPlaying, all);
    } catch (err) {
      console.error(err);
    }
  };

  playTour = async () => {
    try {
      this.setState({ panoramaOn: false });
      await this.showCaseTemp.tour.playTour(this.state.tourPlaying, this.state.reelStep);
    } catch (err) {
      console.error(err);
    }
  };

  changeViewMode = async (mode: TourMode) => {
    try {
      this.setState({ panoramaOn: false });
      await this.showCaseTemp.tour.changeViewMode(mode, this.state.tourPlaying);
    } catch (err) {
      console.error(err);
    }
  };

  trySwitchLoadIndicatorMode = (delays, index = 0) => {
    setTimeout(() => {
      const loaderByMeasurementsOffElement =
        this.iframe?.contentWindow?.document.querySelector('.load-indicator');
      if (loaderByMeasurementsOffElement?.classList?.contains?.('fade-in')) {
        loaderByMeasurementsOffElement.classList.remove('fade-in');
        loaderByMeasurementsOffElement.classList.add('fade-out');
      }
      if (index < delays.length - 1) {
        this.trySwitchLoadIndicatorMode(delays, index + 1);
      }
    }, delays[index]);
  };

  measurementsMode = async () => {
    try {
      const modeOn = !this.state.measurementsOn;
      await this.showcase.Measurements.toggleMode(modeOn);
      if (!modeOn) {
        // Manually switch mode from .fade-in to .fade-out for .load-indicator in showcase
        this.trySwitchLoadIndicatorMode([0, 300, 500]);
      }
    } catch (err) {
      console.error('Failed to change mode.');
    }
  };

  takePosition = (event: any) => {
    // ctrl+y
    if (event.ctrlKey && event.keyCode === 89) {
      const {
        tour: { slug, matterId },
      } = this.state;

      takePositionData({
        slug,
        matterId,
        sweep: this.pose.sweep,
        rotation: this.pose.rotation,
      });
    }
  };

  closeTagPop = async () => {
    const { showcaseLoaded, host, room, isRemoteControlled } = this.state;
    if (showcaseLoaded && room && socket && socket.connected && (host || isRemoteControlled)) {
      socket.emit('close-tag');
    }
    if (
      this.state.openedTag?.type === TagType.Music ||
      this.state.openedTag?.type === TagType.Popup
    ) {
      await audioHandler.resumeMusic();
    }
    this.setState({ tagPopOn: false, openedTag: null, closedElementPopup: true });
  };

  closeConditionPopUp = () => {
    this.setState({
      conditionPopUp: null,
    });
  };

  closeGameLockPop = (isCorrect: boolean) => {};

  changeTagIconAndColor = async (tag, icon, color) => {
    const iconId = `${icon}__${Math.random()}`;
    const iconUrl = `${
      process.env.NEXT_PUBLIC_API
    }/v1/public/icons/${icon}?hex=${encodeURIComponent(color)}`;

    await this.registerIcon({ iconId, url: iconUrl }).catch((e) => {
      console.error(e);
    });
    await this.showcase.Tag.editIcon(tag.sid, iconId).catch((e) => {
      console.error(e);
    });
  };

  closePanoPop = () => {
    const { showcaseLoaded, host, room, isRemoteControlled } = this.state;
    if (showcaseLoaded && room && socket && socket.connected && (host || isRemoteControlled)) {
      socket.emit('close-pano-pop');
    }
    this.setState({ panoPopOn: false, openedPanoHotspot: null });
  };

  closeActionPop = async () => {
    const { showcaseLoaded, room, host, openedVSAction, vsActionPopOn, isRemoteControlled } =
      this.state;
    const vsActionIframeInterupt =
      openedVSAction.type === TourActionType.Iframe && !openedVSAction?.dontInterruptBgAudio;
    const vsActionMedia = [TourActionType.Music, TourActionType.Video].includes(
      openedVSAction.type,
    );

    if (
      showcaseLoaded &&
      room &&
      socket &&
      socket.connected &&
      (host || isRemoteControlled) &&
      vsActionPopOn
    ) {
      socket.emit('close-polygon');
    }
    if (this.state.tourType === TourType.Game) {
      if (vsActionPopOn && (vsActionMedia || vsActionIframeInterupt)) {
        await audioHandler.resumeMusic();
      }
    }
    this.setState({ vsActionPopOn: false, closedElementPopup: true });
  };

  closePathFinderPop = () => {
    this.setState({ showPathFinderPopup: false });
  };

  showcaseLoad = () => {
    this.cleanupIframeResources();
    const search = this.getValueOnWindowLocationObject('search');
    const iframeContentWindowUrlParams = new URLSearchParams(search);
    const iframeSrcUrl = new URL(`https://my.treedis.com${this.state.iframeUrl}`);
    const iframeSrcUrlParams = new URLSearchParams(iframeSrcUrl?.search);
    const m = iframeContentWindowUrlParams.get('m');
    if (m && m !== iframeSrcUrlParams.get('m')) {
      this.setState({ iframeUrl: this.state.iframeUrl.replace(/(m=).*?(&)/, `$1${m}$2`) });
      return;
    }
    this.unsubsribeShowcaseAppSubscriber();

    this.loadTourEntities();

    this.showcaseLoader(this.state.tour?.user?.mpSDK);
  };

  moveModel = async (url: string, keepRotation = false, instant = false) => {
    try {
      const { THREE } = this;
      const { id, iframeId, linkData, rand, linkDataShort } = getUrlVariables(
        url,
        this.state.iframeUrl,
      );
      if (linkData) {
        const q = linkData.camera_quaternion;
        const quaternion = new THREE.Quaternion(q.x, q.y, q.z, q.w);
        const euler = new THREE.Euler().setFromQuaternion(quaternion, 'YXZ');
        let rotation = new THREE.Vector3(euler.x, euler.y, euler.z).multiplyScalar(180 / Math.PI); // @ts-ignore

        if (keepRotation || linkData.showcase_sweep) {
          rotation = this.pose.rotation;
        }
        // eslint-disable-next-line eqeqeq
        if (id && iframeId && id?.toLowerCase() != iframeId?.toLowerCase()) {
          this.startShowcaseLoad();

          this.setState(
            {
              iframeUrl: `${url}&qs=${instant ? '1' : '0'}&play=1&newtags=1&refreshid=${rand}`,
              panoramaOn: false,
            },
            () => {
              if (this.state.room && this.state.host) {
                socket.emit('tour_load', { id, mp: true });
              }
            },
          );
        } else {
          await this.moveToSweep(linkData.scan_id, rotation, instant ? 'INSTANT' : 'FLY');
        }
      } else if (linkDataShort) {
        const xr = parseFloat(linkDataShort.sr[0] || '0');
        const yr = parseFloat(linkDataShort.sr[1] || '0');
        const zr = parseFloat(linkDataShort.sr[2] || '0');
        // eslint-disable-next-line no-nested-ternary
        const mode =
          linkDataShort.sm === 2
            ? this.showCaseTemp.showcase.Mode.Mode.DOLLHOUSE
            : linkDataShort.sm === 3
            ? this.showCaseTemp.showcase.Mode.Mode.FLOORPLAN
            : null;
        let position = null;
        if (linkDataShort.sp) {
          position = {
            x: parseFloat(linkDataShort.sp[0] || '0'),
            y: parseFloat(linkDataShort.sp[1] || '0'),
            z: parseFloat(linkDataShort.sp[2] || '0'),
          };
        }

        const euler = new THREE.Euler().set(xr, yr, zr, 'XYZ').reorder('YXZ');
        let rotation = new THREE.Vector3(euler.x, euler.y, euler.z).multiplyScalar(180 / Math.PI); // @ts-ignore

        rotation.z = 0;

        if (keepRotation) rotation = this.pose.rotation;

        // load another tour, not the same tour
        // eslint-disable-next-line eqeqeq
        if (id && iframeId && id.toLowerCase() != iframeId.toLowerCase()) {
          this.startShowcaseLoad();

          this.setState(
            {
              iframeUrl: `${url}&qs=${instant ? '1' : '0'}&newtags=1&play=1&refreshid=${rand}`,
              panoramaOn: false,
              activePano: null,
            },
            () => {
              if (this.state.room && this.state.host) {
                socket.emit('tour_load', { id, mp: true });
              }
            },
          );
        } else if (linkDataShort.ss) {
          const scan = this.state.sweeps?.find((sweep) => {
            return sweep.index === linkDataShort.ss - 1;
          });
          if (!scan) {
            console.error('Scan not found', linkDataShort.ss, this.state.sweeps);
            return;
          }

          await this.moveToSweep(scan.id, rotation, instant ? 'INSTANT' : 'FLY');
        } else if (linkDataShort.sm && position) {
          // move to dollhouse
          await this.showCaseTemp.showcase.Mode.moveTo(mode, {
            position,
            rotation,
            transition: instant
              ? this.showCaseTemp.showcase.Mode.TransitionType.INSTANT
              : this.showCaseTemp.showcase.Mode.TransitionType.FLY,
            ...(linkDataShort.sz && { zoom: linkDataShort.sz }),
          });
        }
        // eslint-disable-next-line eqeqeq
      } else if (id && iframeId && id.toLowerCase() != iframeId.toLowerCase()) {
        this.startShowcaseLoad();
        // for no link data, just simple links

        this.setState(
          {
            iframeUrl: `${url}&qs=1&newtags=1&play=1&refreshid=${rand}`,
            panoramaOn: false,
            activePano: null,
          },
          () => {
            if (this.state.room && this.state.host) {
              socket.emit('tour_load', { id, mp: true });
            }
          },
        );
      }

      this.setState({
        overlayOn: false,
        markerPopupOn: false,
        panoramaOn: false,
        isTagHovered: false,
        lastTagHovered: null,
        selectedTag: null,
      });
    } catch (err) {
      console.error(err);
    }
  };

  handleClickDescriptionLink = async (url) => {
    if (url.includes('/tour/')) {
      const s = getQueryVariable(url, 's');
      const x = getQueryVariable(url, 'x');
      const y = getQueryVariable(url, 'y');
      this.moveToSweep(String(s), { x: parseFloat(String(x)), y: parseFloat(String(y)) }).catch(
        (err) => console.error(err),
      );
    } else if (url.includes('/my.matterport.com/')) {
      this.moveModel(url, false, true).catch((err) => console.error(err));
    } else {
      window.open(url, '_blank');
    }
  };

  markerClick = (hotspot: any) => {
    this.setState({ minimapOn: false }, () => {
      if (hotspot.type === 'panorama') {
        const { minimaps, selectedMinimap } = this.state;
        minimaps[selectedMinimap].hotspots.map((h: any) => {
          hotspot.active = h.id === hotspot.id;
          return hotspot;
        });

        this.setState({
          panoramaOn: true,
          minimaps,
          activePano: hotspot.panoramaId,
          mapWalkerX: hotspot.x,
          mapWalkerY: hotspot.y,
        });
        return;
      }
      if (!hotspot.external) {
        this.setState({ overlayOn: false });
        if (hotspot.url) {
          const { whiteLabelData } = this.state;
          const { url } = hotspot;

          const type = [
            'my.treedis.com',
            'test.treedis.com',
            whiteLabelData?.domainUrl,
            'localhost:',
          ].find((item) => url.includes(item))
            ? MenuType.Treedis
            : MenuType.Matterport;
          this.loadModel({ name: null, url, type });
        } else {
          const start = encodeURIComponent(
            JSON.stringify({
              camera_mode: 1,
              scan_id: hotspot.scanId,
              showcase_sweep: hotspot.showcaseSweep,
              camera_position: {
                x: hotspot.positionX,
                y: hotspot.positionY,
                z: hotspot.positionZ,
              },
              camera_quaternion: {
                x: hotspot.rotationX,
                y: hotspot.rotationY,
                z: hotspot.rotationZ,
                w: hotspot.rotationW,
              },
            }),
          );

          this.moveModel(
            `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase.html?applicationKey=${this.state.tour?.user?.mpSDK}&m=${this.state.tour.matterId}&start=${start}`,
          );
        }
      } else {
        this.setState({
          selectedMarker: { url: hotspot.url, external: hotspot.external },
          markerPopupOn: true,
          overlayOn: true,
        });
      }
    });
  };

  releaseLock = () => {
    this.setState({ lock: false });
  };

  toggleAppointmentsModal = () => {
    this.setState({
      appointmentsModal: !this.state.appointmentsModal,
      appointmentsHintOn: false,
    });
    this.toggleExternalPopup();
  };

  handleCustomButton = () => {
    const { tour, externalPopupOn } = this.state;
    if (tour.customButtonOpenAs === CustomButtonTypeOpenAsType.Tab) {
      this.openNewTab(tour.customButtonUrl);
      return;
    }
    if (externalPopupOn) return;
    this.setState({
      externalPopupUrl: tour.customButtonUrl,
      externalPopupOn: true,
    });
  };

  toggleNav = () => {
    const {
      menuOpen,
      tour: { menuEnabled, menuAlwaysOpenMobile, menuAlwaysOpenDesktop },
      tourType,
    } = this.state;
    const menuOpenForDevice =
      tourType === TourType.Regular &&
      !!(DeviceManager.isMobile()
        ? menuEnabled && menuAlwaysOpenMobile
        : menuEnabled && menuAlwaysOpenDesktop);
    this.setState({
      menuOpen: menuOpenForDevice || !menuOpen,
      menuOpened: true,
      activeMenu: null,
      MenuHintOn: false,
    });
  };

  setBaseState = (obj: any) => {
    this.setState(obj);
  };

  disableContext = (e: any) => {
    e.preventDefault();
  };

  processTourMusic = async (initPlay = false) => {
    const { currentFloor, tour } = this.state;
    let music = tour.musics.find((item) => item.floor === currentFloor);
    if (!initPlay && audioHandler.isTourMusicPaused() && !music?.autoplay) {
      return;
    }
    if (music && !tour.sameMusicForAllFloors && music?.isActive) {
      if (music.autoplay) {
        await this.setState({ tourAudioPlaying: !!music.autoplay });
        await audioHandler.playAudio({ type: MusicObj.FLOORS, id: music.id });
      }
      return;
    }
    if ((!music || tour.sameMusicForAllFloors) && tour.music) {
      music = {
        autoplay: tour.autoplayMusic,
      };
    }

    // This wrongly sets interacted to true, commented out for now
    // this.setState({ interacted: true });
    if (music) {
      if (!tour.music) {
        audioHandler.pauseAllMusic();
      } else {
        await audioHandler.stopAudioByType(MusicObjectKey.FLOORS);
      }
      if (
        music.autoplay &&
        !(tour.noAudioMode && this.state.room) &&
        // in case of Intro Screen is enables, the music
        // should play after user clicks on play button
        !this.state.startScreenOn
      ) {
        if (this.props.renderer?.xr?.enabled && this.props.renderer?.xr?.isPresenting) {
          await this.playTourAudio().catch(() => {});
        } else if (DeviceManager.supportsTouch()) {
          // we force touch to play music
          this.setState({ interacted: false });
          document.addEventListener(
            'touchstart',
            async () => {
              this.setState({ interacted: true });
              await this.playTourAudio().catch(() => {});
            },
            { once: true },
          );
        } else if (!this.state.interacted || DeviceManager.isMobile()) {
          this.setState({ interacted: false });
          document.addEventListener(
            'click',
            async () => {
              this.setState({ interacted: true });
              await this.playTourAudio().catch(() => {});
            },
            { once: true },
          );
        } else {
          await this.playTourAudio().catch(() => {});
        }
      }
    }
  };

  loadData = async (
    tourData: any,
    changeMenu = true,
    changeMinimap = true,
    changePanorama = true,
    url: any = null,
    changeReel = false,
  ) => {
    //  cancel any previous initStarting ( for case when we are loading another tour before previous one is fully loaded)
    this.setState({ startingInitialized: false });
    const tour = new Tour(tourData);
    const stateTour = this.state.tour;

    const { tourType } = this.state;

    let matterStartLocation = '';
    const { importAudioData } = audioHandler;

    if (url) {
      const s = getQueryVariable(url, 's');
      const x = getQueryVariable(url, 'x');
      const y = getQueryVariable(url, 'y');
      const target = getQueryVariable(url, 'target');

      if (s && x && y) {
        const ss = await getSweepIndex(tour.matterId, tour.slug, s);
        const sr = `${Number(x) * (Math.PI / 180)},${Number(y) * (Math.PI / 180)}`;

        if (sr && ss >= 0) {
          matterStartLocation = `&ss=${ss}&sr=${sr}`;
        }

        // window.history.replaceState(null, '', this.buildLink(s, { x, y }));

        window.history.replaceState(null, '', this.buildLink(s, { x, y }, null, target));
        this.setState({ navigationStartPosition: { s, x, y } });
        if (target) {
          tour.navigationWebEnabled = true;
        }
      }
    } else if (tour.ss && tour.sr) {
      matterStartLocation = `&ss=${tour.ss}&sr=${tour.sr}`;
    }
    if (!changeMenu && stateTour) {
      tour.reel = stateTour.reel;
      tour.menuEnabled = stateTour.menuEnabled;
      tour.menuAlwaysOpenMobile = stateTour.menuAlwaysOpenMobile;
      tour.menuAlwaysOpenDesktop = stateTour.menuAlwaysOpenDesktop;
    }
    if (!changePanorama && stateTour) tour.panorama = stateTour.panorama;

    if (!changeMinimap && stateTour?.customMinimap) {
      tour.customMinimap = stateTour.customMinimap;
      tour.minimap = true;
    }
    tour.reel = tourData.reel;
    const m = getQueryVariable(window.location.href, 'm');
    let matterId = m || tour.matterId;

    if (this.state.room) {
      if (this.state.host) {
        socket.emit('tour_load', { id: matterId, mp: false });
      } else if (matterId !== tour.matterId) {
        // if host uses a Tour Link, matterId should be updated with id of next tour
        matterId = tour.matterId;
      }
    }

    let addons = tour.getAddonsUrl();
    if (tour.introScreen) {
      addons = addons.replace(/qs=0/g, 'qs=1');
    }
    if (tour.navigationWebEnabled) {
      addons = addons.replace(/dh=1/g, 'dh=0');
    }
    const menuOpenForDevice =
      tourType === TourType.Regular &&
      !!(DeviceManager.isMobile()
        ? tour.menuEnabled && tour.menuAlwaysOpenMobile
        : tour.menuEnabled && tour.menuAlwaysOpenDesktop);
    const initialDuplicates = tourData?.initialDuplicates
      ? tourData.initialDuplicates
      : await PublicAPI.getDuplicates(tour.parentId || tour.id)?.duplicates;
    const menuOpen = changeMenu
      ? this.state.room && !this.state.host
        ? false
        : (tour.menuEnabled && tour.menuOnStart) || menuOpenForDevice || false
      : this.state.menuOpen;
    const china = all.getQueryVariable(window.location.href, 'china');

    // disable some features for web navigation test
    if (tour.navigationWebEnabled) {
      tour.menuEnabled = false;
      tour.reel = false;
      tour.mpReel = false;
      tour.panorama = false;
      tour.minimap = false;
    }

    return new Promise((resolve) => {
      return this.setState(
        {
          initialDuplicates,
          menuOpen,
          changeMenu,
          tour,
          isVSEnabled: tour.enableVS,
          allowGuestBeforeHost: tour.allowGuestBeforeHost,
          minimapVisible: tour.minimapVisible && !this.state.room && window.innerWidth > 768,
          iframeUrl: `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase${
            china ? '-china' : ''
          }.html?applicationKey=${tour?.user?.mpSDK}&m=${matterId}${addons}${matterStartLocation}`,
          appointmentsHintOn: tour.appointmentTooltipOn,
          MenuHintOn: tour.menuTooltipOn,
          changeReel,
        },
        async () => {
          // We need to fetch game settings for all tours (IntroClip, for example is used for all tours)
          // So don't check here if url includes /experience/
          if (tour.gameId) {
            await fetchData('public/getGame', 'POST', {
              id: tour.gameId,
            })
              .then((data) => {
                const game = new Game(data?.game);
                this.gameAnalytic = new GameAnalyticService(game.id, tour.slug);
                const showIntro = game?.introClip && (game?.introClipUrl || game?.uploadedIntroUrl);
                // showIntro is for IntroClip
                // startScreenOn is for IntroScreen
                this.setState({
                  gameLoaded: true,
                  showIntro:
                    showIntro && !(tour.introScreen || tour.password) && !this.isGameTour(),
                  startScreenOn: this.isGameTour() || !!tour.introScreen || !!tour.password,
                  game,
                  showBook: game?.gameBookOn && game?.book?.openByDefault,
                });

                if (!showIntro && !tour.password) {
                  this.showcaseLoad();
                }
              })
              .catch((err) => {
                if (err?.response?.data?.message?.includes('trial'))
                  this.setState({ gameTrialErr: err?.response?.data?.message });
                console.error(err.message);
              });
          } else {
            await this.startShowcaseLoad();
            this.setState({
              game: null,
              startScreenOn: !!tour.introScreen || !!tour.password,
            });
          }

          if (tour.disableContext) {
            document.addEventListener('contextmenu', this.disableContext);
          }

          fetchData(`public/getAgentsContactForm/${tour.id}`, 'GET')
            .then((data) => {
              const agents = data.agents.map((a: any) => new Agent(a.agent));
              if (agents && agents.length) this.setState({ agents });
            })
            .catch((err) => {
              console.error(err.message);
            });

          if (tour.minimap && changeMinimap) {
            fetchData('public/getMinimaps', 'POST', {
              id: tour.id,
            })
              .then((data) => {
                const { minimaps } = data;
                this.setState({ minimaps, selectedMinimap: 0 });
              })
              .catch((err) => {
                console.error(err.message);
              });
          }

          if (tour.panorama) {
            fetchData('public/getPanoramas', 'POST', {
              id: tour.id,
            })
              .then((data) => {
                const { panoramas } = data;
                const pano = getQueryVariable(window.location.href, 'pano');
                const pitch =
                  parseInt(String(getQueryVariable(window.location.href, 'panoPitch'))) || 0;
                const yaw =
                  parseInt(String(getQueryVariable(window.location.href, 'panoYaw'))) || 0;
                const hfov =
                  parseInt(String(getQueryVariable(window.location.href, 'panoHfov'))) || 0;

                // accumulate panoramas by user transitions through tours
                this.setState((prevState) => {
                  let defaultPanoForTour = (panoramas || []).find((pano) => pano.default);
                  if (!defaultPanoForTour) {
                    defaultPanoForTour = (prevState.panoramas || []).find((pano) => pano.default);
                  }
                  const newPanoramas = (panoramas || []).reduce((acc, value) => {
                    if (acc.find(({ id }) => id === value.id) === undefined) {
                      acc.push(value);
                    }
                    return acc;
                  }, prevState.panoramas || []);
                  newPanoramas.forEach((pano) => {
                    pano.default = pano.id === defaultPanoForTour?.id;
                  });
                  return {
                    panoramas: newPanoramas,
                    activePano:
                      (pano && parseInt(String(pano))) ||
                      defaultPanoForTour?.id ||
                      newPanoramas[0]?.id,
                    panoPose: { pitch, yaw, hfov },
                    ...(changePanorama
                      ? {
                          panoramaOn: !this.isGameTour()
                            ? tour.panoramaStart || Boolean(pano)
                            : false,
                        }
                      : {}),
                  };
                });
                (panoramas || []).forEach((panorama) => {
                  const data = (panorama?.hotspots || [])
                    .map((hotspot) => ({
                      ...hotspot,
                      tourId: panorama.tourId,
                      panoramaUrl: panorama.url,
                    }))
                    .filter((hotspot) => hotspot.type === 'panorama' || hotspot.type === 'music');
                  importAudioData(MusicObjectKey.PANORAMAS, data);
                });
              })
              .catch((err) => {
                console.error(err.message);
              });
          }

          // Fetch layers data for the tour
          fetchData(`public/getLayers/${tour.id}`, 'GET')
            .then((data) => {
              const { layers } = data;
              if (layers && layers.length > 0) {
                this.setState({
                  layers,
                  showLayers: true // Show layers overlay when tour starts
                });
              }
            })
            .catch((err) => {
              console.error('Error loading layers:', err.message);
            });

          // Sweeps page is locked for free users
          if (!this.isFreeUser) {
            PublicAPI.getGroups({ id: tour.id }).then((groupsData: any) => {
              if (groupsData?.groups?.length)
                this.setState({
                  sweepGroups: groupsData?.groups,
                });
              importAudioData(MusicObjectKey.SWEEPGROUPS, groupsData?.groups);
            });
          }

          return resolve(true);
        },
      );
    });
  };

  getProducts = async (tourId: number, userId: number) => {
    return [];
  };

  setTourBackground = async (models, threeInstance) => {
    const { tour } = this.state;
    let background = null;

    if (tour?.background && color.isHex(tour.background)) {
      background = new threeInstance.Color(tour.background);
    } else if (tour?.backgroundImage) {
      const url = `${process.env.NEXT_PUBLIC_CDN}/tours/${tour.id}/${tour.backgroundImage}`;
      const texture = await new threeInstance.TextureLoader().load(url);
      texture.wrapS = threeInstance.RepeatWrapping;
      texture.wrapT = threeInstance.RepeatWrapping;
      texture.repeat.set(1, 1);
      background = texture;
    }

    if (background) {
      models[0].parent.children[1].material = new threeInstance.ShadowMaterial();
      models[0].parent.background = background;
    }
  };

  initVRSettings = async () => {
    const models = await this.showCaseTemp.showcase.Scene.query(['model']);
    this.camera = models?.[0]?.parent?.children?.[0]?.camera;
    await this.showCaseTemp.scene.configureThreeInstance();
    this.THREE = await iTHREE();
    this.showCaseTemp.mpSDK.Scene.configure((renderer) => {
      this.renderer = renderer;
      this.rendererRef.current = renderer;
      this.renderer.domElement =
        this.iframe.contentWindow.document.getElementsByClassName('webgl-canvas')[0];
      this.renderer?.xr?.addEventListener('sessionstart', () => {
        asyncStore.vrIsOn = true;

        if (!this.SceneVRCameraController)
          this.SceneVRCameraController = new VRCameraController(
            this.THREE,
            this.renderer,
            this.camera,
            this.cameraPose,
          );

        if (this.matterTagMeshComponents.length)
          this.matterTagMeshComponents.forEach((tag) => {
            tag.inputs.visible = true;
          });
        if (this.renderer?.xr) {
          const controllers = [
            this.renderer.xr.getController(0),
            this.renderer.xr.getController(1),
          ];
          controllers.forEach((controller) => {
            controller.addEventListener('connected', (event) => {
              const inputSource = event.data;
              const { handedness } = inputSource;
              if (handedness === 'left') {
                this.gamepadLRef.current = event.data.gamepad;
              } else if (handedness === 'right') {
                this.gamepadRRef.current = event.data.gamepad;
              }
            });
          });
        }
      });
      this.renderer?.xr?.addEventListener('sessionend', () => {
        asyncStore.vrIsOn = false;
        if (this.matterTagMeshComponents.length)
          this.matterTagMeshComponents.forEach((tag) => {
            tag.inputs.visible = false;
          });
      });
    });
    this.setTourBackground(models, this.THREE);
  };

  getShowcaseElement = (element?: ShowcaseElement) => {
    switch (element) {
      case ShowcaseElement.TagPanel: {
        return this.iframe?.contentWindow?.document.body.getElementsByClassName('panels')[1];
      }
      case ShowcaseElement.TagPanelHeader: {
        return this.iframe?.contentWindow?.document.querySelector('.tag-view-panel-header');
      }
      case ShowcaseElement.LoaderPowerBy: {
        return this.iframe?.contentWindow?.document.getElementById('loading-powered-by');
      }
      case ShowcaseElement.LoaderPresentedBy: {
        return this.iframe?.contentWindow?.document.getElementById('loading-presented-by');
      }
      case ShowcaseElement.TagEmbedMedia: {
        return this.iframe?.contentWindow?.document.body.querySelector(
          '.annotations-preview-layer',
        );
      }
      case ShowcaseElement.ErrorContainer: {
        return this.iframe?.contentWindow?.document?.body?.querySelector('#error-container');
      }
      case ShowcaseElement.VRLayer: {
        return this.iframe?.contentWindow?.document?.getElementById('vr-overlay-layer');
      }
      case ShowcaseElement.AddMeasurement: {
        return this.iframe?.contentWindow?.document?.querySelector('.measurements-overlay .action-bar .add-button');
      }
      default:
        return this.iframe?.contentWindow?.document.body;
    }
  };

  hideLoadingScreenIfExists = () => {
    const { tour } = this.state;
    if (tour?.mpPasswordActive) {
      document?.getElementById('loading-screen')?.setAttribute('style', 'display: none');
      // Hiding Loading Spinner when there's a MP password screen because we have a loading screen
      document?.getElementById('loading-spinner')?.setAttribute('style', 'display: none');
    }
  };

  showcaseLoader = async (applicationKey?: string) => {
    try {
      const mpLoader = this.getShowcaseElement(ShowcaseElement.LoaderPowerBy);
      const mpPresenter = this.getShowcaseElement(ShowcaseElement.LoaderPresentedBy);

      if (mpLoader) mpLoader.style.display = 'none';
      if (mpPresenter) mpPresenter.style.display = 'none';

      // Fix for TB-1630
      const search = this.getValueOnWindowLocationObject('search');
      const urlParams = new URLSearchParams(search);
      const newModelSID = urlParams.get('m');
      if (newModelSID && newModelSID != getQueryVariable(this.state.iframeUrl, 'm')) {
        this.setState({
          iframeUrl: this.state.iframeUrl.replace(/(m=).*?(&)/, `$1${newModelSID}$2`),
        });
        console.log('iframeUrl', this.state.iframeUrl);
        return;
      }

      const { tour } = this.state;
      const config: any = {
        applicationKey:
          window.location.hostname === 'my.treedis.com'
            ? process.env.NEXT_PUBLIC_MP_SDK_KEY
            : applicationKey || process.env.NEXT_PUBLIC_MP_SDK_KEY,
        appDomain: process.env.NEXT_PUBLIC_API,
        version: process.env.NEXT_PUBLIC_MP_SDK_VERSION as string,
        logoUrl: this.state.whiteLabelData?.active ? this.state.whiteLabelData?.logo : defaultLogo,
        appAws: process.env.NEXT_PUBLIC_CDN,
        matterId: tour.matterId,
        rtl: tour.client?.rtl,
      };

      // If the tour has a MP pass, we first hide the loading screen/intro screen, and then show again later
      let introScreenDomEl = null;
      if (tour?.mpPasswordActive) {
        introScreenDomEl = document.querySelector('#intro-screen');
        introScreenDomEl?.setAttribute('style', 'display: none');
      }

      this.hideLoadingScreenIfExists();

      const auth = getQueryVariable(window.location.href, 'auth');
      if (tour.user?.oauth && tour.oauthAccess) {
        config.auth = tour.user.oauthToken;
      } else if (auth) {
        config.auth = auth;
      }
      const showcase = await GetSDK(this.iframe, config);

      // Showing again after MP password screen
      if (tour?.mpPasswordActive) {
        if (introScreenDomEl) {
          introScreenDomEl.setAttribute('style', 'display: none');
        } else {
          document?.getElementById('loading-screen')?.setAttribute('style', 'display: block');
        }
      }

      // to make the "copy position" work if focus is on the iframe
      this.iframe.contentWindow.document.addEventListener('keydown', this.takePosition);

      const observerMPPassword = setMPPasswordFormObserver(
        this.getShowcaseElement(),
        () => {
          this.iframe.style.zIndex = 999999;
        },
        async () => {
          this.setState({ waitLoadingPolygons: true });
          this.iframe.style.zIndex = 'inherit';
        },
      );

      this.showcase = showcase.showcase;
      this.showCaseTemp = showcase;
      this.tagManager = new TagManager(this.showcase);

      this.loadedShowcaseHandler();

      const onShowcasePhaseLoading = async () => {
        this.loadingQueue.setLoadingQueueProgress(50);
        observerMPPassword && observerMPPassword.disconnect();
      };

      let starting = false;
      const onShowcasePhaseStarting = async () => {
        starting = true;
        this.initStarting();
      };

      const onShowcasePhasePlaying = async () => {
        if (!starting) {
          // Some tours don't have starting mode
          await this.initStarting();
        }

        this.loadingQueue.setLoadingQueueProgress(90);

        if (tour.hideMPTagDock) {
          this.showcase.Tag.toggleDocking(false);
        }
        if (tour.hideMPTagSwitcher) {
          this.showcase.Tag.toggleNavControls(false);
        }

        await this.initPlaying();

        this.initScene();

        if (
          !DeviceManager.isMobile() &&
          (this.state.tour?.user?.enterprise ||
            this.state.tour?.user?.subscription ===
              (UserSubscription.Business || UserSubscription.Enterprise))
        ) {
          await this.initVRPointer();
          this.initPathFinderMesh();
        }

        const watchErrorElem = this.getShowcaseElement(ShowcaseElement.ErrorContainer);
        setErrorObserver(watchErrorElem, (pageCrashed, observer) => {
          this.setState({
            crashScreen: pageCrashed,
          });
          observer.disconnect();
        });

        const watchTagPanelElem = this.getShowcaseElement(ShowcaseElement.TagPanel);
        if (this.state.tour.mpTagDockSide === TagDockSideType?.Left) {
          watchTagPanelElem.style.transition = 'none';
        }

        setTagPanelObserver(watchTagPanelElem, (isTagPanelOpen, observer) => {
          if (
            !DeviceManager.isMobile() &&
            this.state.tour.mpTagDockSide === TagDockSideType?.Left
          ) {
            const hasStyle =
              this.iframe.contentWindow.document.head.querySelector('#override-matterport');
            if (isTagPanelOpen && !hasStyle) {
              const style = document.createElement('style');
              style.id = 'override-matterport';
              style.innerHTML = `
                .webgl-canvas {
                  left: 375px !important;
                }
                .panel-right {
                  position: absolute !important;
                }
              `;

              this.iframe.contentWindow.document.head.appendChild(style);

              this.setState({
                hideLogo: true,
              });
            } else if (hasStyle) {
              const style =
                this.iframe.contentWindow.document.head.querySelector('#override-matterport');

              style.innerHTML = `
                .webgl-canvas {
                  transition: left .5s !important;
                  left: 0 !important;
                }
                .panel-right {
                  position: absolute !important;
                }
              `;

              this.setState({
                hideLogo: false,
              });

              setTimeout(() => {
                style.remove();
              }, 500); // closing animation duration is .5s
            }
          }

          const bottomBar = document.getElementById('bottom-bar') as HTMLElement;
          const eBottomBar = document.getElementById('ecommerce-bottom-bar') as HTMLElement;
          const volumeBtn = document.getElementById('volume-button') as HTMLElement;
          if (bottomBar) {
            bottomBar.style.display = isTagPanelOpen ? 'none' : 'block';
          }
          if (eBottomBar) {
            eBottomBar.style.display = isTagPanelOpen ? 'none' : 'block';
          }
          if (volumeBtn) {
            volumeBtn.style.display = isTagPanelOpen ? 'none' : 'block';
          }
        });
      };

      this.showcaseAppSubscriber = this.showcase.App.state.subscribe((appState) => {
        switch (appState.phase) {
          case showcase.showcase.App.Phase.LOADING:
            onShowcasePhaseLoading();
            break;
          case showcase.showcase.App.Phase.STARTING:
            onShowcasePhaseStarting();
            break;
          case showcase.showcase.App.Phase.PLAYING:
            onShowcasePhasePlaying();
            break;
          case showcase.showcase.App.Phase.UNINITIALIZED:
          case showcase.showcase.App.Phase.WAITING:
          case showcase.showcase.App.Phase.ERROR:
            break;
          default:
            break;
        }
      });
    } catch (e) {
      console.error(e);
    }
  };

  unsubsribeShowcaseAppSubscriber = () => {
    this.showcaseAppSubscriber?.cancel?.();
  };

  unsubsribeShowcaseSubscribers = () => {
    this.showcaseSubscribers?.forEach((off) => off?.());
    this.showcaseSubscribers.length = 0;
  };

  filterSweepGroupVsElementsByTourVsElement = (vsElements, vsElement) => {
    if (vsElement instanceof TourImage) {
      const vsImageIds = vsElements
        .filter((item) => item.type === 'vsImage')
        .map(({ elementId }) => elementId);
      if (!vsImageIds.length) return true;
      return !!vsImageIds.includes(vsElement?.details?.id);
    }
    if (vsElement instanceof TourVideo) {
      const vsVideoIds = vsElements
        .filter((item) => item.type === 'vsVideo')
        .map(({ elementId }) => elementId);
      if (!vsVideoIds.length) return true;
      return !!vsVideoIds.includes(vsElement?.details?.id);
    }
    const vsObjectsIds = vsElements
      .filter((item) => item.type === 'vsObject')
      .map(({ elementId }) => elementId);
    if (!vsObjectsIds.length) return true;
    return !!vsObjectsIds.includes(vsElement?.details?.id);
  };

  isGameTour = (): boolean => {
    const { tourType, tour, flows } = this.state;
    return tourType === TourType.Game && !!tour?.gameId && !flows?.length;
  };

  isSweepGroupVsVisible = (vsElement, sweepGroupElementIdsToHide): boolean => {
    const { activeSweepGroup, sweepGroups } = this.state;
    if (sweepGroupElementIdsToHide.includes(vsElement?.details?.id)) return false;

    const response = (sweepGroups || []).find((item) => item.id === activeSweepGroup);
    return this.filterSweepGroupVsElementsByTourVsElement(response?.vsElements || [], vsElement);
  };

  hasSweepGroupElements = () => {
    const { sweepGroups } = this.state;
    const elementIds = sweepGroups
      .reduce((acc, { vsElements = [] }) => acc.concat(vsElements), [])
      .map((item) => item?.elementId);
    return elementIds.length > 0;
  };

  sortVsItemsByType = (vsItems) => {
    const images = [];
    const videos = [];
    const objects = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const item of vsItems) {
      if (item?.type === 'vsVideo') {
        videos.push(item?.elementId);
      }
      if (item?.type === 'vsImage') {
        images.push(item?.elementId);
      }
      if (item?.type === 'vsObject') {
        objects.push(item?.elementId);
      }
    }
    return [images, videos, objects];
  };

  getSweepGroupElementIdsToHide = () => {
    const { sweepGroups, activeSweepGroup } = this.state;
    if (!activeSweepGroup) return [];
    const activeSweepGroupObj = sweepGroups.filter((item) => item?.id === activeSweepGroup)[0];
    const activeSweepGroupVsElements = activeSweepGroupObj?.vsElements;
    const { hideVSImages, hideVSVideos, hideVSObjects } = activeSweepGroupObj;
    const [imageIds = [], videoIds = [], objectIds = []] = this.sortVsItemsByType(
      activeSweepGroupVsElements,
    );

    if (
      !imageIds.length &&
      !videoIds.length &&
      !objectIds.length &&
      !hideVSImages &&
      !hideVSVideos &&
      !hideVSObjects
    ) {
      return [];
    }
    return this.vsObjects
      .map((item) => {
        if (
          item instanceof TourVideo &&
          (hideVSVideos || (!videoIds.includes(item.vsVideoId) && videoIds.length))
        ) {
          return item.vsVideoId;
        }
        if (
          item instanceof TourImage &&
          (hideVSImages || (!imageIds.includes(item.vsImageId) && imageIds.length))
        ) {
          return item.vsImageId;
        }
        if (
          item instanceof TourObject &&
          (hideVSObjects || (!objectIds.includes(item.vsObjectId) && objectIds.length))
        ) {
          return item.vsObjectId;
        }
      })
      .filter((item) => !!item);
  };

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
    // Hide MP VR button after closing tag popup
    if (this.state.hideBottomBarForWhile !== prevState.hideBottomBarForWhile) {
      if (DeviceManager.isMobile() && !DeviceManager.isDesktop()) {
        setTimeout(() => {
          const vrOverlay: any = this.getShowcaseElement(ShowcaseElement.VRLayer);
          if (vrOverlay) {
            const iframeVrButton = vrOverlay.querySelector('[role="button"]');
            if (iframeVrButton) iframeVrButton.style.display = 'none';
          }
        }, 100);
      }
    }

    if (this.state.game?.backpackOn) {
      this.updateBackpackMesh();
    }

    if (
      (this.state.tour?.navigationWebEnabled || this.state.flowIsActive || this.state.tour?.menuEnabled) &&
      this.state.sweepsLoaded &&
      this.showCaseTemp &&
      !this.showCaseTemp.navigationManager?.initialized
    ) {
      this.initNavigationManager()
    }

    // reclaim path distance updates to navigation from flows
    if (!this.state.flowIsActive && prevState.flowIsActive) {
      this.initPathDistanceUpdates();
    }

    // Update teleport inputs when isTpUp changes
    if (this.state.isTpUp !== prevState.isTpUp) {
      this.updateTeleportInputs();
    }

    this.updatePathFinderMeshHtml();

    this.updateCssMenuWidth();
  }

  updatePathFinderMeshHtml() {
    const hasData = hasPathFinderData(this.state.pathfinderDataState);
    if (!this.pathFinderMeshComponent || !this.pathFinderMeshComponent.inputs.refs || !hasData)
      return;
    this.pathFinderMeshComponent.inputs.hasPathFinderData = hasData;
    if (!this.pathFinderMeshComponent.hostPose)
      this.pathFinderMeshComponent?.setHostPose(this.pose);

    updateStylesAndContent({
      pathFinderMeshComponent: this.pathFinderMeshComponent,
      pathfinderDataState: this.state.pathfinderDataState,
      game: this.state.game,
      prevPathFinderData: this.prevPathFinderData,
    });
  }

  async initVRTags(tags) {
    await this.showCaseTemp.showcase.Scene.register(
      matterTagMeshComponentType,
      makeMatterTagMeshComponent,
    );
    tags.forEach((tag) => {
      this.initTagMesh(tag);
    });
  }

  updateBackpackMesh() {
    const items = this.state.game?.locks.filter((lock) => lock.type === 'collectItems');
    if (items?.length) {
      this.backpack = { items };
      if (this.backpackMeshComponent) {
        const { itemElements } = this.backpackMeshComponent.inputs.refs;
        items.forEach((item) => {
          const itemElement = itemElements.find((el) => el.name === item.name);
          if (!itemElement) {
            console.error('Tour backpack and VR backpack items mismatch');
            return;
          }
          itemElement.ref.textContent = `${item.name} ${item.collected.length}/${
            item.solution.split('|').length
          }`;
        });
      }
    }
  }

  async initTagMesh(tagData) {
    try {
      const { tour } = this.state;
      let media = null;
      if (tagData.url)
        media =
          tagData.type === 'image'
            ? `${process.env.NEXT_PUBLIC_CDN}/tours/${tour?.id}/tags/${tagData.url}`
            : null;

      const dimensions = { width: media ? 400 : 360 };
      const { html, imageContainer } = createMatterTagHTML(tagData, media, dimensions);
      if (imageContainer) {
        imageContainer.src = media;
        await imageContainer.decode().catch((e) => {
          console.error(`An error occurred when decoding media of tag ${tagData.id}`, e);
        });
      }
      const modelNode: any = await this.showCaseTemp.mpSDK.Scene.createNode();
      const component = await modelNode.addComponent(matterTagMeshComponentType, {
        html,
        tagData,
        media,
        dimensions,
        scale: 0.08,
        visible: typeof asyncStore.vrIsOn === 'boolean' ? asyncStore.vrIsOn : false,
        popupScale: 10,
      });
      await modelNode.start();
      this.matterTagMeshComponents.push(component);
      component.onEvent = (type, eventData) => {
        if (type === ComponentInteractionType.CLICK) {
          if (eventData.collider?.name === 'tag') {
            if (this.openedVRTag && tagData.id !== this.openedVRTag) {
              const openedTag = this.matterTagMeshComponents.find(
                (tag) => tag.tagId === this.openedVRTag,
              );
              if (openedTag) openedTag.inputs.popupVisible = false;
            }
            component.inputs.popupVisible = !component.inputs.popupVisible;
          }
          if (eventData.collider?.name === 'closeBtn') component.inputs.popupVisible = false;
          this.openedVRTag = component.inputs.popupVisible ? tagData.id : null;
        }
        if (type === ComponentInteractionType.HOVER && this.VRPointer.component) {
          if (eventData.hover) {
            this.VRPointer.component.setVisible(true);
            this.VRPointer.target = component;
          } else this.VRPointer.component.setVisible(false);
        }
      };
    } catch (err) {
      console.error(err);
    }
  }

  async initVRPointer() {
    await this.showCaseTemp.showcase.Scene.register(VRPointerComponentType, makeVRPointerComponent);
    const modelNode: any = await this.showCaseTemp.mpSDK.Scene.createNode();
    const component = await modelNode.addComponent(VRPointerComponentType, {});
    component.hostPose = this.camera;
    await modelNode.start();
    this.VRPointer.component = component;

    this.showCaseTemp.mpSDK.Pointer.intersection.subscribe((intersectionData) => {
      if (component.root && this.VRPointer.target) {
        const { x, y, z } = intersectionData.position;
        component.root.position.set(x, y, z);
      }
    });
  }

  async initPathFinderMesh() {
    const { html, refs } = createPathFinderHTML();
    refs.buttonBack.addEventListener('click', () => {
      try {
        this.state.pathfinderDataState?.handlePreviousStep();
        this.pathFinderMeshComponent?.setVisible(false);
      } catch (error) {
        console.error();
        console.error('Starting sweep not found, error: ', error);
      }
    });

    refs.buttonNext.addEventListener('click', () => {
      try {
        this.state.pathfinderDataState?.handleNextStep();
        this.pathFinderMeshComponent?.setVisible(false);
      } catch (error) {
        console.error('Starting sweep not found, error: ', error);
      }
    });

    await this.showCaseTemp.showcase.Scene.register(
      pathFinderMeshComponentType,
      makePathFinderMeshComponent,
    );
    const modelNode: any = await this.showCaseTemp.mpSDK.Scene.createNode();
    const component = await modelNode.addComponent(pathFinderMeshComponentType, {
      html,
      visible: false,
      scale: 0.5,
      refs,
      hasPathFinderData: false,
    });
    await modelNode.start();
    this.pathFinderMeshComponent = component;
    this.pathFinderMeshComponent?.setHostPose(this.pose);
    component.onEvent = (type, eventData) => {
      if (type === ComponentInteractionType.HOVER && this.VRPointer.component) {
        if (eventData.hover) {
          this.VRPointer.component.setVisible(true);
          this.VRPointer.target = component;
        } else this.VRPointer.component.setVisible(false);
      }
    };
    this.updatePathFinderMeshHtml();
  }

  moveToMenuItem(menu: MenuObject) {
    const { moveToMPLabels, loadModel } = this;
    if (menu.type === MenuType.MatterportLabel || menu.type === MenuType.MatterportFloor) {
      moveToMPLabels(menu);
    } else {
      loadModel(menu);
    }
  }

  async initMenuMesh() {
    try {
      const { html, itemRefArr } = createMenuHTML(this.state.menus);

      itemRefArr.forEach((menu, index) => {
        menu.addEventListener('click', () => {
          this.moveToMenuItem(this.state.menus[index]);
          this.menuMeshComponent.setVisible(false);
        });
      });
      await this.showCaseTemp.showcase.Scene.register(menuMeshComponentType, makeMenuMeshComponent);
      const modelNode: any = await this.showCaseTemp.mpSDK.Scene.createNode();
      const component = await modelNode.addComponent(menuMeshComponentType, {
        html,
        visible: false,
        scale: 0.5,
        itemRefArr,
        controller: ControllerType.GamepadL,
        controllerButtonIndex: 1,
      });
      await modelNode.start();
      this.menuMeshComponent = component;
      component.onEvent = (type, eventData) => {
        if (type === ComponentInteractionType.HOVER && this.VRPointer.component) {
          if (eventData.hover) {
            this.VRPointer.component.setVisible(true);
            this.VRPointer.target = component;
          } else this.VRPointer.component.setVisible(false);
        }
      };
    } catch (e) {
      console.error(e);
    }
  }

  async initFlowsMenuMesh(flows) {
    const { html, itemRefArr } = createFlowsMenuHTML(flows);
    await this.showCaseTemp.showcase.Scene.register(menuMeshComponentType, makeMenuMeshComponent);
    const modelNode: any = await this.showCaseTemp.mpSDK.Scene.createNode();
    const component = await modelNode.addComponent(menuMeshComponentType, {
      html,
      visible: false,
      scale: 0.5,
      itemRefArr,
      controller: ControllerType.GamepadL,
      controllerButtonIndex: 1,
    });
    await modelNode.start();
    this.flowsMenuMeshComponent = component;
    component.onEvent = (type, eventData) => {
      if (type === ComponentInteractionType.HOVER && this.VRPointer.component) {
        if (eventData.hover) {
          this.VRPointer.component.setVisible(true);
          this.VRPointer.target = component;
        } else this.VRPointer.component.setVisible(false);
      }
    };
    component.gamepadButtonCallback = () => {
      this.setAllSweepsEnabled(!component.inputs.visible);
    };
    component.onVisibleChange = () => {
      if (this.flowsBarMeshComponent && component.inputs.visible)
        this.flowsBarMeshComponent.setVisible(false);
    };
  }

  async initFlowsBarMesh() {
    const { html, itemRefArr } = createFlowsBarHTML();
    await this.showCaseTemp.showcase.Scene.register(menuMeshComponentType, makeMenuMeshComponent);
    const modelNode: any = await this.showCaseTemp.mpSDK.Scene.createNode();
    const component = await modelNode.addComponent(menuMeshComponentType, {
      html,
      visible: false,
      scale: 0.5,
      itemRefArr,
      controller: ControllerType.GamepadR,
      controllerButtonIndex: 4,
    });
    await modelNode.start();
    this.flowsBarMeshComponent = component;
    component.onEvent = (type, eventData) => {
      if (type === ComponentInteractionType.HOVER && this.VRPointer.component) {
        if (eventData.hover) {
          this.VRPointer.component.setVisible(true);
          this.VRPointer.target = component;
        } else this.VRPointer.component.setVisible(false);
      }
    };
  }

  async initVREventManager() {
    await this.showCaseTemp.showcase.Scene.register(
      VREventManagerComponentType,
      makeVREventManagerComponent,
    );
    const modelNode: any = await this.showCaseTemp.mpSDK.Scene.createNode();
    const component = await modelNode.addComponent(VREventManagerComponentType, {});
    await modelNode.start();
    this.vrEventManager = component;

    this.vrEventManager.addEventListener(
      { type: 'thumbstickthreshholddown', button: 3, controller: ControllerType.GamepadL },
      (axis) => {
        if (!this.flowsMenuMeshComponent?.inputs.visible)
          this.showCaseTemp.showcase.Camera.moveInDirection(
            axis > 0.5
              ? this.showCaseTemp.showcase.Camera.Direction.BACK
              : this.showCaseTemp.showcase.Camera.Direction.FORWARD,
          );
      },
    );
  }

  async initBackpackMesh() {
    const items = this.state.game?.locks.filter((lock) => lock.type === 'collectItems');
    try {
      this.backpackMeshState = 'loading';
      const { html, refs } = createBackpackhtml(items);
      await this.showCaseTemp.showcase.Scene.register(
        backpackMeshComponentType,
        makeBackpackMeshComponent,
      );
      const modelNode: any = await this.showCaseTemp.mpSDK.Scene.createNode();
      const component = await modelNode.addComponent(backpackMeshComponentType, {
        html,
        visible: false,
        scale: 0.5,
        refs,
      });
      await modelNode.start();
      this.backpackMeshComponent = component;
      this.backpackMeshState = 'loaded';
    } catch (e) {
      console.error(e);
      this.backpackMeshState = 'error';
    }
  }

  // 0 - current item, 1 forward, -1 backward, 2 not found
  pathHasElement = (id: string, type: string) => {
    const { paths } = this.state?.game || {};
    const currentPathItem = asyncStore?.currentPathStep;
    if (!asyncStore?.regularActivePath && !paths) return;
    const activePathLock = paths[asyncStore?.regularActivePath];
    const searchingPathItem = activePathLock?.paths?.find(
      (e) => e.locationType === type && e.locationItem === id,
    );

    if (
      !currentPathItem ||
      (currentPathItem.locationItem === id && currentPathItem.locationType === type)
    ) {
      return [0, searchingPathItem];
    }

    const pathItemsArray = [];

    let nextItem = activePathLock?.paths.find(
      (e) => !e.triggerType || e.triggerType === -1 || e.triggerType === '-1',
    );
    let cyclesLeft = activePathLock?.paths?.length || 0;
    while (nextItem && !!cyclesLeft) {
      pathItemsArray.push(nextItem);
      nextItem = activePathLock?.paths.find(
        (e) => e.triggerType === nextItem?.locationType && e.triggerItem === nextItem?.locationItem,
      );
      cyclesLeft--;
    }

    const pathItemsArrayIds = pathItemsArray.map((e) => `${e.locationItem}${e.locationType}`);
    const currentItemIndex = pathItemsArrayIds.indexOf(
      `${currentPathItem.locationItem}${currentPathItem.locationType}`,
    );

    const itemsAfter = pathItemsArrayIds.splice(
      currentItemIndex + 1,
      pathItemsArrayIds.length - currentItemIndex,
    );
    const itemsBefore = pathItemsArrayIds.splice(0, currentItemIndex);

    if (itemsBefore.includes(`${id}${type}`)) {
      return [-1, searchingPathItem];
    }
    if (itemsAfter.includes(`${id}${type}`)) {
      return [1, searchingPathItem];
    }

    return [2, searchingPathItem];
  };

  vsObjectHiddenByPathLock = (vsObject: VSTourAsset) => {
    const { paths } = this.state?.game || {};
    if (!asyncStore?.regularActivePath && !paths) return;
    const activePathLock = paths[asyncStore?.regularActivePath];
    const sId = vsObject.id?.toString();
    const type =
      vsObject instanceof TourObject
        ? 'vsObject'
        : vsObject instanceof TourVideo
        ? 'vsVideo'
        : vsObject instanceof TourImage
        ? 'vsImage'
        : null;
    const [elementPosition, pathElement] = this.pathHasElement(sId, type);

    if (
      (activePathLock?.hideItems && elementPosition === 1) ||
      (pathElement?.hideStep && elementPosition === -1)
    ) {
      return true;
    }
    return false;
  };

  polygonHiddenByPathLock = (polygon: Polygon) => {
    const { paths } = this.state?.game || {};
    const pathItemsMap = {}; // id: {type, hideStep}
    if (!asyncStore?.regularActivePath && !paths) return;
    const activePathLock = paths[asyncStore?.regularActivePath];
    activePathLock?.paths?.forEach((l) => {
      pathItemsMap[l.locationItem] = { type: l.locationType, hideStep: l.hideStep };
    });
    const sId = polygon.id?.toString();
    if (
      pathItemsMap[sId] &&
      pathItemsMap[sId].type === 'polygon' &&
      (pathItemsMap[sId].hideStep === true || activePathLock?.hideItems)
    ) {
      return true;
    }
    return false;
  };

  addVisibleObjectToFlows = (vsObject: any) => {
    if (vsObject instanceof TourObject) {
      this.setState((prev) => ({
        flowsVisibleAssets: {
          ...prev.flowsVisibleAssets,
          objects: [...prev.flowsVisibleAssets.objects, vsObject],
        },
      }));
    }
    if (vsObject instanceof TourVideo) {
      this.setState((prev) => ({
        flowsVisibleAssets: {
          ...prev.flowsVisibleAssets,
          videos: [...prev.flowsVisibleAssets.videos, vsObject],
        },
      }));
    }
  };

  subscribeToStartTriggerVSAfterAnimation = async (vsObject: any) => {
    const { flows } = this.state;
    if (flows?.length) {
      this.addVisibleObjectToFlows(vsObject);
    }

    if (vsObject.node?.mixer) {
      const activateSubscriber = vsObject?.active && vsObject?.animated && !vsObject?.loop;
      if (!activateSubscriber) return;
      vsObject.node.mixer.addEventListener('finished', async () => {
        const { flowIsActive } = this.state;
        if (!flowIsActive) {
          await this.renderVSAfterAnimation(vsObject);
        }
        if (vsObject.node.inputs.hideOnAnimationFinished && !flowIsActive) {
          await this.setVSVisible(vsObject, false);
          vsObject.videoPlayedOnce = true;
        }
      });
    } else if (vsObject.node?.video) {
      const activateSubscriber = vsObject?.active && !vsObject?.loop;
      if (!activateSubscriber) return;
      vsObject.node.video.addEventListener('ended', async () => {
        const { flowIsActive } = this.state;
        if (!flowIsActive) {
          await this.renderVSAfterAnimation(vsObject);
        }
        if (vsObject.node.inputs.hideOnAnimationFinished && !flowIsActive) {
          await this.setVSVisible(vsObject, false);
          vsObject.videoPlayedOnce = true;
        }
      });
    }
  };

  renderVSAfterAnimation = async (animatedVSObject: VSTourAsset) => {
    const filteredVsObjects = this.vsObjects;
    filteredVsObjects.forEach((vsObject: VSTourAsset) => {
      if (vsObject instanceof TourImage) {
        let afterAnimationId = null;
        if (animatedVSObject instanceof TourObject) {
          afterAnimationId = vsObject.toursVSObjectIdAfterAnimation;
        } else if (animatedVSObject instanceof TourVideo) {
          afterAnimationId = vsObject.toursVSVideoIdAfterAnimation;
        }

        if (afterAnimationId === animatedVSObject.id) {
          this.setVSVisible(vsObject, true);
        }
      }
    });
  };

  // Add this method to clean up resources when unloading the iframe
  cleanupIframeResources = () => {
    if (!this.state.isChangeIframe) return; //clear iframe only when it is changed
    // Stop any audio playing from the iframe
    if (this.iframe && this.iframe.contentWindow) {
      try {
        // Remove event listeners
        this.iframe.contentWindow.document.removeEventListener('keydown', this.takePosition);

        // Clean up any WebGL contexts
        const canvases = this.iframe.contentWindow.document.querySelectorAll('canvas');
        canvases.forEach((canvas: HTMLCanvasElement) => {
          const gl = canvas.getContext('webgl') || canvas.getContext('webgl2');
          if (gl) {
            gl.getExtension('WEBGL_lose_context')?.loseContext();
          }
        });
      } catch (e) {
        console.warn('Error cleaning up iframe resources:', e);
      }
    }

    // Clean up Matterport SDK resources
    if (this.showCaseTemp && this.showCaseTemp.showcase) {
      try {
        this.showCaseTemp.showcase.disconnect();
      } catch (e) {
        console.warn('Error disconnecting showcase:', e);
      }
    }

    // Reset important state variables
    this.showCaseTemp = null;
    this.showcase = null;
    this.vsObjects = [];

    // Force garbage collection if possible
    if (window.gc) {
      try {
        window.gc();
      } catch (e) {
        console.warn('Unable to force garbage collection:', e);
      }
    }
  };

  renderVS = async (currentSweep) => {
    const { isVSVisible, tour, flowIsActive } = this.state;
    const blockRender =
      this.state.tourMode === this.showCaseTemp.showcase.Mode.Mode.OUTSIDE ||
      currentSweep.mode === this.showCaseTemp.showcase.Mode.Mode.OUTSIDE ||
      currentSweep.mode === this.showCaseTemp.showcase.Mode.Mode.TRANSITIONING ||
      this.state.tourMode === this.showCaseTemp.showcase.Mode.Mode.TRANSITIONING;

    if (!currentSweep || blockRender) {
      return;
    }
    if (!isVSVisible) {
      return;
    }

    if (flowIsActive) {
      //we let flows load the VS, renderVS is called every movment..
      return;
    }

    const { THREE } = this;

    if (!THREE) return;
    const pose = new THREE.Vector3(
      currentSweep?.position?.x,
      currentSweep?.position?.y,
      currentSweep?.position?.z,
    );

    const sweepGroupElementIdsToHide = this.getSweepGroupElementIdsToHide();

    let filteredVsObjects = this.vsObjects; //this.vsObjects;

    if (this.isGameTour()) {
      const { vsImagesToHide, vsItemsToHide, vsVideosToHide, vsHTMLsToHide } =
        this.filterVsElementsByGameCondition();
      filteredVsObjects = this.vsObjects.filter(
        (item) =>
          (item instanceof TourImage && !vsImagesToHide.includes(item.id)) ||
          (item instanceof TourObject && !vsItemsToHide.includes(item.id)) ||
          (item instanceof TourVideo && !vsVideosToHide.includes(item.id)) ||
          (item instanceof TourVSHtml && !vsHTMLsToHide.includes(item.id)),
      );
    }

    this.pathFinderMeshComponent?.setVisible(false);
    this.menuMeshComponent?.setVisible(false);
    this.flowsMenuMeshComponent?.setVisible(false);
    this.flowsBarMeshComponent?.setVisible(false);

    // if its a game we load everything regardless of radius or sensor.=
    filteredVsObjects.forEach((vsObject: any) => {
      if (this.vsObjectHiddenByPathLock(vsObject)) return;
      if (vsObject.hiddenFromFlows) return;
      const assetPose = new THREE.Vector3(
        vsObject.positionX,
        vsObject.positionY,
        vsObject.positionZ,
      );
      // Multiply by 0.2 because 1 three.js unit is approximately 20cm
      const distance = pose.distanceTo(assetPose) * 0.2;
      const inRange =
        distance <=
        (vsObject?.renderRange || this.state.tour?.vsRenderRange || DEFAULT_VS_SENSOR_RADIUS);
      const startAnimationDistance = vsObject?.startAnimationDistance || tour.vsAnimationDistance;
      const isVisibleVsItems = this.isSweepGroupVsVisible(vsObject, sweepGroupElementIdsToHide);
      if (vsObject?.toursVSObjectIdAfterAnimation || vsObject?.toursVSVideoIdAfterAnimation) {
        // skip it here, renderVSAfterAnimation will render it when time comes...
        return;
      }
      if (inRange && isVisibleVsItems) {
        this.loadingQueue.enqueue(async () => {
          try {
            await this.setVSVisible(vsObject, true);

            if (vsObject?.node && vsObject instanceof TourVideo && vsObject.node.video) {
              if (distance <= startAnimationDistance && vsObject.node.video.autoplay) {
                if (
                  (!vsObject.node.video.paused || !vsObject.node.isLoaded) &&
                  !this.state.startScreenOn
                ) {
                  if (!this.isGeorgiaPacificTour) vsObject.node.play();
                }
              } else if (
                distance > startAnimationDistance &&
                vsObject.node.isLoaded &&
                !vsObject.node.video.paused
              ) {
                vsObject.node?.pause();
              }
            } else if (
              vsObject?.node &&
              ((vsObject.details as VSObject)?.isGLTF || vsObject instanceof TourImage)
            ) {
              vsObject.node.animate = distance <= startAnimationDistance;
            }
            this.loadingQueue.dequeue();
          } catch (err) {
            console.error(err);
            this.loadingQueue.dequeue();
          }
        });
      } else if (vsObject.node) {
        this.setVSVisible(vsObject, false);
      }
    });
  };

  handleShowNearestProduct = (state: boolean) => {
    this.setState({ isShowNearestProducts: state, nearestProducts: [] });
  };

  fixMatterportTagScrollBug = () => {
    // Matterport text tags don't scroll until the end on iOS Chrome
    setTimeout(() => {
      if (DeviceManager.isMobile() && DeviceManager.isIOS() && DeviceManager.isChrome()) {
        const tagPanel = this.getShowcaseElement(ShowcaseElement.TagPanelHeader);

        tagPanel?.style.setProperty('padding-bottom', '120px');
      }
    }, 500);
  };

  setTagAllowAction = async (tag?: Tag) => {
    if (!tag) return;
    await this.showcase.Tag.allowAction(tag.sid, {
      // allow opening: true/false
      opening:
        !tag.tourId ||
        (tag.tooltip && !tag.iotDevices?.length && !tag.treedisStyle && tag.hoverTooltip),
      navigating:
        tag.mpNavigation &&
        tag.type !== TagType.Treedis &&
        tag.type !== TagType.Matterport &&
        tag.type !== TagType.MatterportInstant,
      docking: !this.state.tour.hideMPTagDock && !tag.treedisStyle,
    }).catch(console.error);
  };

  handleTagHoverEvent = (tagId: string, isHovered: boolean) => {
    try {
      const { isClickedTag, iot } = this.state;
      const tags = Array.from(this.state.allTags.values());
      const tag: any = tags.find((t: any) => t.sid === tagId || t.defaultSid === tagId);
      if (tag.media?.type === 'video' || tag.type === 'video' || tag.mediaType === 'video') {
        if (!isHovered) {
          const vsVideos = this.vsObjects?.filter(
            (obj) => obj.node?.componentType === videoRendererType,
          );
          vsVideos?.forEach((obj) => {
            const { video: vsVideo, muteBtn } = obj.node;
            if (muteBtn && !muteBtn.active) {
              vsVideo.muted = true;
              muteBtn.active = true;
              muteBtn.makeBtn(muteBtn.inputs.src);
            }
          });
          audioHandler.pauseAllMusic();
        } else {
          if (!isClickedTag) {
            if (this.state.openedTag?.type !== TagType.Popup) {
              audioHandler.resumeMusic();
            }
          }
          this.setState({ isClickedTag: false });
        }
      }

      if (tag.iotDevices?.length) {
        const devicesBelongingToTag = iot?.devices?.filter((device) =>
          device?.relatedAssets?.find(
            // eslint-disable-next-line eqeqeq
            (asset) => asset.id == tag.sid || asset.id == tag.defaultSid,
          ),
        );
        const doors = iot?.devices?.filter(
          (device) =>
            device.providerId ===
            iot.providers?.find((provider) => provider?.provider?.name === EIoTProviders.Kisi)
              ?.provider?.id,
        );

        // Find doors related to devices belonging to the tag
        const doorsRelatedToTag = doors?.filter((door) =>
          devicesBelongingToTag?.some((device) =>
            // eslint-disable-next-line eqeqeq
            device.relatedAssets?.some((asset) => asset.id == door.id),
          ),
        );
        const tagWithIot = {
          ...tag,
          iotDevices:
            [...(devicesBelongingToTag || []), ...(doorsRelatedToTag || [])] || tag?.iotDevices,
        };
        this.setState({
          isTagHovered: isHovered,
          tagHovered: isHovered ? tagWithIot : null,
          lastTagHovered: tagWithIot,
          selectedTag:
            isHovered && tag?.id !== this.state.selectedTag?.id ? null : this.state.selectedTag,
        });
      } else {
        this.setState({
          isTagHovered: isHovered,
          tagHovered: isHovered ? tag : null,
          lastTagHovered: tag,
          selectedTag:
            isHovered && tag?.id !== this.state.selectedTag?.id ? null : this.state.selectedTag,
        });
      }

      if (!tag) return;

      this.setTagAllowAction(tag);

      this.emitTagChangesFromHost(tag, 'hover');
    } catch (err) {
      console.error(err.message);
    }
  };

  resetTagHoverAndPopupView = () => {
    this.setState({
      lastTagClicked: null,
      tagPopupOpen: false,
      selectedTag: false,
      isTagHovered: false,
      tagHovered: null,
    });
  };

  emitTagTreedisSDKEvent = (
    tagId: string,
    eventType: TreedisSDKEvent = TreedisSDKEvent.TagClicked,
  ) => {
    const tags = Array.from(this.state.allTags.values());
    const tag: any = tags.find((t: any) => t.sid === tagId || t.defaultSid === tagId);
    if (!tag) return;

    if (window.parent) {
      try {
        const safeTag = {
          sid: tag.sid,
          defaultSid: tag.defaultSid,
          id: tag.id,
          title: tag.title,
          url: tag.url,
          type: tag.type,
          description: tag.description,
          position: {
            x: tag.positionX,
            y: tag.positionY,
            z: tag.positionZ,
          },
          // Add any other primitive properties you need
        };
        console.log(`emit ${eventType} message:`, safeTag);

        // Use window.parent to ensure we're targeting the correct window
        window.parent.postMessage({ type: eventType, tag: safeTag }, '*');
      } catch (err) {
        console.error(`Error sending ${eventType} message:`, err);
      }
    }
  };

  handleTagClickEvent = async (tagId: string) => {
    const { iot, lastTagClicked } = this.state;
    if (lastTagClicked === tagId) {
      this.resetTagHoverAndPopupView();
      return;
    }
    this.setState({ isClickedTag: true, lastTagClicked: tagId });
    this.emitTagTreedisSDKEvent(tagId, TreedisSDKEvent.TagClicked);
    const tags = Array.from(this.state.allTags.values());
    const tag: any = tags.find((t: any) => t.sid === tagId || t.defaultSid === tagId);
    if (!tag) return;

    this.setTagAllowAction(tag);

    if (tag.type === TagType.None) {
      // Opening the tag Billboard on Mobile if there's no Action Type
      this.showCaseTemp.showcase.Tag.open(tagId);
    }

    this.emitTagChangesFromHost(tag, 'click');
    if (tag.iotDevices?.length) {
      const devicesBelongingToTag = iot?.devices?.filter((device) =>
        device?.relatedAssets?.find(
          // eslint-disable-next-line eqeqeq
          (asset) => asset.id == tag.sid || asset.id == tag.defaultSid,
        ),
      );
      const doors = iot?.devices?.filter(
        (device) =>
          device.providerId ===
          iot.providers?.find((provider) => provider?.provider?.name === EIoTProviders.Kisi)
            ?.provider?.id,
      );
      // Find doors related to devices belonging to the tag
      const doorsRelatedToTag = doors?.filter((door) =>
        devicesBelongingToTag?.some((device) =>
          // eslint-disable-next-line eqeqeq
          device.relatedAssets?.some((asset) => asset.id == door.id),
        ),
      );
      setTimeout(() => {
        //to make sure it overrides the hover event
        this.setState({
          selectedTag: {
            ...tag,
            iotDevices:
              [...(devicesBelongingToTag || []), ...(doorsRelatedToTag || [])] || tag?.iotDevices,
          },
        });
      }, 50);
    } else if (
      tag.type !== TagType.Matterport &&
      tag.type !== TagType.MatterportInstant &&
      tag.type !== TagType.Treedis &&
      tag.type !== TagType.Flow
    ) {
      setTimeout(() => {
        //to make sure it overrides the hover event
        this.setState({ selectedTag: tag });
      }, 50);
    } else {
      this.setState({ selectedTag: null });
    }

    if (tag.iotDevices?.length) {
      const camera = this.state.lastTagHovered?.iotDevices?.filter((d) => d.videoUrl)?.[0];
      if (camera) {
        this.setIotModalOpen(true, false);
        this.updateIotState({
          openCamera: this.state.lastTagHovered?.iotDevices?.filter((d) => d.videoUrl)?.[0],
          openFavouriteCameras: null,
        });
      }
    }

    if ((tag.mpNavigation || tag.iotDevices?.length) && tag.type !== TagType.Treedis) {
      this.moveToTagIO(tag, tag.action === 'click');
    }

    if (tag.isThread) {
      this.setState({
        isThreadsDrawerOpen: true,
        selectedNoteTag: null,
        selectedThread: { ...tag },
      });
    }

    if (!tag.iotDevices?.length && !tag.isThread) {
      this.setState({ clickedTag: false });
      await this.openTagIframe(tagId);
      this.setState({ clickedTag: true });
    }

    const hasPath = this.state.game?.paths?.length > 0;
    const watchTagPanelElem = this.getShowcaseElement(ShowcaseElement.TagPanel);
    if (!tag.tooltip && DeviceManager.isMobile()) {
      closeTagPanelObserver(watchTagPanelElem);
    } else if ((tag.tooltip || hasPath) && DeviceManager.isMobile()) {
      setTagPanelObserver(watchTagPanelElem, (isTagPanelOpen, observer) => {
        if (tag.tooltip) {
          this.setState({
            hideBottomBarForWhile: isTagPanelOpen,
          });
        }
        if (hasPath) {
          const pathModal = document.getElementsByClassName(
            'path-lock-panel-wrap',
          )[0] as HTMLElement;
          if (pathModal) {
            pathModal.style.display = isTagPanelOpen ? 'none' : 'block';
          }
        }
        if (!isTagPanelOpen) {
          observer.disconnect();
        }
      });
    }

    if (tag && tag.title && !tag.isThread) {
      sendToGA('event', {
        eventCategory: 'Mattertag',
        eventAction: 'click',
        eventLabel: tag.title,
        eventType: tag.type,
      });
    }

    this.fixMatterportTagScrollBug();
  };

  registerShowcaseSubscribers = () => {
    this.unsubsribeShowcaseSubscribers();

    const events = {
      [this.showcase.Mattertag.Event.CLICK]: this.handleTagClickEvent,
      [this.showcase.Mattertag.Event.HOVER]: this.handleTagHoverEvent,
    };

    Object.entries(events).forEach(([event, handler]) => {
      const emitter = this.showcase.on(event, handler);
      this.showcaseSubscribers.push(() => emitter.off(event, handler));
    });
  };

  async loadedShowcaseHandler(cb = () => {}) {
    // Define showcase and event listeners
    const { tour, room, changeReel } = this.state;
    const isEcommerceTour = tour.mode === TourType.ECommerce;
    const isOpticalCenter = this.state.externalProvider === ExternalProvider.OPTICAL_CENTER;
    // TODO revert back
    if (tour?.enableAvatar || room || tour?.isThreadsEnabled) {
      socket.open();
    }
    const auth = getQueryVariable(window.location.href, 'auth');
    if (tour.user?.oauth && (auth || tour.oauthAccess)) {
      // public oauth is allowed for this tour
      const { access_token, expires_in } = await PublicAPI.refreshOAuth({ id: tour.userId });
      // create refresher
      const fetcher = {
        async fetch(oldToken) {
          console.log('OAuth Token Expired, refreshing...');
          return PublicAPI.refreshOAuth({ id: tour.userId });
        },
      };
      this.showCaseTemp.showcase.OAuth.createTokenRefresher(
        {
          access_token,
          expires_in,
        },
        fetcher,
      );
    }

    const reel = await this.showCaseTemp.showcase.Tour.getData().catch(() => []);

    if (reel?.length && !changeReel) {
      this.setState({ reel });
    }
    this.showCaseTemp.showcase.Settings.update('highlight_reel', false);
    this.showCaseTemp.showcase.Settings.update('tour_buttons', false);
    await this.showCaseTemp.showcase.Link.setShareLinkPolicy(
      this.showCaseTemp.showcase.Link.CreationPolicy.REFERRER,
    ).catch(() => []);

    if (tour.hidePucks) {
      this.showCaseTemp.showcase.Settings.update('features/sweep_pucks', false);
    }

    this.showCaseTemp.showcase.Mode.current.subscribe((mode) => {
      if (mode === this.showCaseTemp.showcase.Mode.Mode.OUTSIDE) {
        this.stopVS();
      }
      this.setState({ tourMode: mode });

      // hide models from other floors on view change
      if (
        this.showCaseTemp?.scene?.sceneObject &&
        this.showCaseTemp?.scene?.sceneObject?.assets?.length
      ) {
        if (
          mode === this.showCaseTemp?.showcase?.Mode?.Mode.FLOORPLAN ||
          this.showCaseTemp?.showcase?.Mode?.Mode.TRANSITIONING
        ) {
          this.showCaseTemp.scene.sceneObject.assets.forEach((asset) => {
            if (asset[0].floor !== this.state.currentFloor) asset[0].node.pivot.visible = false;
          });
        }
        if (mode === this.showCaseTemp?.showcase?.Mode?.Mode.INSIDE) {
          this.showCaseTemp?.scene?.sceneObject?.assets.forEach((asset) => {
            asset[0].node.pivot.visible = true;
          });
        }
      }
    });

    this.showCaseTemp.showcase.Camera.pose.subscribe(
      _debounce((p: any) => {
        this.pose = { ...p };
        cb();
      }, 50),
    );

    this.showCaseTemp.showcase.Sweep.current.subscribe(async (currentSweep) => {
      this.currentSweep = currentSweep;
      if (isEcommerceTour) {
        this.handleShowNearestProduct(false);
      }
      if (!this.deselectTagTimeout && !this.state.tagPopupOpen)
        this.setState({ selectedTag: null });
      if (currentSweep.sid !== '') {
        // This line was causing the music to stop when changing sweeps. Ely said it's a bug. Remove this line in a month if everything is fine without it.
        // await audioHandler.stopAudioByPriority(PriorityNumbers.FIRST);
        if (!this.defaultSweep) this.defaultSweep = structuredClone(currentSweep);
        this.prevSweep = structuredClone(currentSweep);
        //call renderVS only if previous sweep was set (this.state.currentSweep === null in the beginning)
        //if previus sweep was not set, we are on the first sweep load, and we call this function anyway in initVS.
        let onActiveSweepGroupChange = this.state.currentSweep
            ? () => this.renderVS(currentSweep)
            : () => undefined;
        this.updateSweepLoc(currentSweep, {
          onActiveSweepGroupChange
        });
        currentSweep.uuid = currentSweep.sid;
        this.setState({ currentSweep }, () => {
          if (isEcommerceTour && !isOpticalCenter) {
            this.handleShowNearestProduct(true);
          }
        });
      }
      this.pathFinderMeshComponent?.setVisible(false);
      if (asyncStore.vrIsOn && this.openedVRTag) {
        const openedTag = this.matterTagMeshComponents.find(
          (tag) => tag.tagId === this.openedVRTag,
        );
        if (openedTag) {
          openedTag.inputs.popupVisible = false;
          this.openedVRTag = null;
        }
      }
    });

    this.showCaseTemp.showcase.on(this.showCaseTemp.showcase.Camera.Event.MOVE, async (p: any) => {
      this.cameraPose.current = p;
      const { showcaseLoaded, host, room, tour, panoramaOn, isRemoteControlled, lock } = this.state;
      if (!showcaseLoaded) return;
      if (!this.menuMeshComponent?.hostPose) this.menuMeshComponent?.setHostPose(this.pose);
      if (!this.flowsMenuMeshComponent?.hostPose)
        this.flowsMenuMeshComponent?.setHostPose(this.pose);
      if (!this.flowsBarMeshComponent?.hostPose) this.flowsBarMeshComponent?.setHostPose(this.pose);
      if (!this.pathFinderMeshComponent?.hostPose)
        this.pathFinderMeshComponent?.setHostPose(this.pose);
      if (!this.backpackMeshComponent?.hostPose) this.backpackMeshComponent?.setHostPose(this.pose);

      this.matterTagMeshComponents.forEach((tag) => {
        if (!tag.hostPose) tag.setHostPose(p);
      });

      if (socket && socket.connected && (room || tour.enableAvatar)) {
        // position of avatar on the circle
        const pose = {
          walking: p.mode === this.showCaseTemp.showcase.Mode.Mode.INSIDE,
          position: p.position,
          rotation: this.camera?.rotation,
          quaternion: this.camera?.quaternion,
          mode: p.mode,
          degree: this.avatarDegree,
          sweep: this.state.currentSweep,
        };

        if (room) {
          if (
            (host && !isRemoteControlled) ||
            (isRemoteControlled &&
              !lock &&
              (!_isEqual(p.position, this.pose?.position) ||
                !_isEqual(p.rotation, this.pose?.rotation)))
          ) {
            socket.emit('move', {
              pose: { ...p, walking: p.mode === this.showCaseTemp.showcase.Mode.Mode.INSIDE },
            });
          }
        }

        this.lastAvatarCameraPose = pose;

        if (tour?.enableAvatar) {
          socket.emit('move_avatar', { pose });
        }
      }

      if (tour.minimap) {
        if (p.mode === this.showCaseTemp.showcase.Mode.Mode.INSIDE && !panoramaOn) {
          this.setState({ mapWalkerRotation: p.rotation.y * -1 });
        }
      }
    });

    this.showCaseTemp.showcase.Sweep.current.subscribe((sweep: any) => {
      const pose = this.lastAvatarCameraPose;
      if (pose) socket.emit('move_avatar', { pose });
    });

    this.showCaseTemp.showcase.Floor.current.subscribe((floor: any) => {
      // hide models from other floors on floor change
      if (
        floor &&
        typeof floor.sequence === 'number' &&
        this.showCaseTemp?.scene?.sceneObject &&
        this.showCaseTemp.scene?.sceneObject?.assets?.length
      ) {
        if (this.state.tourMode === this.showCaseTemp.showcase.Mode.Mode.FLOORPLAN) {
          this.showCaseTemp?.scene?.sceneObject?.assets.forEach((asset) => {
            asset[0].node.pivot.visible = asset[0].floor === floor.sequence;
          });
        }
        if (
          this.state.tourMode === this.showCaseTemp.showcase.Mode.Mode.INSIDE ||
          this.state.tourMode === this.showCaseTemp.showcase.Mode.Mode.DOLLHOUSE
        ) {
          this.showCaseTemp?.scene?.sceneObject?.assets.forEach((asset) => {
            asset[0].node.pivot.visible = true;
          });
        }
      }
      if (
        floor.sequence !== -1 &&
        floor.sequence !== undefined &&
        floor.sequence !== this.state.selectedMinimap
      ) {
        const { minimaps } = this.state;
        if (minimaps.length > 0 && minimaps[floor.sequence]) {
          this.setState({ selectedMinimap: floor.sequence });
        }
      }
      if (
        floor.sequence !== -1 &&
        floor.sequence !== undefined &&
        this.state.currentFloor !== floor.sequence
      ) {
        this.setState(
          {
            currentFloor: floor.sequence,
          },
          () => {
            if (!this.state.showIntro && !this.state.startScreenOn && this.state.showcaseLoaded) {
              this.processTourMusic();
            }
          },
        );
      }
    });

    this.showCaseTemp.showcase.Measurements.mode.subscribe((measurementModeState: any) => {
      const styleId = 'override-measurementsOn';
      const isActive = measurementModeState.active;
      this.setState({ measurementsOn: isActive });

      if (isActive) {
        const style = document.createElement('style');
        style.id = styleId;
        style.innerHTML = `
          @media (max-width: 576px) {
            .measurements-overlay {
              .overlay-action-bar {
                padding-bottom: 60px;
              }
            }
          }
        `;
        this.iframe.contentWindow.document.head.appendChild(style);

        setTimeout(() => {
          const watchElem = this.getShowcaseElement(ShowcaseElement.AddMeasurement);
          this.destroyAddMeasurementsModeObserver = startAddMeasurementsModeObserver(watchElem, (isAddingMeasurement) => {
            this.setState({
              hideActionBar: isAddingMeasurement,
            })
          });
        }, 100);
      } else {
        const style = this.iframe.contentWindow.document.getElementById(`#${styleId}`);
        style && style.remove();
        this?.destroyAddMeasurementsModeObserver?.();
      }
    });

    this.showCaseTemp.showcase.on(this.showCaseTemp.showcase.Tour.Event.STEPPED, (i: number) => {
      this.setState({ reelStep: i, panoramaOn: false });
    });

    this.showCaseTemp.showcase.on(this.showCaseTemp.showcase.Tour.Event.STARTED, () => {
      this.setState({ tourPlaying: true, panoramaOn: false, tourMode: this.pose.mode });
    });

    this.showCaseTemp.showcase.on(this.showCaseTemp.showcase.Tour.Event.STOPPED, () => {
      this.setState({ tourPlaying: false, panoramaOn: false });
    });

    this.showCaseTemp.showcase.on(this.showCaseTemp.showcase.Tour.Event.ENDED, () => {
      this.setState({ tourPlaying: false, panoramaOn: false, reelStep: 0 });
    });

    const hidePathWhenTagDockedInMobile = (docked: string | null) => {
      if (DeviceManager.isMobile() && this.state?.game?.paths?.length > 0) {
        const pathWrap = document.querySelector('.path-lock-panel-wrap');
        if (docked) {
          pathWrap?.classList.add('hide-path');
        } else {
          pathWrap?.classList.remove('hide-path');
        }
      }
    };

    const { emitTagTreedisSDKEvent } = this;

    this.showcase.Tag.openTags.subscribe({
      prevState: {
        hovered: null,
        docked: null,
        selected: null,
      },
      onChanged(newState: { docked?: string; hovered?: string; selected?: Set<string> }) {
        hidePathWhenTagDockedInMobile(newState.docked);
        if (newState.hovered !== this.prevState.hovered && newState.hovered) {
          emitTagTreedisSDKEvent(newState.hovered, TreedisSDKEvent.TagHovered);
        }
        if (newState.docked !== this.prevState.docked && newState.docked) {
          emitTagTreedisSDKEvent(newState.docked, TreedisSDKEvent.TagDocked);
        }

        // only compare the first 'selected' since only one tag is currently supported
        // @ts-ignore
        const [selected = null] = newState.selected; // destructure and coerce the first Set element to null
        if (selected !== this.prevState.selected && selected) {
          emitTagTreedisSDKEvent(selected, TreedisSDKEvent.TagFocused);
        }

        this.prevState = {
          ...newState,
          selected,
        };
      },
    });

    this.registerShowcaseSubscribers();

    this.showCaseTemp.showcase.Floor.data.subscribe({
      // Get floor data
      onCollectionUpdated: (collection: any) => {
        const mpFloors = [];
        Object.keys(collection).forEach((o) => {
          const floor = collection[o];
          if (!floor.name || floor.name.length === 0) return;
          mpFloors.unshift(floor);
        });
        this.setState({ mpFloors });
      },
    });

    this.showCaseTemp.showcase.Label.getData()
      .then((labels) => {
        if (labels?.length) this.setState({ mpLabels: labels });
      })
      .catch(() => console.error('Error to load MP labels'));
    const videoMediaType = this.showCaseTemp.showcase.Mattertag.MediaType.VIDEO;
    this.showCaseTemp.showcase.Tag.data.subscribe({
      onAdded: async (sid, item) => {
        if (tour?.addon_hidetags) {
          this.showCaseTemp.showcase.Tag.remove(sid);
          return;
        }
        const { room } = this.state;
        if (room && item?.media?.type === videoMediaType) {
          // ToDo: matterport vimeo video does not support mute
          const clone = _cloneDeep(item);
          const urlC = clone.media.src.split('https://vimeo.com/');
          clone.media.src += urlC.length > 1 ? '?muted=1' : '&muted=1';
          this.showCaseTemp.showcase.Tag.editBillboard(sid, clone);
          this.tagManager
            .replaceAttachment(
              {
                originName: item.media.src,
                url: item.media.src,
              },
              clone.media.src,
              sid,
            )
            .catch(console.error);
        }
      },
    });
  }

  async initNavigationManager() {
    const { tour, barrierData, teleportGroups, navigationSweeps } = this.state;

    navigationSweeps.map((sweep) => {
      if (!sweep.enabled) {
        this.showcase.Sweep.disable(sweep.sweep_uuid);
      }
    });

    const customSweeps = navigationSweeps.filter((s) => s.isCustom);
    await this.initCustomSweeps(customSweeps);

    const { barriers, barrierNodes } = await this.initBarriers(barrierData);

    if (teleportGroups?.length) {
      await this.initTeleports(teleportGroups);
    }

   const sweepsWithBarriersApplied = getPathCalculationSweeps(
      this.state.allSweeps,
      barriers,
      barrierNodes,
    );
    await this.showCaseTemp.navigationManager.initialize({
      iframe: this.iframe,
      pathCalculationSweeps: sweepsWithBarriersApplied,
      currentSweep: this.currentSweep,
      pathArrowRef: this.isGameTour() ? null : this.pathArrowRefBaseTour,
      moveToSweep: this.moveToSweep,
      teleportGroups,
      tourId: tour.id,
      teleportPoints: this.teleportPoints,
      requestFn: getPath,
      handleTeleportClick: this.handleTeleportClick,
      getPathResult: this.pathResult,
    });

    this.showCaseTemp.navigationManager.on(
      NodeEventsTypes.NAVIGATION_PATH_RENDER_COMPLETE,
      (data) => {
        const visible =
          data.targetObjectData?.enableNavBar ||
          data.targetObjectData?.enableTeleportBtn ||
          data.targetObjectData?.autoNavigation ||
          data.targetObjectData?.sweepId;
        this.setActionPathNavbarVisible(visible);
      },
    );
    this.showCaseTemp.navigationManager.on(NodeEventsTypes.NAVIGATION_PATH_RESET, (data) => {
      if (data.pathFinished) {
        this.setActionPathFinished(true);
      }
      this.setActionPathNavbarVisible(false);
    });
    this.showCaseTemp.navigationManager.on(NodeEventsTypes.NAVIGATION_COMPLETE, (data) => {
      this.setActionPathFinished(true);
      this.onPathNavigationFinished(data);
    });

    this.showCaseTemp.navigationManager.on(
      NodeEventsTypes.NAVIGATION_TELEPORT_RESUME_AUTOMOVE,
      (data) => {
        this.setActionPathNavbarPlayButtonType('Pause');
      },
    );
    this.showCaseTemp.navigationManager.on(NodeEventsTypes.NAVIGATION_PATH_RENDER_FAIL, (data) => {
      console.log('NAVIGATION_PATH_RENDER_FAIL', data);
    });

    this.initPathDistanceUpdates();
  }

  initPlaying = async () => {
    const { tour, iframeUrl } = this.state;

    if (DeviceManager.isMobile() && !DeviceManager.isDesktop()) {
      const vrOverlay: any = this.getShowcaseElement(ShowcaseElement.VRLayer);
      if (vrOverlay) {
        const iframeVrButton = vrOverlay.querySelector('[role="button"]');
        if (iframeVrButton) iframeVrButton.style.display = 'none';
      }
    }

    // in case the tour goes directly into playing
    const matterId = getQueryVariable(iframeUrl, 'm');

    // Support for matterport->treedis->matterport
    const url = window.location.href;
    const s = getQueryVariable(url, 's');
    const x = getQueryVariable(url, 'x');
    const y = getQueryVariable(url, 'y');

    if (!this.camera) {
      const models = await this.showCaseTemp.showcase.Scene.query(['model']);
      this.camera = models[0]?.parent.children[0].camera;
    }

    if (s && x && y && this.state.tourType !== TourType.Kiosk && !tour.navigationWebEnabled) {
      // We move inside the tour
      this.moveToSweep(String(s), { x: parseFloat(x), y: parseFloat(y) });
    }

    this.setState({ appState: 'playing' });

    const newState: any = { loadedOnce: true };
    // TODO:: Remove when Matterport will fix problem with current floor
    if (matterId === 'VE4rJCNFfba') newState.currentFloor = 1;

    this.setState(newState, async () => {
      if (tour.addon_ts >= 0 && tour.mpPlay) {
        setTimeout(() => {
          this.playTour();
        }, tour.addon_ts * 1000);
      }

      try {
        const hash = window.location.hash.substring(1);
        if (hash) {
          this.loadModel({
            name: null,
            url: null,
            type: MenuType.Product,
            tag: hash,
            panoramaId: null,
            changeMinimap: true,
            changePanorama: false,
            iframeSettings: {},
            changeReel: false,
            gallery: [],
            file: null,
          });
        }
        if (this.isTourReadyForAudio()) {
          await this.processTourMusic(true);
        }
        const { polygons } = this.state;

        if (this.getValueOnWindowLocationObject('href').includes('m=Q17U4kMH7A9')) {
          this.pipesData = new DeloreanCTBPipes(this.showCaseTemp, this.state.iot?.devices);
        }

        if (this.vsObjects?.length > 0 || polygons?.length > 0 || tour?.enableAvatar) {
          this.setState({ isVSReady: true }, async () => {
            await this.showCaseTemp.showcase.Scene.register(
              avatarComponentType,
              makeAvatarComponent,
            );
            if (polygons?.length || this.vsObjects?.length) {
              if (polygons?.length) {
                await this.initPolygons();
              }
              if (this.vsObjects?.length) {
                await this.initVS();
              }
            }
            await this.initAvatar();

            if (
              !DeviceManager.isMobile() &&
              this.isGameTour() &&
              (this.state.tour?.user?.enterprise ||
                this.state.tour?.user?.subscription ===
                  (UserSubscription.Business || UserSubscription.Enterprise))
            ) {
              if (this.state.game?.backpackOn) await this.initBackpackMesh();
              await this.initPathFinderMesh();
            }
            await this.initVRPointer();
            // TODO Hardcoded pipes for TB-2112
            if (this.getValueOnWindowLocationObject('href').includes('m=y9vZoA57wQs')) {
              this.pipesData = await initPipes(
                this.showCaseTemp,
                this.modelNodes,
                this.state.polygons,
                this.renderer,
              );
            }

            if (this.getValueOnWindowLocationObject('href').includes('m=cKEUCfKQmHn')) {
              this.pipesData = await initPipesAmericanWater(
                this.showCaseTemp,
                this.modelNodes,
                this.state.polygons,
                this.renderer,
              );
            }

            if (this.state.tour.slug === '05417693') this.buildPipes();

            this.loadingQueue.setLoadingQueueProgress(100);
          });
        } else {
          this.loadingQueue.setLoadingQueueProgress(100);
        }
      } catch (err) {
        console.error(err);
      }
    });
  };

  setActionPathNavbarVisible = (visible) => {
    this.setState({ showActionPathBar: visible });
  };

  setActionPathNavbarPlayButtonType = (type: 'Pause' | 'Play') => {
    this.setState({ actionPathNavbarPlayButtonType: type });
  };

  setActionPathNavbarData = (data) => {
    this.setState({ actionPathNavbarData: data });
  };

  setActionPathFinished = (val: boolean) => {
    this.setState({ actionPathFinished: val });
  };

  setPathResult = (val: any) => {
    this.setState({ pathResult: val });
  };

  setTeleportFinished = (data) => {
    this.onPathNavigationFinished(data);
  };

  onPathNavigationFinished = (data) => {
    const { targetObjectData } = data;
    if (targetObjectData?.sid) {
      this.handleTagHoverEvent(targetObjectData.sid, true);
    }
  };

  resetNavigationByCloseButton = (value) => {
    this.setState({ shouldNavReset: value });
  };

  initStarting = async () => {
    // Prevent multiple executions of initStarting
    if (this.state.startingInitialized) {
      console.log('initStarting already executed, skipping redundant initialization');
      return;
    }

    try {
      this.loadingQueue.setLoadingQueueProgress(70);

      this.setState({ appState: 'starting', startingInitialized: true });
      this.setState({ appState: 'starting' });
      const { tour, tourType, showcaseLoaded, isChangeIframe, iframeUrl } = this.state;
      if (iframeUrl.includes('m=mEMx41aqAaq')) this.isGeorgiaPacificTour = true;

      const { addon_hidetags: isHideTags } = tour;
      startGA(tour, true);
      const condition = tourType === TourType.Game ? true : !showcaseLoaded || isChangeIframe;
      const matterId = getQueryVariable(iframeUrl, 'm');

      await this.initVRSettings();

      const { importAudioData, volumeHandler } = audioHandler;
      if (!condition) return;
      volumeHandler(tour.audioVolume);

      this.yAxisVec3 = new this.THREE.Vector3(0, 1, 0);

      let auth = getQueryVariable(window.location.href, 'auth');
      if (tour.user?.oauth && tour.oauthAccess) {
        auth = null; // disregard auth if oauth is enabled on tour
      }

      const tagsRes = !isHideTags
        ? await PublicAPI.getTags({
            matterId,
            slug: matterId === tour.matterId ? tour.slug : null,
            auth,
          })
        : {};

      if (tour.slug == 'trane-demo') {
        const traneData = await PublicAPI.getTraneDemo();
        this.setState({ traneData });
      }

      const iotDevices = tour.enableIot
        ? await PublicAPI.getIoTDevices({ query: { tourId: tour.id } })
        : {};
      const iotDevicePositions =
        tour.showIotOnMinimap && tour.minimap
          ? await PublicAPI.getIotDevicePositions({ query: { tourId: tour.id } })
          : {};
      const iotProviders = tour.enableIot
        ? await PublicAPI.getIoTProviders({ query: { tourId: tour.id } })
        : {};

        this.updateIotState({
          devices: iotDevices?.data,
          providers: iotProviders?.data,
          devicePosition: iotDevicePositions?.data,
        });
      const iotDevicesWithTags = iotDevices?.data?.filter((device) => device.relatedAssets);

      // TODO check with MP!!!
      // const mpTags = !isHideTags? await new Promise((resolve) => {
      //   this.showcase.Tag.data.subscribe({
      //     onCollectionUpdated(collection) {
      //       const modifiedCollection = {}
      //       Object.keys(collection).map((item) => {
      //         const tag = collection[item]
      //         modifiedCollection[tag.id] = {
      //           newColor: tag.color,
      //           color: tag.color.r? rgbToHex(tag.color.r, tag.color.g, tag.color.b) : tag.color, //rgb is decimal numbers??? Why??
      //           description: tag.description,
      //           sid: tag.id,
      //           label: tag.label,
      //           position: tag.anchorPosition,
      //           stem: {
      //             direction: tag.stemVector,
      //             enabled: tag.stemEnabled
      //           }
      //         }
      //       })
      //       return resolve(modifiedCollection);
      //     }
      //   });
      // }) : {};

      // console.log("MP Tags loaded showcase vs legacy API", mpTags, tagsRes.matterTags)

      if (isHideTags) {
        this.setState({ loadingTags: false });
      }

      const mpTags = tagsRes?.matterTags;
      const treedisTags = tagsRes?.tags;
      const threads = tour?.isThreadsEnabled ? tagsRes?.threads : [];
      this.loadingQueue.setLoadingQueueProgress(40);

      // isMatterportLink - when tour is loaded via link of Matterport type
      const isMatterportLink = getQueryVariable(this.state.iframeUrl, 'm') !== tour.matterId;

      /* Concurrent (Non-blocking requests) */
      // VS Pages and Polygons are locked for free users
      const { polygons, vsObjects, vsSettings } = this.isFreeUser
        ? { polygons: [], vsObjects: [], vsSettings: this.state.vsSettings }
        : await getVSItems(isMatterportLink, {
            slug: tour.slug,
            userId: tour.userId,
            id: tour.id,
            tourType,
          });

      const { flows: fetchedFlows, objectsWithClick } = await getFlowsData(tour.id);
      const foundMainFlow = fetchedFlows.find((f) => f.isMain);

      this.vsObjects = vsObjects
        // Filtering IoT devices. Those are rendered in the IotLogic component
        .filter((o) => o.actionType !== 'iot')
        .filter((obj) => obj.active);

      await this.showCaseTemp.scene.configureScene({
        settings: vsSettings,
        onShadowEnabled: (value) => {
          this.isShadowEnabled = value;
        },
        onShadowNodeCreated: (shadowNode) => {
          this.shadowNode = shadowNode;
        },
      });

      if (tour.patchIconEnabled && tour.patchIcon) {
        this.initPatch(`${process.env.NEXT_PUBLIC_CDN}/tours/${tour.id}/${tour.patchIcon}`);
      }
      importAudioData(
        MusicObjectKey.VSIMAGES,
        (vsObjects.filter((item) => item instanceof TourImage) as any).map((el) => {
          return { ...el, tourId: tour.id };
        }),
      );
      const polygonsAudioData = [];
      polygons.forEach((p) => {
        if (p.polygonsActions?.find((a) => a.type === 'music')) {
          polygonsAudioData.push({
            id: p.polygonsActions[0].id,
            tourId: tour.id,
            actionType: 'music',
            url: p.polygonsActions[0].url,
          });
        }
      });
      importAudioData(MusicObjectKey.TAGS, treedisTags);
      importAudioData(MusicObjectKey.TOUR, [tour]);
      importAudioData(MusicObjectKey.FLOORS, tour.musics);
      if (polygonsAudioData?.length) {
        importAudioData(MusicObjectKey.POLYGONS, polygonsAudioData);
      }
      this.setState({ allAudio: audioHandler.getAllMusicData() });

      this.setState(
        {
          allTags: new Map(),
          polygons,
          vsSettings,
          flows: fetchedFlows,
          mainFlow: foundMainFlow,
          flowsObjects: objectsWithClick,
        },
        () => {
          this.tagManager.subscribe(
            { mpTags, treedisTags, threads, iotDevicesWithTags },
            (allTags) => {
              console.log('Setting tags...', allTags.size);

              this.setState({ allTags, threadsLoaded: true }, async () => {
                const { allTags } = this.state;

                const tags = await this.initTags(Array.from(allTags.values()));

                const isBusinessOrEnterprise =
                  this.state.tour?.user?.enterprise ||
                  this.state.tour?.user?.subscription === UserSubscription.Business ||
                  this.state.tour?.user?.subscription === UserSubscription.Enterprise;
                if (
                  !DeviceManager.isMobile() &&
                  !DeviceManager.isDesktop() &&
                  this.renderer?.xr?.enabled &&
                  isBusinessOrEnterprise
                ) {
                  this.initVRTags(tags);
                  this.initVREventManager();
                  if (this.state.parentMenus.length) {
                    this.initMenuMesh();
                  }
                  if (!this.state.parentMenus.length && fetchedFlows)
                    this.initFlowsMenuMesh(fetchedFlows);
                  this.initFlowsBarMesh();
                }

                this.setState({ loadingTags: false, allTags: tags }, async () => {
                  try {
                    if (this.state.tour?.isThreadsEnabled) {
                      this.openNoteDrawerWithInitialNote(
                        getQueryVariable(window.location.href, 'note') || '',
                      );

                      // Uncomment this if you want initial note opened only once (do not open after page reload)
                      // const urlWithoutNoteQuery = deleteQueryVariable(window.location.href, 'note');
                      // window.history.replaceState(null, '', urlWithoutNoteQuery);
                    }

                    this.hiddenTags = {};
                    this.visibleTags = {};
                    this.filterTags();

                    const { iot } = this.state;

                    const twinmakerProvider = iot?.providers?.find(
                      (provider) => provider?.provider?.name === EIoTProviders.TWINMAKER,
                    );

                    // AWS TwinMaker specific code:
                    if (twinmakerProvider && false) {
                      // depreacted for now
                      const { data: tmConfig } = await PublicAPI.getTwinMakerConfig(tour.slug);
                      const alarms: any = {};
                      const { rules } = tmConfig.data;
                      const liveTags: any[] = [];
                      await Promise.all(
                        tmConfig.data?.nodes?.map(async (node) => {
                          const tagComponent = node.components?.filter(
                            (component) => component.type === 'Tag',
                          )[0];
                          const overlayComponent = node.components?.filter(
                            (component) => component.type === 'DataOverlay',
                          )[0];
                          if (
                            !tagComponent ||
                            !tagComponent.valueDataBinding ||
                            tagComponent.valueDataBinding.length === 0
                          )
                            return; // not a live tag
                          if (
                            !overlayComponent ||
                            !overlayComponent.valueDataBindings ||
                            overlayComponent.valueDataBindings.length === 0
                          )
                            return; // not a live tag with overlay
                          const tag: any = {
                            title: node.name,
                            enabled: true,
                            mpTitle: true,
                            tooltip: true,
                            mpNavigation: true,
                            iconColor: '#0000FF',
                            positionX: node.transform?.position[0],
                            positionY: node.transform?.position[1],
                            positionZ: node.transform?.position[2],
                            description: overlayComponent?.dataRows[0]?.content
                              .replace(/#/g, '')
                              .replace(/\*\*/g, ''),
                          };

                          tag.sid = await this.addMattertag(tag);
                          this.showcase.Tag.editStem(tag.sid, { stemVisible: false }).catch(
                            console.error,
                          );
                          tag.component = tagComponent;
                          tag.overlay = overlayComponent.valueDataBindings;
                          liveTags.push(tag);
                          console.log('liveTag added', tag);
                          const ruleId = tagComponent.ruleBasedMapId;
                          if (ruleId) alarms[tag.sid] = ruleId;
                        }),
                      );

                      await this.registerIcon({
                        iconId: `stopped__treedis`,
                        url: 'https://static.treedis.com/iot/stopped.png',
                      });
                      await this.registerIcon({
                        iconId: `idle__treedis`,
                        url: 'https://static.treedis.com/iot/idle.png',
                      });
                      await this.registerIcon({
                        iconId: `running__treedis`,
                        url: 'https://static.treedis.com/iot/running.png',
                      });
                      await this.registerIcon({
                        iconId: `fault__treedis`,
                        url: 'https://static.treedis.com/iot/fault.png',
                      });

                      this.requestTwinMakerData(liveTags, rules, alarms, tour);

                      this.twinMakerDataInterval = setInterval(async () => {
                        this.requestTwinMakerData(liveTags, rules, alarms, tour);
                      }, 60000);
                    }

                    // @ts-ignore
                    this.updateIotState({
                      sceneAssets: vsObjects.filter((o) => o.actionType === 'iot'),
                    });

                    // if no VS objects, Media Images of Media Videos found - loadingQueueProgress is set to 100%
                    // to do not display the loading indicator for VS
                    //Added gametour check as this is legacy stuff from https://treedis.atlassian.net/browse/TB-3235
                    //We don't need renderVS to be loaded again otherwise.
                    if (
                      this.isGameTour() &&
                      this.vsObjects.length &&
                      this.pose &&
                      this.pose.mode === this.showCaseTemp.showcase.Mode.Mode.INSIDE
                    ) {
                      const { THREE } = this;
                      const pose = new THREE.Vector3(
                        this.pose?.position?.x,
                        this.pose?.position?.y,
                        this.pose?.position?.z,
                      );
                      const isVisibleAsset = this.vsObjects.find((asset) => {
                        const assetPose = new THREE.Vector3(
                          asset.positionX,
                          asset.positionY,
                          asset.positionZ,
                        );
                        // Multiply by 0.2 because 1 three.js unit is approximately 20cm
                        const distance = pose.distanceTo(assetPose) * 0.2;
                        return distance <= (tour.vsRenderRange || DEFAULT_VS_SENSOR_RADIUS);
                      });

                      if (isVisibleAsset) this.renderVS(this.pose);
                    }
                  } catch (err) {
                    console.error(err);
                  }
                });
              });
            },
          );
          this.setState({ isChangeIframe: false, showcaseLoaded: true });
        },
      );
    } catch (err) {
      console.error(err);
    }
  };

  private requestTwinMakerData(liveTags, rules, alarms, tour) {
    liveTags.map(async (tag) => {
      const entities = [
        {
          bindingName: 'tagInfo_treedis_reserved',
          id: tag.component?.valueDataBinding.dataBindingContext.entityId,
          componentName: tag.component?.valueDataBinding.dataBindingContext.componentName,
          propertyName: tag.component?.valueDataBinding.dataBindingContext.propertyName,
        },
      ];

      for (const entity of tag.overlay) {
        entities.push({
          bindingName: entity.bindingName,
          id: entity.valueDataBinding.dataBindingContext.entityId,
          componentName: entity.valueDataBinding.dataBindingContext.componentName,
          propertyName: entity.valueDataBinding.dataBindingContext.propertyName,
        });
      }

      // overlay data
      const res = await PublicAPI.getTwinMakerData(tour.slug, { entities });

      if (!res?.data) return;

      const { data } = res;
      let { description } = tag;
      Object.keys(data).map((bindingName) => {
        const value = data[bindingName];
        const replacedValue = description.replace(`\${${bindingName}}`, value.doubleValue);
        description = replacedValue;
      });

      // replace overlay
      this.showcase.Tag.editBillboard(tag.sid, {
        label: tag.title,
        description,
      }).catch(console.error);

      rules[alarms[tag.sid]]?.statements.map(async (statement) => {
        const { comparator, value } = this.extractAWSRule(statement.expression);
        if (comparator(data.tagInfo_treedis_reserved?.doubleValue, value)) {
          if (value == 100) {
            this.showcase.Tag.editIcon(tag.sid, `stopped__treedis`).catch((e) => {
              console.error(e);
            });
          }
          if (value == 200) {
            this.showcase.Tag.editIcon(tag.sid, `idle__treedis`).catch((e) => {
              console.error(e);
            });
          }
          if (value == 300) {
            this.showcase.Tag.editIcon(tag.sid, `running__treedis`).catch((e) => {
              console.error(e);
            });
          }
          if (value == 400) {
            this.showcase.Tag.editIcon(tag.sid, `fault__treedis`).catch((e) => {
              console.error(e);
            });
          }
        }
      });
    });
  }

  private extractAWSRule = (statement: string) => {
    // Extracting the attribute name
    const attributeNameRegex = /^([a-zA-Z0-9_]+)\s/;
    const attributeNameMatch = statement.match(attributeNameRegex);
    const attribute = attributeNameMatch ? attributeNameMatch[1] : null;

    // Extracting the numerical value and comparison operator
    const comparisonRegex = /[<>=!]=?\s?(['a-zA-Z0-9.]+)/;
    const comparisonMatch = statement.match(comparisonRegex);

    const comparisonOperator = comparisonMatch ? statement.match(/[<>=!]=?/)[0] : null;
    const numericalValue = comparisonMatch ? comparisonMatch[1] : null;

    // Convert comparisonOperator to an actual comparator
    let comparator;
    switch (comparisonOperator) {
      case '>':
        comparator = (a, b) => a > b;
        break;
      case '>=':
        comparator = (a, b) => a >= b;
        break;
      case '<':
        comparator = (a, b) => a < b;
        break;
      case '<=':
        comparator = (a, b) => a <= b;
        break;
      case '==':
        comparator = (a, b) => a === b;
        break;
      case '!=':
        comparator = (a, b) => a !== b;
        break;
      default:
        console.error('Invalid comparison operator:', comparisonOperator);
        break;
    }

    return { attribute, comparator, value: parseFloat(numericalValue) };
  };

  initScene = () => {
    let isFirstLoad = true;

    this.showCaseTemp.showcase.Sweep.current.subscribe((sweep) => {
      if (isFirstLoad && this.pose?.mode === 'mode.inside') {
        if (sweep?.sid) {
          sendToGA('event', {
            eventCategory: 'Sweep',
            eventAction: 'move',
            eventLabel: sweep.sid,
          });
        }
        isFirstLoad = false;
      }
    });

    this.showCaseTemp.tag.on(TagEventsType.OpenTagIframe, (data: any) => {
      const { event, tagId } = data;
      if (event === this.showCaseTemp.tags.matterTag.Event.CLICK) {
        this.setState({
          clickedElement: {
            id: tagId,
            type: EntityType.Tag,
          },
        });
      }
    });

    this.showCaseTemp.scene?.sceneObject.on(NodeEventsTypes.OBJECT_HOVER, ({ data, eventData }) => {
      if (this.VRPointer.component) {
        let isLockSolution = false;
        if (this.state.game?.locks) {
          this.state.game.locks.forEach((lock) => {
            if (
              lock.locationType === LockLocationType.vsItem &&
              lock.solution?.split('|').find((id) => +id === data.id)
            ) {
              isLockSolution = true;
            }
          });
        }
        if ((data.actionType !== TourActionType.None || isLockSolution) && eventData.hover) {
          this.VRPointer.component.setVisible(true);
          this.VRPointer.target = data.node;
        } else this.VRPointer.component.setVisible(false);
      }
    });

    this.showCaseTemp.scene?.sceneObject.on(NodeEventsTypes.OBJECT_CLICK, ({ data, eventData }) => {
      let isLockSolution = false;
      if (this.state.game?.locks) {
        this.state.game.locks.forEach((lock) => {
          if (
            lock.locationType === LockLocationType.vsItem &&
            lock.solution?.split('|').find((id) => +id === data.id)
          ) {
            isLockSolution = true;
          }
        });
      }
      this.setState({ isClickedElement: true });
      this.emitVSChangesFromHost({
        data,
        eventData,
        type: VSInteractionType.CLICK,
      });

      if (this.state.tourType === TourType.Game) {
        this.openVsObjectIframe(data) && this.handleVSAction(data);
      } else if (this.state.tourType === TourType.ECommerce && data?.details?.products?.length) {
        this.handleVSProduct && this.handleVSProduct(data.details);
      } else {
        this.handleVSAction(data);
      }
      sendToGA('event', {
        eventCategory: 'vsObject',
        eventAction: 'click',
        eventLabel: data.details.title,
        eventId: data.sweepUuid,
      });

      this.setState({
        clickedElement: {
          id: data.id,
          type: EntityType.VSItem,
        },
      });
    });

    this.showCaseTemp.scene.sceneImage.on(
      NodeEventsTypes.IMAGE_HOVER,
      ({ eventData, data }: any) => {
        if (this.VRPointer.component) {
          const {
            isLockSolution,
            isGeniallySolution,
            isPopUpTriviaSolution,
            isCodeSolution,
            isKeyboardSolution,
          } =
            this.state.game?.locks?.reduce(
              (acc, lock) => {
                if (
                  lock.locationType === LockLocationType.vsImage &&
                  lock.solution?.split('|').includes(`${data.id}`)
                ) {
                  acc.isLockSolution = true;
                }
                if (lock.type === LockType.Genially && lock.locationItem === `${data.id}`) {
                  acc.isGeniallySolution = true;
                }
                if (lock.type === LockType.PopUpTrivia && lock.locationItem === `${data.id}`) {
                  acc.isPopUpTriviaSolution = true;
                }
                if (lock.type === LockType.Code && lock.locationItem === `${data.id}`) {
                  acc.isCodeSolution = true;
                }
                if (lock.type === LockType.Keyboard && lock.locationItem === `${data.id}`) {
                  acc.isKeyboardSolution = true;
                }
                return acc;
              },
              {
                isLockSolution: false,
                isGeniallySolution: false,
                isPopUpTriviaSolution: false,
                isCodeSolution: false,
                isKeyboardSolution: false,
              },
            ) || {};

          if (
            data.actionType !== TourActionType.None ||
            isLockSolution ||
            isGeniallySolution ||
            isPopUpTriviaSolution ||
            isCodeSolution ||
            isKeyboardSolution
          ) {
            this.iframe.contentWindow.document.body.style.cursor = eventData.hover
              ? 'pointer'
              : 'auto';
          }

          if (
            (data.actionType !== TourActionType.None || isLockSolution || isGeniallySolution) &&
            eventData.hover
          ) {
            this.VRPointer.component.setVisible(true);
            this.VRPointer.target = data.node;
          } else this.VRPointer.component.setVisible(false);
        }
        if (data.actionType === TourActionType.None) {
          return;
        }

        this.emitVSChangesFromHost({
          data,
          eventData,
          type: VSInteractionType.HOVER,
        });

        this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? 'pointer' : 'auto';

        if (data.action === TourAction.Hover && eventData.hover) {
          this.handleVSAction(data);
        }
      },
    );

    this.showCaseTemp.scene.sceneImage.on(
      NodeEventsTypes.IMAGE_CLICK,
      async ({ eventData, data }: any) => {
        let isLockSolution = false;
        if (this.state.game?.locks) {
          this.state.game.locks.forEach((lock) => {
            if (
              lock.locationType === LockLocationType.vsImage &&
              lock.solution?.split('|').find((id) => +id === data.id)
            ) {
              isLockSolution = true;
            }
          });
        }
        this.setState({
          clickedElement: {
            id: data.id,
            type: EntityType.VSImage,
          },
        });
        this.emitVSChangesFromHost({
          data,
          eventData,
          type: VSInteractionType.CLICK,
        });
        if (this.state.tourType === TourType.Game) {
          this.openVsImageIframe(data);
        }

        sendToGA('event', {
          eventCategory: 'vsImage',
          eventAction: 'click',
          eventLabel: data.details.title,
          eventId: data.sweepUuid,
        });

        const triggerVSAnimation = () => {
          // handle trigger VS animation event
          if (data.toursVSObjectId) {
            this.showCaseTemp.scene?.sceneObject?.assets.forEach(([assetKey, node]) => {
              if (assetKey.id === data.toursVSObjectId) {
                const [, component] = node;
                component.toggleClipAnimation(!component.clipAction.isRunning());
              }
            });
          }
        };
        // handle trigger VS video event
        if (data.toursVSVideoId) {
          this.showCaseTemp.scene.sceneVideo.assets.forEach(([assetKey, node]) => {
            if (assetKey.id === data.toursVSVideoId) {
              const [_, component] = node;
              const btn = component.muteBtn;

              if (component.isMuted()) {
                audioHandler.pauseAllMusic();
                this.setState({
                  vsAudio: { component, btn },
                });
                btn.setActive(!btn.isActive());
                component.toggleMute();
              }
              if (component.video.autoplay) {
                if (btn.isActive()) {
                  const vsVideos = this.vsObjects?.filter(
                    (obj) =>
                      obj.node?.components &&
                      obj.node?.components[0]?.instance?.componentType === videoRendererType,
                  );
                  vsVideos?.forEach((obj) => {
                    const [vsVideo, muteBtn] = obj.node?.components;
                    if (!muteBtn.instance.active) {
                      vsVideo.instance.video.muted = true;
                      muteBtn.instance.active = true;
                      muteBtn.instance.makeBtn(muteBtn.instance.inputs.src);
                    }
                  });
                }
              } else if (component.video.paused) {
                component.video.play();
                component.video.muted = false;
                btn.setActive(!btn.isActive());
              }

              if (!component.video?.hasEndListener) {
                component.video.hasEndListener = true;
                component.video.addEventListener('ended', () => {
                  if (this.state.restoreAudio) {
                    audioHandler.resumeMusic();
                    this.setState({
                      restoreAudio: null,
                    });
                  }
                  btn.setActive(true);
                  component.video.muted = true;
                  // component.toggleMute(true);
                });
              }
              // else {
              //   component.video.pause();
              //   component.video.muted = true;
              // }
            }
          });
        }

        if (!data.actionType || data.actionType === TourActionType.None) {
          // do not wait when the action starts playing, if the is no action
          triggerVSAnimation();
          return;
        }
        if (data.action === TourAction.Click) {
          await this.handleVSAction(data);
          // waiting for the action to start playing
          triggerVSAnimation();
        }
      },
    );

    this.showCaseTemp.scene.sceneImage.on(
      NodeEventsTypes.AVATAR_BUTTON_HOVER,
      ({ eventData }: any) => {
        this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? 'pointer' : 'auto';
      },
    );

    this.showCaseTemp.scene.scenePolygon.on(
      NodeEventsTypes.POLYGON_CLICK,
      ({ assetId, eventData }: any) => {
        this.emitPolygonChangesFromHost({ type: VSInteractionType.CLICK, assetId, eventData });
      },
    );
    this.showCaseTemp.scene.scenePolygon.on(
      NodeEventsTypes.POLYGON_HOVER,
      ({ assetId, eventData }: any) => {
        this.emitPolygonChangesFromHost({ type: VSInteractionType.HOVER, assetId, eventData });
      },
    );

    this.showCaseTemp.scene.scenePolygon.on(
      NodeEventsTypes.POLYGON_EVENTS,
      ({ type, component, eventData, data }: any) => {
        const handleAction = (action: PolygonAction, eventType: string, eventData) => {
          if (!action) {
            return;
          }
          if (action.type === PolygonActionType.None) {
            return;
          }
          if (
            action.action === PolygonActionAction.Hover &&
            eventType === VSInteractionType.HOVER &&
            eventData.hover
          ) {
            this.handlePolygonAction(action);
          }
          if (
            action.action === PolygonActionAction.Click &&
            eventType === VSInteractionType.CLICK
          ) {
            this.handlePolygonAction(action);
          }
        };

        const isECommerceTour = this.state.tourType === TourType.ECommerce;

        if (type === VSInteractionType.HOVER) {
          this.iframe.contentWindow.document.body.style.cursor = eventData.hover
            ? 'pointer'
            : 'auto';
          if (this.VRPointer.component) {
            let isLockSolution = false;
            if (this.state.game?.locks) {
              this.state.game.locks.forEach((lock) => {
                if (
                  lock.locationType === 'transparentBox' &&
                  lock.solution?.split('|').find((id) => +id === data.id)
                ) {
                  isLockSolution = true;
                }
              });
            }
            if ((data.actionType !== TourActionType.None || isLockSolution) && eventData.hover) {
              this.VRPointer.component.setVisible(true);
              this.VRPointer.target = component;
            } else this.VRPointer.component.setVisible(false);
          }
        }

        if (type === VSInteractionType.CLICK) {
          let isLockSolution = false;
          if (this.state.game?.locks) {
            this.state.game.locks.forEach((lock) => {
              if (
                lock.locationType === 'transparentBox' &&
                lock.solution?.split('|').find((id) => +id === data.id)
              ) {
                isLockSolution = true;
              }
            });
          }

          const { polygons } = this.state;
          let updatedPolygons = [...polygons];
          const action = data.polygonsActions.find((i) => i.mode === PolygonActionMode.VS);
          const polygonAction = new PolygonAction(action);
          const foundPolygon = polygons.find(
            (p) => p.id === polygonAction.polygonId && p.hideAfterClick,
          );
          if (foundPolygon) {
            const nodeIndex = this.modelNodes.findIndex(
              (node: any) => node[0]?.obj3D?.uuid === foundPolygon.uuid,
            );
            if (nodeIndex >= 0) {
              this.modelNodes[nodeIndex][0].stop();
              foundPolygon.uuid = null;
              foundPolygon.isHiddenAfterClick = true;
              this.modelNodes.splice(nodeIndex, 1);

              updatedPolygons = polygons.map((polygon) => {
                if (polygon.id === polygonAction.polygonId) {
                  return foundPolygon;
                }
                return polygon;
              });
            }
          }
          this.setState({
            clickedElement: {
              id: data?.id || data?.id,
              type: EntityType.Polygon,
              polygons: updatedPolygons,
            },
          });
          sendToGA('event', {
            eventCategory: 'Polygon',
            eventAction: 'click',
            eventLabel: data.title,
            eventId: data.sweep_uuid,
          });
        }
        if (this.isGameTour()) {
          if (type === VSInteractionType.CLICK) {
            const action = data.polygonsActions.find((i) => i.mode === PolygonActionMode.VS);
            const polygonAction = new PolygonAction(action);
            handleAction(polygonAction, type, eventData);

            // @ts-ignore
            const result = this.handlePolygonLock && this.handlePolygonLock(data.id);
            this.unlockChapter && this.unlockChapter(data, ChapterType.Polygon);
            if (result) {
              if (
                polygonAction.gameBackpack &&
                !this.state.polygonsBackpack.find(({ id }) => data.id === id)
              ) {
                this.setState({
                  polygonsBackpack: [data, ...this.state.polygonsBackpack],
                });
              }
            } else if (result === undefined) {
              component.setSelection();
            }
          }
        } else if (isECommerceTour && data.products.length && type === VSInteractionType.CLICK) {
          this.handlePolygonProduct && this.handlePolygonProduct(data);
        } else {
          const action = data.polygonsActions.find((i) => i.mode === PolygonActionMode.VS);
          handleAction(new PolygonAction(action), type, eventData);
        }
      },
    );

    this.showCaseTemp.scene.sceneVideo.on(
      NodeEventsTypes.VIDEO_HOVER,
      ({ data, eventData }: any) => {
        this.emitVSChangesFromHost({
          data,
          eventData,
          type: VSInteractionType.HOVER,
        });
      },
    );

    this.showCaseTemp.scene.sceneVideo.on(
      NodeEventsTypes.VIDEO_CLICK,
      ({ data, eventData }: any) => {
        const { flowIsActive } = this.state;

        this.emitVSChangesFromHost({
          data,
          eventData,
          type: VSInteractionType.CLICK,
        });

        sendToGA('event', {
          eventCategory: 'vsVideo',
          eventAction: 'click',
          eventLabel: data.details.title,
          eventId: data.sweepUuid,
        });

        if (data.effectHide && !flowIsActive) {
          this.setVSVisible(data, false);
        }

        this.subscribeToStartTriggerVSAfterAnimation(data);

        if (this.state.tourType === TourType.Game) {
          this.openVsVideoIframe(data);
        }
        this.setState({
          clickedElement: {
            id: data.id,
            type: EntityType.VSVideo,
          },
        });
      },
    );

    this.showCaseTemp.scene.sceneTeleport.on(
      NodeEventsTypes.TELEPORT_CLICK,
      ({ assetId, data, eventData, component }: any) => {
        this.handleTeleportClick(data.sweep);
      },
    );
    this.showCaseTemp.scene.sceneTeleport.on(
      NodeEventsTypes.TELEPORT_HOVER,
      ({ assetId, data, eventData, component }: any) => {
        this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? 'pointer' : 'auto';
      },
    );

    this.showCaseTemp.scene.sceneVideo.on(
      NodeEventsTypes.VIDEO_BUTTON_HOVER,
      ({ eventData, data }: any) => {
        this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? 'pointer' : 'auto';
        if (this.VRPointer.component) {
          if (data.actionType !== TourActionType.None && eventData.hover) {
            this.VRPointer.component.setVisible(true);
            this.VRPointer.target = data.node;
          } else this.VRPointer.component.setVisible(false);
        }
      },
    );

    this.showCaseTemp.scene.sceneVideo.on(
      NodeEventsTypes.VIDEO_BUTTON_CLICK,
      this.handleVideoButtonClick,
    );

    this.showCaseTemp.scene.sceneVideo.on(
      NodeEventsTypes.UNMUTE_AFTER_START,
      this.handleUnmuteAfterStart,
    );
  };

  handleUnmuteAfterStart = ({ eventData, data, component, btnComponent }) => {
    if (this.isTourReadyForAudio()) {
      // delay to let other audio code run before for proper interaction
      setTimeout(() => this.handleVideoLoaded({ eventData, data, component, btnComponent }), 500);
    } else {
      setTimeout(
        () => this.handleUnmuteAfterStart({ eventData, data, component, btnComponent }),
        500,
      );
    }
  };

  handleVideoLoaded({ eventData, data, component }: any) {
    // unmute if mute button is hidden
    if (component.muteBtn?.inputs.size === 0) component.toggleMute(component.inputs.isDefaultMuted);
    if (!component.inputs.autoplay) {
      component.toggleMute(false);
      if (component.muteBtn.button) {
        component.muteBtn.button.visible = true;
        if (!DeviceManager.isIOS()) component.muteBtn.setActive(false);
      }
    } else {
      component.play();
    }
  }

  muteVSVideo = (node: any) => {
    const { video, muteBtn } = node;

    if (video && muteBtn) {
      video.muted = true;
      muteBtn.active = true;
      muteBtn.makeBtn(muteBtn.inputs.src);
    }
  };

  muteAllVsVideos = (currentVideoId?: number) => {
    const vsVideos = this.vsObjects?.filter((obj) => obj.node?.componentType === videoRendererType);
    vsVideos?.forEach((obj) => {
      if (currentVideoId && obj.id === currentVideoId) return;
      this.muteVSVideo(obj.node);
    });
  };

  handleVideoButtonClick = ({
    eventData,
    data,
    component,
    btnComponent,
    preventEmit = false,
  }: any) => {
    if (component.isMuted()) {
      audioHandler.pauseAllMusic();

      this.setState({
        vsAudio: { component, btn: btnComponent },
      });
    }

    if (btnComponent.inputs.type === 'mute') {
      const { video } = data.node;
      // This logic was muting all videos when one video was un-muted, but since now videos are paused when another video is played, this logic is not needed anymore
      // Keeping it commented out until we refactor the Music logic

      // if (btnComponent.isActive()) {
      //   const vsVideos = this.vsObjects?.filter((obj) => obj.node?.componentType === videoRendererType);
      //   vsVideos?.forEach((obj) => {
      //     const { video: vsVideo, muteBtn } = obj.node;
      //     if (muteBtn && !muteBtn.active) {
      //       vsVideo.muted = true;
      //       muteBtn.active = true;
      //       muteBtn.makeBtn(muteBtn.inputs.src);
      //     }
      //   });
      // }
      if (!video.paused) {
        component.toggleMute();
        this.muteAllVsVideos(data.id);

        emitter.emit(MittEvents.AUDIO_MUTE, { mute: false });
      }
    }

    if (btnComponent.inputs.type === 'play') {
      const { video, muteBtn } = data.node;
      // Play vsVideo
      if (video.paused) {
        // If a video has been played, mute all other videos
        audioHandler.pauseAllMusic();
        this.muteAllVsVideos(data.id);
        video.play();
        video.muted = false;
        video.volume = audioHandler.getVolume();
        muteBtn.setActive(false);
      } else {
        // Pause vsVideo
        video.pause();
        if (DeviceManager.isIOS()) component.muteBtn.setActive(true);
      }
    }

    if (!component.video?.hasEndListener) {
      component.video.hasEndListener = true;
      component.video.addEventListener('ended', (event) => {
        if (this.state.restoreAudio) {
          audioHandler.resumeMusic();
          this.setState({
            restoreAudio: null,
          });
        }
        btnComponent.setActive(true);
        component.video.muted = true;
        // component.toggleMute(true);
      });
    }
    btnComponent.setActive(!btnComponent.isActive());

    if (!preventEmit) {
      socket.emit('vs', {
        vsVideoId: data.id,
        eventData,
        type: NodeEventsTypes.VIDEO_BUTTON_CLICK,
        btnType: btnComponent.inputs.type,
      });
    }
  };

  initObjectNode = async (asset: VSTourAsset) => {
    /** helper method for different render functions */

    let node;

    // render the VS object
    if (asset instanceof TourImage) {
      const showAssetAfterAnimation =
        asset?.toursVSObjectIdAfterAnimation || asset?.toursVSVideoIdAfterAnimation;
      node = await this.initImageNode(asset);
      node[1].animate = true;
      if ((this.isGameTour() || showAssetAfterAnimation) && node && node.length === 2)
        node[1].animate = true;
    } else if (asset instanceof TourVideo) {
      node = await this.initVideoNode(asset);
      // TODO Hardcoded pipes for TB-2112

      if (this.getValueOnWindowLocationObject('href').includes('m=y9vZoA57wQs') && this.pipesData) {
        if (asset.details.title === 'Pressure.mp4')
          initPolygonUpdateFromVideo(asset, node, this.pipesData, this.THREE, this.renderer, 1);
      }
      if (this.getValueOnWindowLocationObject('href').includes('m=cKEUCfKQmHn') && this.pipesData) {
        if (asset.details.title === 'Pressure.mp4')
          initPolygonUpdateFromVideo(asset, node, this.pipesData, this.THREE, this.renderer, 0);
        if (asset.details.title === 'Pressure2.mp4')
          initPolygonUpdateFromVideo(asset, node, this.pipesData, this.THREE, this.renderer, 1);
        if (asset.details.title === 'Pressure3.mp4')
          initPolygonUpdateFromVideo(asset, node, this.pipesData, this.THREE, this.renderer, 2);
      }
    } else if (asset instanceof TourVSHtml) {
      node = await this.initVSHtmlNode(asset);
    } else {
      node = await this.initNode(asset);
      if (this.isGameTour() && node && node.length === 2) node[1].animate = true;
    }

    if (node && node.length === 2) {
      return node[1];
    }

    return null;
  };

  setVSVisible = async (
    vsObject: any,
    visible: boolean,
    trigger: vsTriggerType.revealCondition | vsTriggerType.default = vsTriggerType.default,
  ) => {
    try {
      const isVideo = vsObject instanceof TourVideo;
      const { flowIsActive } = this.state;
      // isVisible is needed to know which videos to play on IS unmount
      if (isVideo) {
        const index = this.vsObjects.findIndex((item) => item.id === vsObject.id);
        if (index !== -1) (this.vsObjects[index] as TourVideo).isVisible = visible;
      }

      if (vsObject?.videoPlayedOnce && visible && !flowIsActive) {
        return;
      }

      if (visible && !vsObject.started) {
        if (trigger === vsTriggerType.revealCondition && vsObject.delay) {
          setTimeout(async () => {
            vsObject.started = true; // we do it here because initObjectNode can take time
            vsObject.node = await this.initObjectNode(vsObject);
            if (vsObject.node?.video && vsObject.node.inputs.autoplay) {
              vsObject.node.play();
            }
            this.subscribeToStartTriggerVSAfterAnimation(vsObject);
            this.deferVisibilityVSObjectRef.current.filter((item) => item.id !== vsObject.id);
          }, vsObject.delay * 1000);
          this.deferVisibilityVSObjectRef.current = [
            ...this.deferVisibilityVSObjectRef.current,
            vsObject,
          ];
        } else {
          vsObject.started = true; // we do it here because initObjectNode can take time
          vsObject.node = await this.initObjectNode(vsObject);
          if (vsObject.node?.video && vsObject.node.inputs.autoplay && !this.state.startScreenOn) {
            vsObject.node.play();
          }
          this.subscribeToStartTriggerVSAfterAnimation(vsObject);
          /// TODO REMOVE AFTER TOUR-LOADER WILL RETURN node.remove
          // vsObject.node.obj3D.visible = true;
          /// END_OF_TODO

          if (vsObject.isAIAvatar) {
            const aiAvatarId = vsObject.id.toString();

            if (!this.aiAvatars.has(aiAvatarId)) {
              await this.createAIAvatar(vsObject);
            }
          }
        }
      } else if (!visible && vsObject?.started && vsObject.node) {
        vsObject.started = false;
        /// TODO REMOVE AFTER TOUR-LOADER WILL RETURN node.remove
        // vsObject.node.obj3D.visible = false;
        /// END_OF_TODO

        if (vsObject.isAIAvatar) {
          const aiAvatarId = vsObject.id.toString();
          this.destroyAIAvatar(aiAvatarId);
        }

        let vsObjectType = SceneInitEventsTypes.Object;
        if (vsObject instanceof TourImage) {
          vsObjectType = SceneInitEventsTypes.Image;
        } else if (vsObject instanceof TourVideo) {
          if (vsObject.hideOnAnimationFinished) {
            vsObject.videoPlayedOnce = true;
          }
          vsObjectType = SceneInitEventsTypes.Video;
        } else if (vsObject instanceof TourVSHtml) {
          vsObjectType = SceneInitEventsTypes.HTML;
        }
        if (vsObjectType && vsObject) {
          this.showCaseTemp?.scene?.remove(vsObjectType, vsObject);
        }
      }
    } catch (e) {
      console.error(e.message);
    }
  };

  changeGameCondition = (id: number, key: string, state: boolean) => {
    const condition = this.state.game.conditions.find((condition) => condition.id === id);
    const filteredConditions = this.state.game.conditions.filter(
      (condition) => condition.id !== id,
    );
    const { game } = this.state;
    if (!condition) return;
    condition[key] = state;
    game.conditions = [...filteredConditions, condition];
    this.setState({ game });
  };

  filterVsElementsByGameCondition = () => {
    const startGameHideConditions: GameCondition[] = this.state.game.conditions.filter(
      (condition: GameCondition) =>
        !condition.lock_ids.length && condition.conditionType === ConditionType.HIDE,
    );
    const gameHideConditions: GameCondition[] = this.state.game.conditions.filter(
      (condition: GameCondition) => {
        return condition.isHidden && condition.conditionType === ConditionType.HIDE;
      },
    );
    const gameRevealConditions: GameCondition[] = this.state.game.conditions
      .filter((condition: GameCondition) => {
        return condition.isRevealed && condition.conditionType === ConditionType.REVEAL;
      })
      .reduce(
        (
          acc: GameCondition[],
          condition: GameCondition,
          currentIndex: number,
          items: GameCondition[],
        ) => {
          const itemsEntityIds = this.state.game.conditions
            .filter(
              (item) =>
                item.entity_type === condition.entity_type &&
                item.isHidden &&
                item.lock_ids.length &&
                item.conditionType === ConditionType.HIDE,
            )
            .reduce((acc: number[], item: GameCondition) => {
              return [...acc, ...item.entity_ids];
            }, []);
          return [
            ...acc,
            {
              ...condition,
              entity_ids: condition.entity_ids.filter(
                (entityId) => !itemsEntityIds.includes(entityId),
              ),
            },
          ];
        },
        [],
      );

    let vsItemsToHide: number[] = [];
    let vsVideosToHide: number[] = [];
    let vsImagesToHide: number[] = [];
    let vsHTMLsToHide: number[] = [];
    let polygonsToHide: string[] = [];
    startGameHideConditions.forEach((condition: GameCondition) => {
      if (!condition.entity_ids) return;
      if (condition.entity_type === EntityType.Polygon) {
        polygonsToHide = [...polygonsToHide, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSItem) {
        vsItemsToHide = [...vsItemsToHide, ...condition.entity_ids].map((item) => +item);
      } else if (condition.entity_type === EntityType.VSVideo) {
        vsVideosToHide = [...vsVideosToHide, ...condition.entity_ids].map((item) => +item);
      } else if (condition.entity_type === EntityType.VSImage) {
        vsImagesToHide = [...vsImagesToHide, ...condition.entity_ids].map((item) => +item);
      } else if (condition.entity_type === EntityType.VSHTML) {
        vsHTMLsToHide = [...vsHTMLsToHide, ...condition.entity_ids].map((item) => +item);
      }
    });
    gameHideConditions.forEach((condition: GameCondition) => {
      if (!condition.entity_ids) return;
      if (condition.entity_type === EntityType.Polygon) {
        polygonsToHide = [...polygonsToHide, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSItem) {
        vsItemsToHide = [...vsItemsToHide, ...condition.entity_ids].map((item) => +item);
      } else if (condition.entity_type === EntityType.VSVideo) {
        vsVideosToHide = [...vsVideosToHide, ...condition.entity_ids].map((item) => +item);
      } else if (condition.entity_type === EntityType.VSImage) {
        vsImagesToHide = [...vsImagesToHide, ...condition.entity_ids].map((item) => +item);
      } else if (condition.entity_type === EntityType.VSHTML) {
        vsHTMLsToHide = [...vsHTMLsToHide, ...condition.entity_ids].map((item) => +item);
      }
    });
    gameRevealConditions.forEach((condition: GameCondition) => {
      if (!condition.entity_ids) return;
      if (condition.entity_type === EntityType.Polygon) {
        polygonsToHide = polygonsToHide.filter((el) => !condition.entity_ids.includes(el));
      } else if (condition.entity_type === EntityType.VSItem) {
        vsItemsToHide = vsItemsToHide.filter((el) => !condition.entity_ids.includes(`${el}`));
      } else if (condition.entity_type === EntityType.VSVideo) {
        vsVideosToHide = vsVideosToHide.filter((el) => !condition.entity_ids.includes(`${el}`));
      } else if (condition.entity_type === EntityType.VSImage) {
        vsImagesToHide = vsImagesToHide.filter((el) => !condition.entity_ids.includes(`${el}`));
      } else if (condition.entity_type === EntityType.VSHTML) {
        vsHTMLsToHide = vsHTMLsToHide.filter((el) => !condition.entity_ids.includes(`${el}`));
      }
    });
    this.deferVisibilityVSObjectRef.current.forEach(({ id, isVSImage, isVSVideo, isVSHtml }) => {
      if (isVSImage) {
        vsImagesToHide.push(id);
      } else if (isVSVideo) {
        vsVideosToHide.push(id);
      } else if (isVSHtml) {
        vsHTMLsToHide.push(id);
      }
    });

    return {
      startGameHideConditions,
      vsItemsToHide,
      vsVideosToHide,
      vsImagesToHide,
      vsHTMLsToHide,
    };
  };

  initVS = async () => {
    /** method for sensors processing, LOD and other calculations */
    const { isVSReady, flows, mainFlow } = this.state;

    if (!isVSReady) return; // VS should be initialized for using!

    if (this.isGameTour()) {
      const { vsImagesToHide, vsItemsToHide, vsVideosToHide, vsHTMLsToHide } =
        this.filterVsElementsByGameCondition();
      const filteredVsObjects = this.vsObjects.filter(
        (item) =>
          (item instanceof TourImage && !vsImagesToHide.includes(item.id)) ||
          (item instanceof TourObject && !vsItemsToHide.includes(item.id)) ||
          (item instanceof TourVideo && !vsVideosToHide.includes(item.id)) ||
          (item instanceof TourVSHtml && !vsHTMLsToHide.includes(item.id)),
      );
      filteredVsObjects.forEach((obj: any) => {
        this.loadingQueue.enqueue(async () => {
          try {
            if (obj?.toursVSObjectIdAfterAnimation || obj?.toursVSVideoIdAfterAnimation) {
              // Those checks are necessary because of the case when object is hidden by game condition but is connected to another object which is not hidden via afterAnimation
              if (obj.toursVSObjectIdAfterAnimation) {
                const o1 = filteredVsObjects.find(
                  (item) => item.id === obj.toursVSObjectIdAfterAnimation,
                );
                await this.setVSVisible(o1, o1 != undefined); // if o1 is not in filteredVsObjects, it means that it was hidden by game condition, so should not be showned
              }
              if (obj.toursVSVideoIdAfterAnimation) {
                const o2 = filteredVsObjects.find(
                  (item) => item.id === obj.toursVSVideoIdAfterAnimation,
                );
                await this.setVSVisible(o2, o2 != undefined); // if o2 is not in filteredVsObjects, it means that it was hidden by game condition, so should not be showned
              }
              await this.setVSVisible(obj, false);
            } else if (this.THREE) {
              const pose = new this.THREE.Vector3(
                this.pose?.position?.x,
                this.pose?.position?.y,
                this.pose?.position?.z,
              );
              const assetPose = new this.THREE.Vector3(obj.positionX, obj.positionY, obj.positionZ);
              // Multiply by 0.2 because 1 three.js unit is approximately 20cm
              const distance = pose.distanceTo(assetPose) * 0.2;
              const inRange =
                distance <=
                (obj?.renderRange || this.state.tour?.vsRenderRange || DEFAULT_VS_SENSOR_RADIUS);
              if (inRange) {
                await this.setVSVisible(obj, true);
              } else {
                await this.setVSVisible(obj, false);
              }
            }

            // Hardcoded for Georgia Pacific TB-2219
            if (this.isGeorgiaPacificTour) {
              this.processGeorgiaPacificTour();
            }

            this.loadingQueue.dequeue();
          } catch (err) {
            console.error(err);
            this.loadingQueue.dequeue();
          }
        });
      });
    } else if (flows.length && mainFlow) {
      const startStep = mainFlow.steps.find((step) => step.type === 'start_step');
      const condition = startStep.conditions.find((condition) => condition.action === 'start');
      let filteredVsObjects = this.vsObjects;
      if (condition) {
        //start condition always has 1 row
        const vsImagesToHide = condition?.rows[0]?.vsItems
          ?.filter((item) => item.includes('image'))
          .map((item) => parseInt(item.replace('image_', '')));
        const vsVideosToHide = condition?.rows[0]?.vsItems
          ?.filter((item) => item.includes('video'))
          .map((item) => parseInt(item.replace('video_', '')));
        const vsHTMLsToHide = condition?.rows[0]?.vsItems
          ?.filter((item) => item.includes('html'))
          .map((item) => parseInt(item.replace('html_', '')));
        const vsItemsToHide = condition?.rows[0]?.vsObjects;

        filteredVsObjects = this.vsObjects.filter(
          (item) =>
            (item instanceof TourImage && !vsImagesToHide.includes(item.id)) ||
            (item instanceof TourObject && !vsItemsToHide.includes(String(item.id))) ||
            (item instanceof TourVideo && !vsVideosToHide.includes(item.id)) ||
            (item instanceof TourVSHtml && !vsHTMLsToHide.includes(item.id)),
        );
      }

      filteredVsObjects.forEach((obj: any) => {
        this.loadingQueue.enqueue(async () => {
          try {
            if (this.THREE) {
              await this.setVSVisible(obj, true); //we show VS Object regardless of distance because flows said so!
              //The rest of the checks like game, for hidden after animation, will be added as conditions in flows. We ignore for now.
            }

            // Hardcoded for Georgia Pacific TB-2219
            if (this.isGeorgiaPacificTour) {
              this.processGeorgiaPacificTour();
            }

            this.loadingQueue.dequeue();
          } catch (err) {
            console.error(err);
            this.loadingQueue.dequeue();
          }
        });
      });
    } else {
      this.renderVS(this.pose);
    }
  };

  processGeorgiaPacificTour() {
    // If all required assets are present, init ControllerNode
    if (this.state.gameStatus === 'started' && !this.hasController) {
      const titlesToKeys = {
        'Under curl bar reversed.mp4': 'targetDecrease',
        'Under curl bar.mp4': 'targetIncrease',
        'plates_ok.png': 'resultOk',
        'q_early.png': 'qEarly',
        'q_early_success.png': 'qEarlySuccess',
        'q_early_fail.png': 'qEarlyFail',
        'q_late.png': 'qLate',
        'q_late_success.png': 'qLateSuccess',
        'q_late_fail.png': 'qLateFail',
        'q1.png': 'q1',
        'q1_success.png': 'q1Success',
        'q1_fail.png': 'q1Fail',
        'Paper rolling': 'paperRolling',
        'Front of plates': 'frontOfPlates',
        'Front of plates squished': 'frontOfPlatesSquished',
        'completed.png': 'completedImage',
        'Up Curl - Bad': 'upCurlBad',
        'Good Curl': 'upCurlGood',
      };

      const results = this.vsObjects.reduce((acc, obj) => {
        const key = titlesToKeys[obj.details?.title];
        if (key) acc[key] = obj;
        return acc;
      }, {} as any);

      const allKeysExist = Object.values(titlesToKeys).every((key) => results[key]?.node);

      // hiding early because GP component is initialized after tour is loaded and interactable
      if (results.qEarly.node?.pivot) results.qEarly.node.pivot.visible = false;
      if (results.qEarlySuccess.node?.pivot) results.qEarlySuccess.node.pivot.visible = false;
      if (results.qEarlyFail.node?.pivot) results.qEarlyFail.node.pivot.visible = false;
      if (results.q1Success.node?.pivot) results.q1Success.node.pivot.visible = false;
      if (results.q1Fail.node?.pivot) results.q1Fail.node.pivot.visible = false;
      if (results.qLate.node?.pivot) results.qLate.node.pivot.visible = false;
      if (results.qLateSuccess.node?.pivot) results.qLateSuccess.node.pivot.visible = false;
      if (results.qLateFail.node?.pivot) results.qLateFail.node.pivot.visible = false;
      if (results.resultOk.node?.root) results.resultOk.node.root.visible = false;
      if (results.completedImage.node?.pivot) results.completedImage.node.pivot.visible = false;
      if (results.frontOfPlates.node?.root) results.frontOfPlates.node.root.visible = false;

      if (allKeysExist) {
        this.initGeorgiaPacificGameTour(results);
        this.hasController = true;
      }
    }

    // If Quiz1 is completed, overwrite 'Q1_show' polygon onClick event to show plate status instead of quiz
    if (
      this.state.lockSolved?.lock.name === 'q1_complete' &&
      this.showCaseTemp.scene.sceneController &&
      !this.showCaseTemp.scene.sceneController.active
    ) {
      this.showCaseTemp.scene.sceneController.active = true;
      const polygonShow = this.state.polygons.find((polygon) => polygon.title === 'Q1_show');
      this.showCaseTemp.scene.scenePolygon.assets.get(polygonShow.id)[1].onEvent = (
        type,
        eventData,
      ) => {
        if (
          type === ComponentInteractionType.CLICK &&
          this.showCaseTemp.scene.sceneController.active
        ) {
          this.showCaseTemp.scene.sceneController.result.early.node.pivot.visible = true;
          this.showCaseTemp.scene.sceneController.result.ok.node.pivot.visible = true;
          this.showCaseTemp.scene.sceneController.result.late.node.pivot.visible = true;
        }
      };
    }
  }

  async initGeorgiaPacificGameTour(results) {
    const {
      targetIncrease,
      targetDecrease,
      resultOk,
      qEarly,
      qEarlySuccess,
      qEarlyFail,
      qLate,
      qLateSuccess,
      qLateFail,
      q1,
      q1Success,
      q1Fail,
      paperRolling,
      frontOfPlates,
      frontOfPlatesSquished,
      completedImage,
      upCurlBad,
      upCurlGood,
    } = results;

    const getPolygonArr = (str: string) => {
      const keys = this.state.polygons
        .filter((polygon) => polygon.title.includes(str))
        .sort((a, b) => {
          const numA = parseInt(a.title.match(/\d+$/)[0], 10);
          const numB = parseInt(b.title.match(/\d+$/)[0], 10);

          return numA - numB;
        })
        .map((el) => {
          return el.id;
        });

      // Convert map keys to an array
      const mapKeysArray = Array.from(this.showCaseTemp.scene.scenePolygon.assets.keys());

      // Filter keysArray based on mapKeysArray
      const filteredKeys = keys.filter((key) => mapKeysArray.includes(key));

      // Then map filteredKeys to values in the map
      return filteredKeys.map((key) => this.showCaseTemp.scene.scenePolygon.assets.get(key)[1]);
    };

    const q1Polygons = getPolygonArr('Q1_option');
    const qEarlyPolygons = getPolygonArr('Q_early_option');
    const qLatePolygons = getPolygonArr('Q_late_option');
    const completePolygon = getPolygonArr('complete_polygon');

    const asset = {
      scaleX: 1,
      scaleY: 1,
      scaleZ: 1,
      positionX: 0,
      positionY: 0,
      positionZ: 0,
      rotationX: 0,
      rotationY: 0,
      rotationZ: 0,
      targetDecrease,
      targetIncrease,
      q1: {
        default: q1,
        success: q1Success,
        fail: q1Fail,
        polygons: q1Polygons,
        solutionIndex: 0,
      },
      q_early: {
        default: qEarly,
        success: qEarlySuccess,
        fail: qEarlyFail,
        polygons: qEarlyPolygons,
        solutionIndex: 1,
      },
      q_late: {
        default: qLate,
        success: qLateSuccess,
        fail: qLateFail,
        polygons: qLatePolygons,
        solutionIndex: 1,
      },
      result: {
        ok: resultOk,
      },
      paperMachineVideoAssets: [
        paperRolling,
        frontOfPlates,
        frontOfPlatesSquished,
        upCurlBad,
        upCurlGood,
      ],
      startOutroVideo: this.startOutroVideo.bind(this),
      completed: {
        image: completedImage,
        polygons: completePolygon,
      },
      context: {
        showcase: this.showCaseTemp,
        camera: this.camera,
        renderer: this.renderer,
        iframe: this.iframe,
      },
    };

    await this.showCaseTemp.scene.create(SceneInitEventsTypes.Controller, asset);

    this.showCaseTemp.scene.sceneController.on(
      NodeEventsTypes.CONTROLLER_MODEL_CLICK,
      async ({ data }: any) => {
        await this.moveToSweep('c1c38440428f485d9487045fa0ba9cf4', { x: 60, y: 180 }, 'FLY');
      },
    );
  }

  startOutroVideo() {
    this.setState({ gameStatus: GameStatus.OutroClip });
  }

  stopVS = async () => {
    try {
      this.vsObjects.map((asset: any) => {
        this.setVSVisible(asset, false);
      });
    } catch (e) {
      console.error(e);
    }
  };

  initPolygons = async () => {
    this.loadingQueue.enqueue(async () => {
      try {
        const promises = this.state.polygons.map(async (item: Polygon) => {
          if (!item.active || item.hiddenFromFlows) {
            return item;
          }
          if (!item.uuid) {
            const node = await this.initPolygonNode(item);
            console.log('push node');
            this.modelNodes.push(node);
            item.uuid = node[0].obj3D.uuid;
            return item;
          }
          return item;
        });
        const polygons = await Promise.all(promises);
        if (this.state.waitLoadingPolygons) {
          this.setState({ gameStatus: GameStatus.Started });
        }
        if (!_isEqual(polygons, this.state.polygons)) {
          this.setState({
            polygons,
          });
        }
        this.loadingQueue.dequeue();
      } catch (err) {
        console.error(err);
        this.loadingQueue.dequeue();
      }
    });
  };

  initPatch(url) {
    this.showCaseTemp.scene.create(SceneInitEventsTypes.Patch, {
      url,
      opacity: 0.6,
    });
  }

  async initBarriers(barriers) {
    if (!barriers?.length) return { barriers: [], barrierNodes: [] };
    const barrierNodes = await Promise.all(
      barriers
        .filter((barrier) => barrier.enabled)
        .map(async (barrier) => {
          const node = await this.showCaseTemp.scene.create(SceneInitEventsTypes.Barrier, {
            ...barrier,
            colorDefault: '#ea475c',
            colorHover: '#ea475c',
            colorClick: '#ea475c',
            opacityDefault: 0,
            opacityHover: 0,
            opacityClick: 0,
          });
          return node;
        }),
    );
    return { barriers, barrierNodes };
  }

  async initCustomSweeps(customSweeps) {
    if (customSweeps?.length) {
      customSweeps.forEach(async (customSweep) => {
        const res = await this.showCaseTemp.scene.create(SceneInitEventsTypes.CustomSweep, {
          ...customSweep,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          scaleX: 0.4,
          scaleY: 0.4,
          scaleZ: 0.4,
          opacityDefault: 0,
          opacityHover: 0,
          opacityClick: 0,
        });

        this.customSweeps.push(res);
      });
    }
    return this.customSweeps;
  }

  showTeleportLoading = (name) => {
    this.setState({ showTeleportLoading: true, endTeleportName: name });
  };

  handleTeleportClick = async (sweep, resumeAfter = false, setStep = () => {}) => {
    const path = this.showCaseTemp.navigationManager.getAutonavigationPath();
    let nextPoint;
    let endTp;

    path.some((point) => {
      this.teleportPoints.forEach((tp) =>
        tp.pointNodes.forEach((pn) => {
          if (pn.sweep === point.data.id && pn.sweep !== sweep) {
            endTp = { ...pn, type: tp.type };
            nextPoint = point;
          }
        }),
      );
      return !!endTp;
    });

    // this.teleportPoints.forEach(tp => tp.pointNodes.forEach((pn) => {
    //   if(pn.sweep === nextPoint.data.id){
    //     endTp = { ...pn, type: tp.type }
    //   }
    // }));

    if (!endTp) return;

    this.setState({
      showTeleportLoading: true,
      endTeleportName: endTp?.name || '',
      endTpType: endTp?.type || TeleportGroupType.Elevator,
    });

    await this.moveToSweep(nextPoint.data.sweepId, { x: 0, y: 0 }, 'INSTANT');

    if (path[path.length - 1]?.data?.id !== nextPoint?.data?.id) {
      setTimeout(() => {
        this.showCaseTemp.navigationManager.rotateCameraToPathDirection();
        if (resumeAfter) {
          this.setActionPathNavbarPlayButtonType('Pause');
          this.showCaseTemp.navigationManager.autoNavigateCurrentPath(
            setStep,
            () => {},
            () => {},
          );
        }
      }, 3000);
    }
  };

  async initTeleports(teleportGroups) {
    if (teleportGroups?.length) {
      teleportGroups.forEach(async (group) => {
        const pointNodes = [];
        group.points.forEach(async (point) => {
          const res = await this.showCaseTemp.scene.create(SceneInitEventsTypes.Teleport, {
            ...point,
            opacityDefault: 0.65,
            opacityHover: 0.85,
            colorDefault: '#2055FF',
            rotationX: point.rotationX || 0,
            rotationY: point.rotationY || 0,
            rotationZ: point.rotationZ || 0,
            scaleX: 0.5,
            scaleY: 0.5,
            scaleZ: 0.5,
            type: group.type,
            isTpUp: this.state.isTpUp || false,
          });
          res[0].obj3D.visible = false;
          pointNodes.push({ ...res, sweep: point.sweep, name: point.name });
          if (this.state.currentSweep?.position) {
            res[1].pivot.lookAt(
              this.state.currentSweep.position.x,
              res[0].obj3D.position.y,
              this.state.currentSweep.position.z,
            );
          }
        });
        this.teleportPoints.push({ id: group.id, pointNodes, type: group.type });
      });
    }

    return this.teleportPoints;
  }

  updateTeleportInputs() {
    if (this.teleportPoints?.length) {
      this.teleportPoints.forEach((tp) => {
        tp.pointNodes.forEach((pn) => {
          if (pn[1] && pn[1].inputs) {
            try {
              pn[1].inputs.isTpUp = this.state.isTpUp || false;
            } catch (error) {
              console.warn('Cannot update teleport inputs - object is not extensible:', error);
            }
          }
        });
      });
    }
  }

  getPolygons() {
    return this.state.polygons;
  }

  initNode = async (data: TourObject) => {
    // If vsObject is a lock solution, we need to make it clickable (enable collider)
    const enableCollider =
      this.state.game?.locks?.some((lock) => {
        return (
          lock.locationType === LockLocationType.vsItem && lock.solution === data.id.toString()
        );
      }) || this.state.flowsObjects?.some((obj) => obj.assetId === data.id);

    const res = await this.showCaseTemp.scene.create(
      SceneInitEventsTypes.Object,
      data,
      undefined,
      enableCollider,
    );
    return res.length ? res : [];
  };

  initImageNode = async (data: TourImage) => {
    const res = await this.showCaseTemp.scene.create(SceneInitEventsTypes.Image, data);
    if (!res.length) {
      return [];
    }

    return res;
  };

  initVideoNode = async (data: TourVideo) => {
    const options = {
      vimeoURL: '',
      hideMuteButton: data.autoplay && data.hideMuteButton,
      isDefaultMuted: data.hideMuteButton && data.isDefaultMuted,
      autoplay: data.autoplay,
      // end, mute, pause
      onSoundStop: () => {
        // set timeout is important to give vsVideos in audioHandler time to update their state
        setTimeout(() => {
          if (!audioHandler.isTourMusicPaused() && audioHandler.allPlayingVideosAreMuted()) {
            audioHandler.playAudio({ type: MusicObj.TOUR, id: this.state.tour.id }).then(() => {
              this.setState({ tourAudioPlaying: !audioHandler.isTourMusicPaused() });
            });
          }
        }, 100);
      },
      withButton: {
        mute: '/images/mute_icon.png',
        unMute: '/images/unmute_icon.png',
        ...(!data.autoplay && { play: '/images/play_icon.png', pause: '/images/pause_icon.png' }),
      },
    };
    const elementType = data.details.type;
    if (elementType === VSVideoType.Vimeo && this.state.tour.clientId) {
      const vimeoVideo = new VimeoVideo(
        VimeoVideo.parseVideoId(data.getVideoURL()) as unknown as string,
      );
      await vimeoVideo.loadFromVideoId(this.state.tour.clientId);
      options.vimeoURL = await PublicAPI.getVimeoVideoUrl(vimeoVideo.getFileURL());
      // const subsToReplace = {
      //   he: 'iw',
      // };
      // const subCode = this.getCurrentLanguage()?.languageCode;
      // if (subsToReplace[subCode] || subCode) options.vimeoURL += `&texttrack=${subsToReplace[subCode] || subCode}`;
    } else {
      const isValidVideoURL = await file.existFile(
        `${process.env.NEXT_PUBLIC_CDN}${data.details.url}`,
      );
      if (!isValidVideoURL && !options.vimeoURL) {
        return [];
      }
    }
    // TODO hardcoded for Georgia Pacific TB-2219
    // Update video to remove it's default controller buttons
    if (this.getValueOnWindowLocationObject('href').includes('m=mEMx41aqAaq')) {
      if (
        data.details.title === 'Under curl bar reversed.mp4' ||
        data.details.title === 'Under curl bar.mp4'
      ) {
        options.autoplay = true;
        options.hideMuteButton = true;
        options.isDefaultMuted = true;
        data.autoplay = true;
        data.hideMuteButton = true;
        data.isDefaultMuted = true;
      }

      if (
        data.details.title === 'Under curl bar reversed.mp4' ||
        data.details.title === 'Under curl bar.mp4' ||
        data.details.title === 'plates_early' ||
        data.details.title === 'plates_late' ||
        data.details.title === 'plates_ok'
      ) {
        const updatedData = {
          ...data,
          hasExternalController: true,
        };
        const res = await this.showCaseTemp.scene.create(
          SceneInitEventsTypes.Video,
          updatedData,
          options,
        );
        if (!res.length || res.length === 1) {
          return [];
        }
      }
    }
    data.hideOnAnimationFinished = data.hideOnAnimationFinished;
    const res = await this.showCaseTemp.scene.create(SceneInitEventsTypes.Video, data, options);
    if (!res.length || res.length === 1) {
      return [];
    }
    const videoNode = res[1];
    videoNode.video.volume = audioHandler.getVolume();
    audioHandler.addMusicToVolumeControl(videoNode);
    return res;
  };

  initVSHtmlNode = async (data: TourVSHtml) => {
    const isFlowsHtml = this.state.flowsObjects?.some((obj) => obj.assetId === data.id);
    const res = await this.showCaseTemp.scene.create(SceneInitEventsTypes.HTML, {
      ...data,
      isFlowsHtml,
    });
    if (!res.length || res.length === 1) {
      return [];
    }
    // On mobile, instead of interacting with HTML, open a popup with iframe
    if (DeviceManager.isMobile())
      res[1].onEvent = (type, eventData) => {
        if (type === ComponentInteractionType.CLICK) {
          this.setState({ vsHTMLPopup: { show: true, src: res[1].inputs.url } });
        }
      };

    return res;
  };

  setVsHTMLPopupShow = (show) => {
    this.setState({ vsHTMLPopup: { show, src: this.state.vsHTMLPopup.src } });
  };

  initPolygonNode = async (data: Polygon) => {
    return await this.showCaseTemp.scene.create(SceneInitEventsTypes.Polygon, data);
  };

  initAvatarNode = async (data: Avatar) => {
    const avatar = await this.showCaseTemp.scene.create(SceneInitEventsTypes.Avatar, data, {
      host: this.state.host,
      withButton: { mute: '/images/mute_icon.png', unMute: '/images/unmute_icon.png' },
    });
    avatar[1].inputs.bodyType = data.bodyType;
    return avatar;
  };

  handlePolygonProduct(polygon: any) {}

  handleVSProduct(vsObject: any) {}

  openNewTab = (url: string) => {
    const popupWindow = window.open(url);

    if (popupWindow === null || typeof popupWindow === 'undefined') {
      // Some browsers have 'Block pop-up windows' set to true by default and in these cases we show a notification for the user to turn this setting off
      toast.info('Please allow pop-ups for this site in order to view this content');
    }
  };

  // Works for VS Images and VS Objects Action Types for now
  handleVSAction = async (data: TourImage | TourObject, isObject?: boolean) => {
    const { noAudioMode, id: tourId } = this.state.tour;
    const { flowAssetsToDisableAction } = this.state;
    const { pauseAllMusic, stopTourMusic } = audioHandler;
    const assetType = data instanceof TourImage ? 'image' : 'vsObject';
    const disableActionForFlow = !!flowAssetsToDisableAction?.find(
      (a) => a.asset === assetType && a.assetId === data.id,
    );

    switch (data.actionType) {
      case TourActionType.IoT:
        if (data.action === TourAction.Click) {
          this.updateIotState({ lockDeviceId: data.id });
        }
        return;
      case TourActionType.Tab:
        if (data.action === TourAction.Hover) {
          this.openNewTab(data.actionURL);
        } else if (data.action === TourAction.Click) {
          this.openNewTab(data.actionURL);
        }
        return;
      case TourActionType.Music:
        if ((noAudioMode && this.state.room) || disableActionForFlow) return;
        if (data.action === TourAction.Hover) {
          return;
        }

        // If VSImage has Trigger VS Animation attached, then we need to check if animation is paused or playing and do the same with the audio TB-3126
        // @ts-ignore
        if (data.toursVSObjectId) {
          // @ts-ignore
          const clipAction = this.showCaseTemp.scene?.sceneObject?.assets?.find(
            ([assetKey, node]) => assetKey.id === data.toursVSObjectId,
          )?.[1]?.[1]?.clipAction;

          if (clipAction) {
            // If animation is not started yet, play audio
            if (clipAction.time === 0) {
              await audioHandler.playAudio({ type: MusicObj.VSIMAGES, id: data.id });
              // else pause or resume it
            } else if (clipAction.paused) {
              audioHandler.resumeAudio(data.id);
            } else {
              audioHandler.pauseAudio(data.id);
            }
          }
        } else {
          await audioHandler.playAudio({ type: MusicObj.VSIMAGES, id: data.id });
        }
        return;
      case TourActionType.Video:
        data.actionURL = getVideoLink(data.actionURL, {
          mute: noAudioMode && this.state.room,
        });
        if (this.state.tourType === TourType.Game) {
          await stopTourMusic;
        } else {
          pauseAllMusic();
        }
        break;
      case TourActionType.NavigationPath:
        const currentSID = this.state.currentSweep.sid || this.state.currentSweep.sweep;
        const targetSID = extractSweepIdFromURL(data.actionURL);

        if (!currentSID) {
          toast.error('Current sweep not found');
          return;
        }
        if (!targetSID) {
          toast.error('Target sweep not found');
          return;
        }

        if (this.showCaseTemp.navigationManager) {
          if (this.showCaseTemp.navigationManager.targetSID !== targetSID) {
            const allSweeps = Array.from(this.state.allSweeps, ([, value]: any) => value);
            const target = allSweeps?.find(
              (item: any) => item.sweep_uuid === targetSID || item.sweepId === targetSID,
            );
            // TODO test changes
            this.showCaseTemp.navigationManager.renderPath(currentSID, target?.id);
          } else {
            this.showCaseTemp.navigationManager.reset();
          }
        }
        break;
      case TourActionType.Treedis:
        const segments = data.actionURL.split('/');
        const slug = segments[segments.length - 1].split('?')[0];
        // get segmans from window.location.href
        const windowSegmants = window.location.href.split('/');
        const windowId = windowSegmants[windowSegmants.length - 1].split('?')[0];

        if (window.top !== window.self) {
          window.top.postMessage(
            {
              type: 'tourLink',
              url: data.actionURL,
            },
            '*',
          );
          // so the parent window can handle the link
          await new Promise((resolve) => setTimeout(resolve, 100));
        }

        if (slug !== windowId && window.location.href.includes('/experience/')) {
          window.location.href = data.actionURL;
          return;
        }

        if (getQueryVariable(data.actionURL, 'm')) {
          toast.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
          return;
        }

        const { tour } = this.state;
        const changeMinimap = tour && !tour.customMinimap;

        this.setState({ panoramaOn: false, activePano: null }, () => {
          // false = dont change the menu/panorama
          this.getTour({
            slug,
            changeMenu: false,
            changeMinimap,
            changePanorama: false,
            url: data.actionURL,
            hideIntroScreen: true,
          });
        });
        return;
      case TourActionType.Menu:
        const menuData = data as TourImage; // This case is only for TourImage
        this.setState(
          {
            menuOpen: false,
            activeMenu: null,
          },
          () => {
            this.setState({
              menuOpen: true,
              menuOpened: true,
              activeMenu: {
                menuId: menuData.menuId,
                subMenuId: menuData.subMenuId,
                subSubMenuId: menuData.subSubMenuId,
              },
            });
          },
        );
        return;
      case TourActionType.Panorama:
        this.setState({
          activePano: data.panoramaId,
          panoramaOn: true,
        });
        return;
      case TourActionType.ExperiencePopUp: {
        const menuData = data as TourImage; // This case is only for TourImage
        audioHandler.pauseAllMusic();
        this.setState({
          experiencePopUpIsOpen: true,
          closedElementPopup: false,
          experiencePopUpData: {
            title: menuData.popupTitle,
            url: menuData.actionURL,
            description: menuData.text,
            defaultImageUrl: menuData?.details?.url,
            prefixImageUrl: `/tours/${tourId}/vsimages/`,
            rotation: menuData.rotation,
            backgroundColor: menuData.backgroundColor,
            backgroundOpacity: menuData.backgroundOpacity,
            textColor: menuData.textColor,
            buttonColor: menuData.buttonColor,
          },
        });
        return;
      }
      case TourActionType.Matterport: {
        this.setState(
          {
            isChangeIframe: this.state.iframeUrl.matterId !== getQueryVariable(data.actionURL, 'm'),
          },
          () => {
            this.moveModel(
              `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase.html?applicationKey=${
                this.state.tour?.user?.mpSDK
              }${all.getAllQueryVariables(data.actionURL)}`,
              false,
              false,
            );
          },
        );
        return;
      }
      case TourActionType.MatterportInstant: {
        this.setState(
          {
            isChangeIframe: this.state.iframeUrl.matterId !== getQueryVariable(data.actionURL, 'm'),
          },
          () => {
            this.moveModel(
              `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase.html?applicationKey=${
                this.state.tour?.user?.mpSDK
              }${all.getAllQueryVariables(data.actionURL)}`,
              false,
              true,
            );
          },
        );
        return;
      }
      case TourActionType.Flow: {
        this.setState({ startFlowFromAsset: data.flowId });
        return;
      }
      case TourActionType.Gallery: {
        const galleryData = data as TourImage; // This case is only for TourImage
        this.setState({
          galleryArr: galleryData?.gallery,
        });
        return;
      }
      default:
    }

    if (data.actionType !== TourActionType.NavigationPath)
      this.setState({
        vsActionPopOn: true,
        openedVSAction: data,
        closedElementPopup: false,
      });
  };

  emitVSChangesFromHost = ({ data, eventData, type }) => {
    const { showcaseLoaded, room, host, isRemoteControlled } = this.state;
    if (
      showcaseLoaded &&
      room &&
      socket &&
      socket.connected &&
      (host || isRemoteControlled) &&
      this.pose.mode === this.showcase.Mode.Mode.INSIDE
    ) {
      const key = data.vsImageId
        ? 'vsImageId'
        : data.vsVideoId
        ? 'vsVideoId'
        : data.vsObjectId
        ? 'vsObjectId'
        : '';
      if (!key) return;
      socket.emit('vs', {
        [key]: data.id,
        eventData,
        type,
      });
    }
  };

  emitPolygonChangesFromHost = ({ type, assetId, eventData }) => {
    const { showcaseLoaded, room, host, isRemoteControlled } = this.state;
    if (
      showcaseLoaded &&
      room &&
      socket &&
      socket.connected &&
      (host || isRemoteControlled) &&
      this.pose.mode === this.showcase.Mode.Mode.INSIDE
    ) {
      socket.emit('polygon', {
        type,
        assetId,
        eventData,
      });
    }
  };

  emitTagChangesFromHost = (tag: any, action?: string) => {
    const { showcaseLoaded, room, host, isRemoteControlled } = this.state;
    if (
      tag &&
      showcaseLoaded &&
      room &&
      socket &&
      socket.connected &&
      (host || isRemoteControlled) &&
      this.pose.mode === this.showcase.Mode.Mode.INSIDE
    ) {
      if (action === 'hover') {
        socket.emit('tag_hover', {
          tag: {
            sid: tag.defaultSid || tag.sid,
            action,
          },
        });
      } else if (action === 'click') {
        socket.emit('tag_click', {
          tag: {
            sid: tag.defaultSid || tag.sid,
            action,
          },
        });
      }

      if (tag.embedMedia) {
        const watchTagContentElem = this.getShowcaseElement(ShowcaseElement.TagEmbedMedia);
        closeTagEmbedTagObserver(watchTagContentElem, () => {
          socket.emit('close-embed-tag');
        });
      }
    }
  };

  handlePolygonAction = async (data: PolygonAction) => {
    const { tour, flowAssetsToDisableAction, polygons } = this.state;
    // openedVSAction old popup
    const { noAudioMode } = tour;
    const disableActionForFlow = !!flowAssetsToDisableAction?.find(
      (a) => a.asset === 'polygon' && polygons?.find((p) => p.id === a.assetId),
    );

    if (disableActionForFlow) {
      return;
    }

    switch (data.type) {
      case PolygonActionType.Tab:
        if (data.action !== PolygonActionAction.Hover) {
          this.openNewTab(data.url);
        }
        return;
      case PolygonActionType.Music:
        if (noAudioMode && this.state.room) return;
        if (data.action === PolygonActionAction.Hover) {
          return;
        }
        await audioHandler.playAudio({ type: MusicObj.POLYGONS, id: data.id });
        return;
      case PolygonActionType.Video:
        data.url = getVideoLink(data.url, {
          mute: noAudioMode && this.state.room,
          autoplay: data.autoPlay ? 1 : 0,
        });
        audioHandler.pauseAllMusic();
        break;
      case PolygonActionType.Treedis:
        const segments = data.url.split('/');
        const slug = segments[segments.length - 1].split('?')[0];
        // get segmans from window.location.href
        const windowSegmants = window.location.href.split('/');
        const windowId = windowSegmants[windowSegmants.length - 1].split('?')[0];

        if (window.top !== window.self) {
          window.top.postMessage(
            {
              type: 'tourLink',
              url: data.url,
            },
            '*',
          );
          // so the parent window can handle the link
          await new Promise((resolve) => setTimeout(resolve, 100));
        }

        // if current tour is experience and moving to a different tour, we should change the whole location to release some memory
        if (slug !== windowId && window.location.href.includes('/experience/')) {
          window.location.href = data.url;
          return;
        }

        if (getQueryVariable(data.url, 'm')) {
          toast.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
          return;
        }
        const { tour } = this.state;
        const changeMinimap = tour && !tour.customMinimap;
        this.setState({ panoramaOn: false, activePano: null }, () => {
          // false = dont change the menu/panorama

          this.getTour({
            slug,
            changeMenu: false,
            changeMinimap,
            changePanorama: false,
            url: data.url,
            hideIntroScreen: true,
          });
        });
        return;
      case PolygonActionType.Menu:
        this.setState(
          {
            menuOpen: false,
            activeMenu: {
              menuId: null,
              subMenuId: null,
              subSubMenuId: null,
            },
          },
          () => {
            this.setState({
              menuOpen: true,
              menuOpened: true,
              activeMenu: {
                menuId: data.menuId,
                subMenuId: data.subMenuId,
                subSubMenuId: data.subSubMenuId,
              },
            });
          },
        );
        return;
      case PolygonActionType.Panorama:
        this.setState({
          activePano: data.panoramaId,
          panoramaOn: true,
        });
        return;
      case PolygonActionType.Matterport:
        this.moveModel(
          `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase.html?applicationKey=${
            this.state.tour?.user?.mpSDK
          }${all.getAllQueryVariables(data.url)}`,
          false,
          false,
        );
        return;
      case PolygonActionType.MatterportInstant:
        this.moveModel(
          `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase.html?applicationKey=${
            this.state.tour?.user?.mpSDK
          }${all.getAllQueryVariables(data.url)}`,
          false,
          true,
        );
        return;
      case PolygonActionType.ExperiencePopUp:
        this.setState({
          experiencePopUpIsOpen: true,
          closedElementPopup: false,
          experiencePopUpData: {
            title: data.popupTitle,
            url: data.actionURL,
            description: data.text,
            defaultImageUrl: '',
            prefixImageUrl: `/tours/${this.state.tour?.id}/polygons/`,
            rotation: data.rotation,
            backgroundColor: data.backgroundColor,
            backgroundOpacity: data.backgroundOpacity,
            textColor: data.textColor,
            buttonColor: data.buttonColor,
          },
        });
        return;
      case PolygonActionType.Flow:
        this.setState({ startFlowFromAsset: data.flowId });
        return;
      default:
    }

    this.setState({
      vsActionPopOn: true,
      closedElementPopup: false,
      openedVSAction: new PolygonAction(data),
    });
  };

  updateSweepLoc = (
      nextSweep: any,
      callbacks?: { onActiveSweepGroupChange: () => void,
    }) => {
    // if (this.pose?.mode && this.pose?.mode !== this.showCaseTemp.showcase.Mode.Mode.INSIDE) return;
    const { tour, sweepGroups } = this.state;
    sendToGA('event', {
      eventCategory: 'Sweep',
      eventAction: 'move',
      eventLabel: nextSweep.sid,
    });
    let activeSweepGroup = null;
    sweepGroups.forEach((group: any, i: number) => {
      group.sweeps?.forEach((sweep: any) => {
        if (sweep.uuid === nextSweep.sid) {
          activeSweepGroup = group.id;
        }
      });
    });
    this.setState(
      {
        activeSweepGroup,
      },
      () => {
        this.filterTags();
        this.filterPolygon();
        callbacks?.onActiveSweepGroupChange?.();
      },
    );
    if (tour.minimap) {
      // find nextSweep in this.state.sweeps, so we can use the old sweep.sweep_uuid which is not included anymore on SDK Sweeps..
      const nextSweepObj = this.state.sweeps?.find(
        (sweep) => sweep.id === nextSweep.sid || sweep.sweep_uuid === nextSweep.sid,
      );
      const loc: any = this.calculateLocation(nextSweepObj || nextSweep);
      if (!loc) return;
      this.setState({
        mapWalkerX: loc.px,
        mapWalkerY: loc.py,
        minimaps: loc.minimaps,
      });
    }
  };

  markMinimap = (p: any) => {
    const { minimaps, selectedMinimap } = this.state;
    if (!minimaps || minimaps.length === 0 || selectedMinimap === null) return;
    minimaps[selectedMinimap].hotspots.forEach((h: any) => {
      if (h.type === 'panorama' && h.panoramaId === p.id) {
        this.setState({
          mapWalkerX: h.x,
          mapWalkerY: h.y,
          activePano: null,
        });
      }
    });
  };

  async moveToSweepIO(p: any) {
    if (this.state.showcaseLoaded) {
      setTimeout(() => {
        if (!p.walking) {
          this.showCaseTemp.showcase.Mode.moveTo(p.mode, {
            position: p.position,
            rotation: p.rotation,
            transition: this.showCaseTemp.showcase.Mode.TransitionType.FLY,
          }).catch((e: any) => {});
        } else {
          this.showcase.Sweep.moveTo(p.sweep, {
            position: p.position,
            rotation: p.rotation,
            transition: this.showCaseTemp.showcase.Sweep.Transition.FLY,
          }).catch((e: any) => {});
        }
      }, 100);
    }
  }

  moveToTagIO(tag: any, doOpenTag = true) {
    if (this.state.showcaseLoaded) {
      this.deselectTagTimeout = setTimeout(() => {
        this.deselectTagTimeout = undefined;
      }, 2000);
      setTimeout(() => {
        const tags = Array.from(this.state.allTags.values());
        const foundTag: any = tags.find((t: any) => {
          return tag.sid && (t.sid === tag.sid || t.defaultSid === tag.sid);
        });
        if (!foundTag) {
          return;
        }
        if (this.pose.mode !== this.showCaseTemp.showcase.Mode.Mode.OUTSIDE) {
          this.showCaseTemp.showcase.Mattertag.navigateToTag(
            foundTag.sid,
            this.showCaseTemp.showcase.Mattertag.Transition.FLY,
          )
            .then(() => {
              if (doOpenTag) {
                this.openTagIframe(tag.sid);
              }
            })
            .catch((err: any) => {
              console.error(err.toString());
            });
        } else if (doOpenTag) {
          this.openTagIframe(foundTag.sid);
        }
      }, 100);
    }
  }

  isTourReadyForAudio = () => {
    const { showIntro, startScreenOn, gameStatus, tourType, avatar, tour, showcaseLoaded, room } =
      this.state;

    const isReady = !(
      !showcaseLoaded ||
      // video tour, before avatar select
      (room && tour?.enableAvatar && !avatar?.imageUrl) ||
      // regular tour, before avatar select
      (!room && tour?.enableAvatar && !avatar?.url) ||
      showIntro ||
      startScreenOn ||
      (tourType === TourType.Game && gameStatus === GameStatus.NotStarted)
    );

    return isReady;
  };

  playTourAudio = async (ignoreTimeout = false) => {
    const { videoPlaying } = this.state;
    const { isTourMusicPaused } = audioHandler;
    if (!ignoreTimeout && this.playAudioTimeout) return;
    this.playAudioTimeout = null;
    if (videoPlaying) {
      return;
    }
    if (!this.isTourReadyForAudio()) {
      this.mainContainerWaitingForPlay = true;
      this.playAudioTimeout = setTimeout(() => this.playTourAudio(true).catch(() => {}), 500);
      return this.playAudioTimeout;
    }
    if (isTourMusicPaused()) {
      await this.handleToggleMusic();
    }
    this.mainContainerWaitingForPlay = false;
  };

  moveToSweep = async (s: string, rotation: any, transition = 'INSTANT', changeUrl = true) => {
    // find the sweep so we can use both IDs depending on legacy
    const sweep = this.state?.sweeps?.find((sweep) => sweep.id === s || sweep.sweep_uuid === s);
    if (!sweep) {
      console.trace();
      console.error('Sweep not found in  list: ', s, this.state?.sweeps);
    }

    const sweepId = sweep?.id || s;

    if (this.showCaseTemp) {
      return this.showCaseTemp.showcase.Sweep.moveTo(sweepId, {
        rotation,
        transition: this.showCaseTemp.showcase.Sweep.Transition[transition],
      })
        .then(() => {
          if (asyncStore.vrIsOn) {
            if (!this.SceneVRCameraController) {
              console.error('Error: SceneVRCameraController not initialized');
              return;
            }
            const targetSweep = this.state.sweeps.find(
              (sweep) => sweep.uuid === sweepId || sweep.id === sweepId || sweep.sid === sweepId,
            );
            this.SceneVRCameraController.rotateVRViewByCameraRotation(targetSweep, rotation);
          }

          if (
            this.state.tourType !== TourType.Game &&
            this.state.tourType !== TourType.Kiosk &&
            !this.state.tour.navigationWebEnabled &&
            changeUrl
          ) {
            window.history.replaceState(null, '', this.buildLink(sweepId, rotation));
          }
        })
        .catch((err: any) => {
          console.error(err.toString());
        });
    }
    toast.error('Wait for the model to load');
  };

  moveToStep = async (step: number) => {
    if (this.showCaseTemp) {
      await this.showCaseTemp.showcase.Tour.step(step).catch((err: any) => {
        console.error(err.toString());
      });
    } else {
      toast.error('Wait for the model to load');
    }
  };

  getLogoUrl() {
    const { tour } = this.state;
    return tour && tour?.client
      ? `${process.env.NEXT_PUBLIC_CDN}/clients/${tour?.client?.id}/logo.png${all.getVersion(
          tour.client.updatedAt,
        )}`
      : '';
  }

  closeMenu = () => {
    this.setState({ menuOpen: false });
  };

  openMenu = () => {
    this.setState({ menuOpen: true });
  };

  loadModelMenu = (menu: any) => {
    this.setState({ lastTagHovered: null, activeMenu: null }, () => {
      this.loadModel(menu);
    });
  };

  changeWidthMenu = (width: number) => {
    this.setState({ menuWidth: width });
  };

  handleLockMenu = (d) => {
    this.updateIotState({ lockDeviceId: d.id });
  };

  handleMoveToLockMenu = (d) => {
    this.updateIotState({ moveToDevice: d });
  };

  handleOpenCameraMenu = ({ openCamera, multiCams }) => {
    this.updateIotState({
      openCamera: openCamera || null,
      openFavouriteCameras: multiCams || null,
    });
    this.setIotModalOpen(true, false);
    this.setState({ menuOpen: false });
  };

  injectBottomBg() {}

  stopPolygons = async () => {
    try {
      const { polygons } = this.state;

      this.setState({
        polygons: await Promise.all(
          polygons.map(async (item: Polygon) => {
            if (!item.active) return item;
            const nodeIndex = this.modelNodes.findIndex(
              (node: any) => node[0]?.obj3D?.uuid === item.uuid,
            );
            if (nodeIndex >= 0) {
              this.modelNodes[nodeIndex][0].stop();
              item.uuid = null;
              this.modelNodes.splice(nodeIndex, 1);
            }
            return item;
          }),
        ),
      });
    } catch (e) {
      console.error(e);
    }
  };

  renderPolygons = async () => {
    try {
      const { polygons } = this.state;
      await Promise.all(
        polygons.map(async (item: Polygon) => {
          if (item.hiddenFromFlows) return;
          if (!this.polygonHiddenByPathLock(item)) {
            if (item.active) {
              if (!item.uuid) {
                const node = await this.initPolygonNode(item);
                this.modelNodes.push(node);
                item.uuid = node[0].obj3D.uuid;
                return item;
              }
            } else {
              const nodeIndex = this.modelNodes.findIndex(
                (node: any) => node[0]?.obj3D?.uuid === item.uuid,
              );
              if (nodeIndex >= 0) {
                this.modelNodes[nodeIndex][0].stop();
                item.uuid = null;
                this.modelNodes.splice(nodeIndex, 1);
              }
            }
          }
        }),
      );
    } catch (e) {
      console.error(e);
    }
  };

  toggleVS = async () => {
    if (!this.vsObjects?.length) {
      toast.error('There is no vsObjects to hide');
      return;
    }
    const { isVSEnabled, isVSVisible } = this.state;
    this.setState(
      {
        isVSEnabled: !isVSEnabled,
        isVSVisible: !isVSVisible,
      },
      async () => {
        if (isVSEnabled && isVSVisible) {
          await this.stopVS();
          await this.stopPolygons();
        } else {
          await this.initVS();
          await this.initPolygons();
        }
      },
    );
  };

  hideIframeButtons() {
    try {
      if (this.iframe) {
        const iframeButtons = this.iframe?.contentWindow?.document?.querySelector('#bottom-ui');
        if (iframeButtons && iframeButtons.style.display !== 'none') {
          iframeButtons.style.display = 'none';
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  resumeTourMusic = async () => {
    if (!this.isTourReadyForAudio()) return;

    if (audioHandler.isTourMusicPaused()) {
      await this.handleToggleMusic();
    }
  };

  openVR = () => {
    const vrOverlay: any = this.getShowcaseElement(ShowcaseElement.VRLayer);
    const iframeVrButton = vrOverlay.querySelector('[role="button"]');
    iframeVrButton.click();
  };

  renderPanorama() {
    const {
      tour,
      panoramaOn,
      showcaseLoaded,
      panoramas,
      flowIsActive,
      room,
      host,
      openedPanoHotspot,
    } = this.state;

    const showPanorama =
      panoramaOn &&
      panoramas?.length > 0 &&
      (tour.mpPasswordActive ? showcaseLoaded : true) &&
      !flowIsActive;

    let audio;
    if (openedPanoHotspot?.type === 'music') {
      audio = audioHandler.getAudio(MusicObjectKey.PANORAMAS, openedPanoHotspot.defaultId);
      this.setState({ tourAudioPlaying: false });
    }

    const handleSoundControlClose = async () => {
      const { tour } = this.state;
      this.setState({ openedPanoHotspot: null });
      if (tour?.autoplayMusic) {
        await this.resumeTourMusic();
      }
      await audioHandler.stopAudioByType(MusicObjectKey.PANORAMAS);
    };

    return (
      <>
        {showPanorama && openedPanoHotspot && audio && (
          <SoundControls audio={audio} onClose={handleSoundControlClose} />
        )}
        <Panorama
          panoramas={panoramas}
          markMinimap={this.markMinimap}
          panoPose={this.state.panoPose}
          activePano={this.state.activePano}
          compass={tour.panoramaCompass}
          transition={tour.panoramaTransition}
          isChatGuest={room && socket && socket.connected && !host}
          defaultPanorama={tour.defaultPanorama}
          updatePanoRotation={this.updatePanoRotation}
          openHotspot={this.openedPanoHotspot}
          onSceneChange={this.handlePanoSceneChange}
          handleTogglePano={this.handleTogglePano}
        />
      </>
    );
  }

  renderBottomBar(isFullScreen, toggleFullscreen) {
    const {
      tour,
      room,
      sharePopupOn,
      minimapVisible,
      panoramaOn,
      measurementsOn,
      whiteLabelData,
      reel,
      reelStep,
      translation,
      currentFloor,
      isVSEnabled,
      mpFloors,
      host,
      activeSweepGroup,
      sweepGroups,
      hideBottomBarForWhile,
      tourMode,
      clickedTag,
      changeReel,
      chatParticipant,
      flowIsActive,
    } = this.state;

    const activeSweepGroupObject = sweepGroups.find((g) => g.id === activeSweepGroup);

    const firstAudio = audioHandler.getFirstMusic();
    let audio;
    if (firstAudio?.type?.name === MusicObjectKey.TAGS) {
      audio = firstAudio.audio;
    }

    const handleSoundControlClose = async () => {
      const { tour } = this.state;
      this.setState({ clickedTag: false });
      if (tour?.autoplayMusic) {
        await this.resumeTourMusic();
      }
      await audioHandler.stopAudioByType(MusicObjectKey.TAGS);
    };

    const setTourMusicState = (state: boolean) => {
      this.setState({ tourAudioPlaying: state });
    };

    const isAudioControlEnabled = this.isTourReadyForAudio();
    return (
      <>
        {tour.musicControl && clickedTag && audio && (
          <SoundControls
            vsObjects={this.vsObjects}
            audio={audio}
            onClose={handleSoundControlClose}
            flowIsActive={flowIsActive || !this.state.isNavigationBackgroundVisible}
          />
        )}
        {!this.state.showIntro && !this.state.startScreenOn && (
          <BottomBarWithRecoil
            audio={audioHandler.getAudio(MusicObjectKey.TOUR, tour.id)}
            host={host}
            musicPausedByUser={this.state.musicPausedByUser}
            activeSweepGroup={activeSweepGroupObject}
            tourAudioPlaying={this.state.tourAudioPlaying}
            setTourMusicState={setTourMusicState}
            toggleSketchfabPopup={this.toggleSketchfabPopup}
            isFull={isFullScreen}
            translation={translation}
            vsObjects={this.vsObjects}
            changeFull={toggleFullscreen}
            mainPlaying={this.state.tourAudioPlaying}
            openShare={() => {
              this.setState({ sharePopupOn: !sharePopupOn });
            }}
            reelVideos={this.state.reelVideos}
            reel={reel}
            changeReel={changeReel}
            mpFloors={mpFloors}
            room={room}
            loadModel={this.loadModel}
            tour={tour}
            reelStep={reelStep}
            sharePopupOn={sharePopupOn}
            isVSEnabled={isVSEnabled}
            moveToStep={this.moveToStep}
            playTour={this.playTour}
            tourPlaying={this.state.tourPlaying}
            showcase={this.showCaseTemp.showcase}
            showcaseTag={this.showcase.Tag}
            tourMode={tourMode}
            changeViewMode={this.changeViewMode}
            measurementsOn={measurementsOn}
            panoramaOn={panoramaOn}
            measurementsMode={this.measurementsMode}
            changeFloor={this.changeFloor}
            defurnishEnabled={
              this.iframe?.contentWindow?.document?.querySelector('.mode-defurnish button')
                ? true
                : false
            }
            onDefurnish={() => {
              this.iframe?.contentWindow?.document
                ?.querySelector('.mode-defurnish button')
                ?.click();
            }}
            showPanorama={tour.panorama}
            toggleExternalPopup={this.toggleExternalPopup}
            handleToggleMusic={this.handleToggleMusic}
            isAudioControlEnabled={isAudioControlEnabled}
            takeScreenshot={this.takeScreenshot}
            takePano={this.takePano}
            whitelabel={whiteLabelData}
            showMinimapClick={() => {
              this.setState({
                minimapVisible: !minimapVisible,
              });
            }}
            showPanoramaClick={this.handleTogglePano}
            layers={this.state.layers}
            showLayers={this.state.showLayers}
            toggleLayersClick={() => {
              this.setState({
                showLayers: !this.state.showLayers,
              });
            }}
            onHelpClick={() => {
              this.setState({
                showHelpModal: true,
                showTermsModal: false,
              });
            }}
            onTermsClick={() => {
              this.setState({
                showTermsModal: true,
                showHelpModal: false,
              });
            }}
            toggleVS={this.toggleVS}
            openVR={this.openVR}
            onStartVideo={() => {
              this.setState({ videoPlaying: true });
              audioHandler.pauseAllMusic();
            }}
            onStopVideo={() => {
              audioHandler.playAudio({ type: MusicObj.TOUR, id: this.state.tour.id });
              this.setState({ videoPlaying: false });
            }}
            currentFloor={currentFloor}
            onMuteClick={this.toggleMuteParticipants}
            onFullscreenClick={this.toggleFullscreenVideo}
            onPinClick={this.addPinnedVideo}
            initialDuplicates={this.props?.tourData?.tour?.initialDuplicates}
            audioOnly={this.state.audioOnly}
            hideForWhile={hideBottomBarForWhile}
            showCaseTemp={this.showCaseTemp}
            iframe={this.iframe}
            toggleThreadsDrawer={() =>
              this.setState((prevState) => ({
                ...prevState,
                isThreadsDrawerOpen: !prevState.isThreadsDrawerOpen,
              }))
            }
            closeThreadsDrawer={() =>
              this.setState({
                isThreadsDrawerOpen: false,
                selectedThread: null,
                selectedNoteTag: null,
              })
            }
            tags={Array.from(this.state.allTags, ([, value]) => value).filter((t) => !t.isThread)}
            openThreadsDrawer={() => this.setState({ isThreadsDrawerOpen: true })}
            isThreadsDrawerOpen={this.state.isThreadsDrawerOpen}
            threadsLoaded={this.state.threadsLoaded}
            selectedThread={this.state.selectedThread}
            threads={Array.from(this.state.allTags, ([, value]: any) => value).filter(
              (t) => t.isThread,
            )}
            appState={this.state.appState}
            addThreadToSpace={this.addThreadToSpace}
            removeThreadFromSpace={this.removeThreadFromSpace}
            toggleThreadVisibility={this._changeTagPos}
            hideElements={this.hideElements}
            avatar={chatParticipant}
            moveToTagIO={(tagSid) => {
              const tags = Array.from(this.state.allTags.values());
              const foundTag: any = tags.find((t: any) => {
                return tagSid && (t.sid === tagSid || t.defaultSid === tagSid);
              });
              if (!foundTag) return;
              this.moveToTagIO(foundTag, false);
            }}
            flowIsActive={flowIsActive}
            onToggleBottomBarActions={this.handleUserBottomBarActions}
            getShareLocation={this.getShareLocation}
            isRtl={tour.client?.rtl}
            selectedNoteTag={this.state.selectedNoteTag}
            unselectNoteTag={() => this.setState({ selectedNoteTag: null })}
            hideActionBar={this.state.hideActionBar}
          />
        )}
      </>
    );
  }

  handleTogglePano = async () => {
    const { panoramaOn, showcaseLoaded, room, host, tourPlaying } = this.state;

    if (!panoramaOn && tourPlaying) {
      // We pause the tour if the user wants the pano
      await this.showCaseTemp.showcase.Tour.stop();
    }

    const data = {
      interacted: true,
      panoramaOn: !panoramaOn,
      activePano: panoramaOn ? null : this.state.activePano,
    };

    if (showcaseLoaded && room && socket && socket.connected && host) {
      socket.emit('toggle-pano', data);
    }

    if (!this.state.lock) {
      this.setState(data);
    }
  };

  injectChildComponents() {}

  /** experience handlers * */

  renderGameContent() {}

  hideItemsFromConditions() {}

  renderEndGameScreen(): any {}

  handleGameStart(username: string, skipValidation?: boolean) {}

  tryButtonPlaySound() {}

  /** experience handlers * */

  isRenderAuth() {
    const { tour } = this.state;
    const p = getQueryVariable(window.location.href, 'p');

    if (!tour || (tour.password && p && atob(decodeURIComponent(p)) === tour.password)) {
      return false;
    }

    return !!tour.password;
  }

  renderAuth() {
    // Login screen has been combined with IntroScreen, so we don't need this function to return the Login component anymore
    // But we still need the function because it get's overriden in the GameTour component
    return <></>;
  }

  getShareLocation = () => {
    let location = sdk.getLocation.call(this);

    const { panoramaOn, panoramas } = this.state;
    if (panoramaOn && panoramas?.length > 0 && this.currentPanorama) {
      const pano = `pano=${this.currentPanorama.id}`;
      const panoPitch = `panoPitch=${this.panoPose.pitch}`;
      const panoYaw = `panoYaw=${this.panoPose.yaw}`;
      const panoHfov = `panoHfov=${this.panoPose.hfov}`;

      const query = `${pano}&${panoPitch}&${panoYaw}&${panoHfov}`;
      if (location.split('?')[1]) {
        location += `&${query}`;
      } else {
        location += `?${query}`;
      }
    }

    return location;
  };

  updatePanoRotation = (north: number, pos: any, scene: string) => {
    const { room, host, lock, panoramas } = this.state;
    if (room && socket && socket.connected) {
      if (host) {
        const pano = panoramas.find((p) => p.name === scene);
        if (pano?.id === this.currentPanorama.id) {
          socket.emit('move-pano', {
            panoPose: pos,
            currentPanorama: this.currentPanorama,
          });
        }
        all.updatePanoRotation.call(this, north, pos);
      } else if (!lock) {
        all.updatePanoRotation.call(this, north, pos);
      }
    } else {
      all.updatePanoRotation.call(this, north, pos);
    }
  };

  handlePanoSceneChange = (scene: any) => {
    this.currentPanorama = scene;
    const { room, showcaseLoaded, host } = this.state;
    if (showcaseLoaded && room && socket && socket.connected && host) {
      socket.emit('move-pano', {
        panoPose: {
          pitch: 0,
          yaw: 0,
          hfov: 100,
        },
        currentPanorama: scene,
      });
    }
  };

  handleGameStartOnIntroModal = (username: string) => {
    this.handleGameStart(username, true);
  };

  addAvatar = async (data: any) => {
    // calculating new position based on new center
    const [myX, myZ] = pointsOnCircle2D(
      AVATAR_CIRCLE_RADIUS,
      180 + this.avatarDegree,
      data?.pose?.position?.x,
      data?.pose?.position?.z,
    );
    const [x, z] = pointsOnCircle2D(AVATAR_CIRCLE_RADIUS, data.degree, myX, myZ);

    let json;
    if (data.avatarUrl && !data.avatarUrl.includes('base64')) {
      const modelId = getRPMModelId(data.avatarUrl);
      const response = await fetch(`https://models.readyplayer.me/${modelId}.json`);
      json = await response.json();
    }
    await this.onAddAvatar(
      new Avatar({
        uuid: data.avatarId,
        bodyType: json?.bodyType || 'image',
        name: data?.name,
        url: data.avatarUrl || null,
        positionX:
          this.defaultSweep && this.defaultSweep.sid === this.state.currentSweep.sid
            ? x
            : this.defaultSweep.position.x,
        positionY: data.pose?.position?.y,
        positionZ:
          this.defaultSweep && this.defaultSweep.sid === this.state.currentSweep.sid
            ? z
            : this.defaultSweep.position.z,
        rotationX: data.pose?.rotation?._x,
        rotationY: data.pose?.rotation?._y,
        rotationZ: data.pose?.rotation?._z,
        quaternionX: data.pose?.quaternion?._x,
        quaternionY: data.pose?.quaternion?._y,
        quaternionZ: data.pose?.quaternion?._z,
        quaternionW: data.pose?.quaternion?._w,
        degree: data.degree,
      }),
    );
  };

  onAddAvatar = async (data: Avatar) => {
    if (!this.avatarNodes.has(data.uuid)) {
      if (!data.positionX && !data.positionY && !data.positionZ) {
        data.positionX = this.pose.position.x;
        data.positionY = this.pose.position.y;
        data.positionZ = this.pose.position.z;
      }

      // TODO: implement LoadingQueue
      const avatarNode = await this.initAvatarNode(data);
      avatarNode[0].obj3D.position.set(data.positionX, data.positionY, data.positionZ);
      avatarNode[0].obj3D.rotation.set(data.rotationX, data.rotationY, data.rotationZ);
      avatarNode[0].obj3D.quaternion.set(
        data.quaternionX,
        data.quaternionY,
        data.quaternionZ,
        data.quaternionW,
      );
      avatarNode[0].obj3D.children[0]?.rotation.set(0, Math.PI, 0);

      if (avatarNode?.length) {
        if (!data?.muted) {
          if (avatarNode[2]) {
            // changing state to !active if video is not muted
            avatarNode[2].setActive(!avatarNode[2].isActive());
          }
        }
        this.avatarNodes.set(data.uuid, avatarNode);
      }
      return avatarNode;
    }
  };

  onRemoveAvatar = async (uuid: string) => {
    if (this.avatarNodes.size) {
      const [avatar] = this.avatarNodes.get(uuid);
      if (avatar) {
        avatar.stop();
        this.avatarNodes.delete(uuid);
      }
    }
  };

  videoEndCall = () => {
    socket.close();
    this.setState({ reelVideos: [] });
  };

  videoChangeTour = (data: any) => {
    const { tour } = this.state;
    const m = getQueryVariable(this.state.iframeUrl, 'm');
    if (data.id && data.id !== m) {
      if (data.mp) {
        this.moveModel(
          `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase.html?applicationKey=${tour?.user?.mpSDK}&m=${data.id}`,
        );
      } else {
        this.getTour({
          slug: data.id,
          changeMenu: false,
          changeMinimap: true,
          changePanorama: false,
        });
      }
    }
  };

  changeMuteStatus = (name: string, muted: boolean) => {
    const { fullscreenVideo, pinnedVideos, reelVideos } = this.state;
    const isReeled = reelVideos.findIndex((i) => i.name === name);
    const isPinned = pinnedVideos.findIndex((i) => i.name === name);
    const isFullscreen = fullscreenVideo?.name === name;

    if (isFullscreen) {
      fullscreenVideo.muted = muted;
    } else if (isPinned >= 0) {
      pinnedVideos[isPinned].muted = muted;
      this.addPinnedVideo(pinnedVideos[isPinned]);
    } else if (isReeled >= 0) {
      reelVideos[isReeled].muted = muted;
      this.addVideoReel(reelVideos[isReeled]);
    }
  };

  addTrack = async (p: any) => {
    try {
      const { fullscreenVideo, pinnedVideos } = this.state;
      if (p.track?.kind === 'audio' && !p.self) {
        const audioEl = new Audio();
        audioEl.append(p.track.attach());
        audioEl.setAttribute('data-cy-audio-track-name', p.track.name);
        audioEl.setAttribute('data-cy-audio-track-sid', p.sid);
        document.body.appendChild(audioEl);
        if (!p.enabled) {
          audioEl.pause();
          this.changeMuteStatus(p.name, true);
        } else {
          this.changeMuteStatus(p.name, false);
        }
      } else if (p.track?.kind === 'video') {
        const isFullscreen = fullscreenVideo?.sid === p.sid;
        const isPinned = pinnedVideos.findIndex((i) => i.sid === p.sid);
        if (p.dominant) {
          this.setState({ dominantSpeaker: p });
        } else if (isFullscreen) {
          this.setState({ fullscreenVideo: p });
        } else if (isPinned >= 0) {
          // || p.track.name.includes('-screen')
          // we pin screen shares
          this.addPinnedVideo(p);
        } else {
          this.addVideoReel(p);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  removeTrack = async (sid: string) => {
    try {
      const { fullscreenVideo, pinnedVideos, audioOnly } = this.state;
      const isFullscreen = fullscreenVideo?.sid === sid;
      const isPinned = pinnedVideos.findIndex((i) => i.sid === sid);
      if (isFullscreen) {
        this.setState({ fullscreenVideo: null });
      } else if (isPinned >= 0) {
        this.removePinnedVideo(sid);
        if (audioOnly) this.removePinnedVideo(`${sid}_video`);
      } else {
        this.removeVideoReel(sid);
        if (audioOnly) this.removeVideoReel(`${sid}_video`);
      }
    } catch (e) {
      console.error(e);
    }
  };

  updateAvatarsInList = async (name: string, avatarImage: string) => {
    try {
      if (!avatarImage) return;
      const reelVideos = [...this.state.reelVideos];
      const index = reelVideos.findIndex((i) => i.name === name);
      if (index >= 0 && !reelVideos[index].avatarImage) {
        reelVideos[index] = Object.assign(reelVideos[index], { avatarImage });
        this.setState({ reelVideos });
      }
    } catch (e) {
      console.error(e);
    }
  };

  addVideoReel = async (p: any) => {
    try {
      if (p.track?.kind === 'video') {
        this.setState((prevState) => {
          const reelVideos = [...prevState.reelVideos];
          const index = reelVideos.findIndex((i) => i.sid === p.sid);
          if (index >= 0) {
            reelVideos[index] = Object.assign(reelVideos[index], p);
          } else {
            reelVideos.push(p);
          }
          return {
            reelVideos,
          };
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  removeVideoReel = async (sid: string) => {
    console.log(`Removing ${sid} from reel`);
    this.setState((prevState) => ({
      reelVideos: prevState.reelVideos.filter((i) => i.sid !== sid),
    }));
  };

  addPinnedVideo = async (p: any) => {
    addPinnedVideoFunc(p, this.state.pinnedVideos, (pinnedVideos) => {
      this.setState({ pinnedVideos }, () => {
        if (!p.pinned) this.removeVideoReel(p.sid);
      });
    });
  };

  removePinnedVideo = async (sid: string) => {
    this.setState({
      pinnedVideos: this.state.pinnedVideos.filter((i) => i.sid !== sid),
    });
  };

  toggleFullscreenVideo = async (participant: any, pinned = false) => {
    const { fullscreenVideo, pinnedVideos } = this.state;
    if (fullscreenVideo?.sid === participant.sid) {
      // close fullscreen video
      if (fullscreenVideo.pinned) {
        this.addPinnedVideo({ ...fullscreenVideo, pinned });
      } else {
        this.addVideoReel(fullscreenVideo);
      }
      this.setState({ fullscreenVideo: null });
      document.removeEventListener('keydown', this.exitFullscreenVideo);
    } else {
      // open fullscreen video
      this.setState({ fullscreenVideo: { ...participant, pinned } });
      if (fullscreenVideo) {
        // first close old one, then add the new one
        if (fullscreenVideo.pinned) {
          const newPinnedVideos = [
            ...pinnedVideos.filter((p) => p.sid !== participant.sid),
            { ...fullscreenVideo, pinned: false },
          ];
          this.setState({ pinnedVideos: newPinnedVideos });
        } else {
          this.addVideoReel(fullscreenVideo);
        }
      } else {
        this.removePinnedVideo(participant.sid);
      }

      this.removeVideoReel(participant.sid);
      document.addEventListener('keydown', this.exitFullscreenVideo);
    }
  };

  exitFullscreenVideo = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      if (this.state.fullscreenVideo) {
        this.toggleFullscreenVideo(this.state.fullscreenVideo);
      }
    }
  };

  initAvatar = async () => {
    const { tour, room } = this.state;
    if (!tour.enableAvatar) return;

    try {
      const avatar = storage('avatar').get();
      if (!avatar) {
        this.setState({ avatar: null, chatParticipant: null });
      } else if (!room) {
        await this.setAvatar(avatar);
      }
    } catch (e) {}
  };

  getActiveAIAvatar = (): AIAvatar | null => {
    if (!this.activeAIAvatarId) return null;
    return this.aiAvatars.get(this.activeAIAvatarId) || null;
  };

  activateAIAvatar = (aiAvatarId: string) => {
    // Deactivate current active avatar
    const currentActive = this.getActiveAIAvatar();
    if (currentActive) {
      currentActive.stop();
      currentActive.showStartButton();
    }

    // Activate new avatar
    const newActive = this.aiAvatars.get(aiAvatarId);
    if (newActive) {
      this.activeAIAvatarId = aiAvatarId;
      return newActive;
    }
    return null;
  };

  deactivateCurrentAIAvatar = () => {
    const currentActive = this.getActiveAIAvatar();
    if (currentActive) {
      currentActive.stop();
      currentActive.showStartButton();
      this.activeAIAvatarId = null;
    }
  };

  setAIAvatarVisible = async (aiAvatarId: string, isVisible: boolean) => {
    const aiAvatar = this.aiAvatars.get(aiAvatarId);
    if (aiAvatar) {
      await aiAvatar.setVisibleStartButton(isVisible);
    }
  };

  /**
   * Create a new AIAvatar instance
   */
  private async createAIAvatar(vsObject: any): Promise<void> {
    const aiAvatarId = vsObject.id.toString();

    try {
      // Create new AIAvatar instance
      const aiAvatar = new AIAvatar(vsObject, { showcase: this.showCaseTemp });

      // Store the avatar
      this.aiAvatars.set(aiAvatarId, aiAvatar);

      // Subscribe to status changes - only update panel if this is the active avatar
      aiAvatar.onStatusChange((status) => {
        if (this.activeAIAvatarId === aiAvatarId) {
          this.setState((prevState: any) => ({
            aiAvatarStatusPanel: {
              ...prevState.aiAvatarStatusPanel,
              status,
            },
          }));
        }
      });

      aiAvatar.onStartChat(() => {
        this.showAIAvatarStatusPanel(aiAvatarId, 'connecting');
      });

      console.log(`Created new AIAvatar instance for ${aiAvatarId}`);
    } catch (error) {
      console.error(`Failed to create AIAvatar ${aiAvatarId}:`, error);
    }
  }

  /**
   * Destroy an AIAvatar instance and clean up resources
   */
  private destroyAIAvatar(aiAvatarId: string): void {
    const aiAvatar = this.aiAvatars.get(aiAvatarId);
    if (aiAvatar) {
      try {
        // If this is the active avatar, deactivate it first
        if (this.activeAIAvatarId === aiAvatarId) {
          this.activeAIAvatarId = null;
          this.setState({
            aiAvatarStatusPanel: {
              visible: false,
              status: 'connecting' as AIAvatarStatus,
              aiAvatarId: null,
            },
          });
        }

        // Destroy the avatar and clean up resources
        aiAvatar.destroy();

        // Remove from map
        this.aiAvatars.delete(aiAvatarId);

        console.log(`Destroyed AIAvatar instance for ${aiAvatarId}`);
      } catch (error) {
        console.error(`Error destroying AIAvatar ${aiAvatarId}:`, error);
      }
    }
  }



  showAIAvatarStatusPanel = (aiAvatarId: string, status: AIAvatarStatus = 'connecting') => {
    // Activate the specified avatar
    const activeAvatar = this.activateAIAvatar(aiAvatarId);
    if (!activeAvatar) return;

    // Hide TextPlane buttons when showing VoiceStatus
    activeAvatar.hideStartButton();

    this.setState({
      aiAvatarStatusPanel: {
        visible: true,
        status,
        aiAvatarId,
      },
    });

    console.log(`VoiceStatus shown for AI Avatar ${aiAvatarId} with status: ${status}`);
  };

  handleAIAvatarStatusEndChat = () => {
    // Hide VoiceStatus and show TextPlane buttons for the active avatar
    const activeAvatar = this.getActiveAIAvatar();
    if (activeAvatar) {
      activeAvatar.showStartButton();
      activeAvatar.stop();
    }

    this.deactivateCurrentAIAvatar();

    this.setState({
      aiAvatarStatusPanel: {
        visible: false,
        status: 'connecting',
        aiAvatarId: null,
      },
    });
  };

  handleLayerClick = (layer: any) => {
    // Use the SDK utility to handle the layer action
    if (layer.actionType && layer.actionType !== 'none') {
      // Map layer actionType to SDK action types
      // Call the SDK loadModel function to handle the action
      this.loadModel({
        type: layer.actionType,
        url: layer.actionUrl,
      });
    }
  };

  toggleMuteParticipants = async (sid: string) => {
    const audioEl: any = document.querySelectorAll(`[data-cy-audio-track-sid=${sid}]`);
    let mute = false;
    if (audioEl && audioEl.length > 0) {
      if (audioEl[0].playing) {
        audioEl[0].pause();
        mute = true;
      } else {
        audioEl[0].play();
        mute = false;
      }
      if (this.state.host) {
        socket.emit('mute_participant', {
          participantId: sid,
          mute,
        });
      }
    }
  };

  getAvatarImage = async (url: string) => {
    try {
      if (!url.includes('.glb')) throw new Error('No GLB');
      const id = url.split('/').pop().split('.glb')[0];
      const response = await fetch(`https://models.readyplayer.me/${id}.json`);
      const json = await response.json();
      return await new Promise((resolve) => {
        const imageUrl = `https://api.readyplayer.me/v1/avatars/${id}.png?scene=${json.bodyType}-portrait-v1-transparent`;
        this.setState({ avatarImage: imageUrl }, () => {
          return resolve(imageUrl);
        });
      });
    } catch (err) {
      console.log(err);
      return '';
    }
  };

  setAvatarImage = async (url) => {
    this.setState({ avatarImage: url });
  };

  setAvatar = async (data) => {
    const { tour, room, avatarImage } = this.state;
    this.setState({
      chatParticipant: Object.assign(data, {
        imageUrl: avatarImage || (await this.getAvatarImage(data.url)),
      }),
    });
    if (!tour.enableAvatar) return;

    const avatarId = uuid();
    const avatar = {
      ...data,
      uuid: avatarId,
      imageUrl: avatarImage,
    };
    storage('avatar').set(avatar);
    this.setState({ avatar });
    const user: any = {
      name: data?.name,
      room: room || tour.id,
      avatarUrl: data.url,
      avatarId,
      avatarImage,
      model: data.model,
      pose: {
        rotation: this.camera?.rotation,
        quaternion: this.camera?.quaternion,
        position: this.pose.position,
      },
      sweep: this.pose.sweep,
    };

    socket.emit('user_joining', user);
    console.log(`Joining avatar to room ${room}`);
  };

  toggleSketchfabPopup = (state: boolean) => () => {
    this.setState({ showSketchfabPopup: state });
  };

  startShowcaseLoad = () => {
    return new Promise((resolve, reject) => {
      if (this.iframe) {
        if (this.loadShowcaseFrameAbortController) {
          this.loadShowcaseFrameAbortController.abort();
        }
        this.loadShowcaseFrameAbortController = new AbortController();
        const { signal } = this.loadShowcaseFrameAbortController;

        this.iframe.addEventListener(
          'load',
          () => {
            this.showcaseLoad();
            resolve(true);
          },
          { once: false, signal },
        ); // once: false for TB-3129
      } else {
        reject(new Error('Iframe is not defined'));
      }
    });
  };

  onCloseIntro = () => {
    const { tour, startScreenOn, tourType } = this.state;
    this.setState(
      {
        showIntro: false,
        startScreenOn: tourType === TourType.Game || tour.introScreen ? startScreenOn : false,
      },
      async () => {
        this.showcaseLoad();
        if (tour?.autoplayMusic) {
          await this.playTourAudio().catch(() => {});
        }
      },
    );
  };

  getCurrentLanguage = () => {
    return this.state.initialDuplicates?.find(
      (duplicate: any) => duplicate.slug === this.state?.tour?.slug,
    );
  };

  unlockChapter = (targetObj: any, type: ChapterType): void => {
    const {
      game: { book, gameBookOn },
      unlockedChapterIds,
      clickedElements,
    } = this.state;
    const value = targetObj?.id;

    this.setState({
      clickedElements: [
        ...clickedElements,
        {
          type,
          value,
          sid: targetObj?.sid,
          defaultSid: targetObj?.defaultSid,
        },
      ],
    });

    if (!gameBookOn || !book) return;

    const chapters = sortBy(book?.chapters, 'order');
    const chapter = chapters.find((item) => item.order === unlockedChapterIds.length + 1);

    let unblock = false;
    switch (type) {
      case ChapterType.Tag: {
        const tag = targetObj as Tag;
        unblock =
          chapter &&
          chapter.type === ChapterType.Tag &&
          (chapter.value === String(tag.id) || chapter.value === tag.sid);
        break;
      }
      case ChapterType.Polygon:
        const polygon = targetObj as Polygon;
        unblock =
          chapter && chapter.type === ChapterType.Polygon && chapter.value === String(polygon.id);
        break;
      case ChapterType.VSItem:
        const vsItem = targetObj as VSObject;
        unblock =
          chapter && chapter.type === ChapterType.VSItem && chapter.value === String(vsItem.id);
        break;
      case ChapterType.VSImage:
        const vsImage = targetObj as VSImage;
        unblock =
          chapter && chapter.type === ChapterType.VSImage && chapter.value === String(vsImage.id);
        break;
      case ChapterType.VSVideo:
        const vsVideo = targetObj as VSVideo;
        unblock =
          chapter && chapter.type === ChapterType.VSVideo && chapter.value === String(vsVideo.id);
        break;
      default:
        break;
    }

    if (unblock) {
      this.tryButtonPlaySound();
      this.setState({
        unlockedChapterIds: [...unlockedChapterIds, chapter.id],
      });
    }
  };

  onPathAction = async (element, type: ChapterType) => {
    if (type === ChapterType.Tag) {
      this.openTagIframe(element.sid);
    } else if (type === ChapterType.VSItem) {
      this.openVsObjectIframe(element);
    } else if (type === ChapterType.VSVideo) {
      this.openVsVideoIframe(element);
    } else if (type === ChapterType.Polygon) {
      const data = element?.polygonsActions ? element.polygonsActions[0] : element;
      await this.handlePolygonAction(data);
    } else if (type === ChapterType.VSImage) {
      await this.handleVSAction(element);
    }
    this.setState({
      clickedElement: {
        id: element.id,
        type,
      },
    });
  };

  private openNoteDrawerWithInitialNote(initialNoteId: string | number) {
    if (!initialNoteId) return;
    const foundNote = this.state.allTags.values()?.find((t) => {
      return t.isThread && t.id === Number(initialNoteId);
    });

    if (foundNote) {
      this.setState({
        isThreadsDrawerOpen: true,
        selectedThread: { ...foundNote },
      });
    }

    return foundNote;
  }


  __hideConditions = async (conditions: any[]) => {
    // mattertag - editOpacity and make it 0 |  mpSdk.Mattertag.getData(); mpSdk.Mattertag.editOpacity(mattertagData[0].sid, 0);
    if (!conditions.length) return;
    console.debug('__hideConditions', conditions);
    const { polygons, allTags } = this.state;
    const availableSweeps = this.state.sweeps?.map((s) => s.sid);
    let _tags = [];
    let polygonsToHide = [];
    let vsItemsToHide = [];
    let vsVideosToHide = [];
    let vsImagesToHide = [];
    let sweeps = [];
    const currentRevealedConditions = [];

    conditions.forEach((condition: GameCondition) => {
      if (!condition.entity_ids) return;
      if (condition.entity_type === EntityType.Tag) {
        _tags = [..._tags, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.Polygon) {
        polygonsToHide = [...polygonsToHide, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSItem) {
        vsItemsToHide = [...vsItemsToHide, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSVideo) {
        vsVideosToHide = [...vsVideosToHide, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSImage) {
        vsImagesToHide = [...vsImagesToHide, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.Sweep) {
        sweeps = [...sweeps, ...condition.entity_ids];
      }
      currentRevealedConditions.push(condition.id);
    });

    console.debug('-----------disabling sweeps-----------', sweeps);
    // filter first of all (using map for example)
    // then filter for existing
    const uniqueCondSweeps = new Set(sweeps);
    const availableCondSweeps = Array.from(uniqueCondSweeps).filter((s: string) =>
      availableSweeps.includes(s),
    );
    this.showcase.Sweep.disable(...availableCondSweeps).catch((err) => console.error(err));

    const allTagsArray = Array.from(allTags, ([, value]: any) => value);

    const tagsToHide = _tags.map((tag: string) =>
      allTagsArray.find(
        (allTagItem: any) =>
          allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag,
      ),
    );
    console.debug('-----------disabling tags-----------', tagsToHide);
    tagsToHide.forEach((_tag: any) => _tag && this._changeTagPos(_tag, false));

    if (polygons && polygons.map) {
      console.debug('Polygons to hide', polygonsToHide, polygons);
      await Promise.all(
        polygons.map(async (item: Polygon) => {
          if (
            polygonsToHide.indexOf(item?.id?.toString()) !== -1 ||
            polygonsToHide.indexOf(item?.id) !== -1
          ) {
            if (!item?.active) {
              console.debug('-----------not hiding polygon (inactive) ----------', item);
            }
            const nodeIndex = this.modelNodes.findIndex(
              (node: any) => node?.[0]?.obj3D?.uuid === item.uuid,
            );
            if (nodeIndex >= 0 && item.uuid) {
              console.debug('-----------hiding polygon ----------', item);
              this.modelNodes[nodeIndex][0].stop();
              item.uuid = null;
              this.modelNodes.splice(nodeIndex, 1);
            }
          }
        }),
      );
    }

    await Promise.all(
      (this.vsObjects || []).map(async (item: VSTourAsset) => {
        let targetObjToHide;

        if (item instanceof TourImage) {
          targetObjToHide = vsImagesToHide;
        } else if (item instanceof TourVideo) {
          targetObjToHide = vsVideosToHide;
        } else {
          targetObjToHide = vsItemsToHide;
        }

        if (
          targetObjToHide &&
          (targetObjToHide.indexOf(item?.id?.toString()) !== -1 ||
            targetObjToHide.indexOf(item?.id) !== -1)
        ) {
          if (item && !item.active) return item;
          console.debug('-----------hiding vs ----------', item);
          await this.setVSVisible(item, false);
          return {
            ...item,
          };
        }
      }),
    );
  };

  _changeTagPos = (_tag, isVisible) => {
    const { sid } = _tag;
    console.debug(`-----------${isVisible ? 'revealing' : 'hiding'} tag ----------`, _tag);

    if (!isVisible && _tag.isThread) {
      this.removeDuplicatedTags(_tag);
    }

    this.showcase.Tag.editOpacity(sid, isVisible ? 1 : 0).catch((e) => console.error(e));
    this.showcase.Tag.editPosition(sid, {
      anchorPosition: {
        x: isVisible ? _tag.positionX : 0,
        y: isVisible ? _tag.positionY : 0,
        z: isVisible ? _tag.positionZ : 0,
      },
      stemVector: {
        x: isVisible ? _tag.stemVectorX : 0,
        y: isVisible ? _tag.stemVectorY : 0,
        z: isVisible ? _tag.stemVectorZ : 0,
      },
      // floorIndex: isVisible ? _tag.floor : 0,
      floorIndex: _tag.floor,
    }).catch((e) => console.error(e));
  };


  removeDuplicatedTags = (_tag) => {
    const {sid} = _tag;
    if(!sid) return;
   this.showcase.Tag.data.subscribe({
        onCollectionUpdated: (collection) => {

          Object.entries(collection).forEach(([tagSid, tag]) : any => {
            if (tagSid === sid) return;

            const posKey = `${Math.round(tag.anchorPosition.x * 100) / 100},${Math.round(tag.anchorPosition.y * 100) / 100},${Math.round(tag.anchorPosition.z * 100) / 100}`;
            const currentPosKey = `${Math.round(_tag.positionX * 100) / 100},${Math.round(_tag.positionY * 100) / 100},${Math.round(_tag.positionZ * 100) / 100}`;

            if (posKey === currentPosKey) {
              console.log(`Found duplicate tag at position ${posKey}. Removing tag with sid: ${tagSid}`);
              this.removeTagFromShowcase(tagSid);
            }
          });
        }
      });
  }

  removeTagFromShowcase = (tagSid) => {
    try {
      this.showcase.Tag.remove(tagSid);
      console.log('Tag removed from showcase:', tagSid);
    } catch (error) {
      console.error('Error removing tag from showcase:', error);
    }
  };

  __revealConditions = async (conditions: any[]) => {
    // this.showcase.Sweep.disable(sweep.uuid, sweep2.uuid,...)
    // mattertag - editOpacity and make it 0 |  mpSdk.Mattertag.getData(); mpSdk.Mattertag.editOpacity(mattertagData[0].sid, 0);
    if (!conditions.length) return;
    console.debug('__revealConditions', conditions);
    const { polygons, allTags } = this.state;
    const availableSweeps = this.state.sweeps?.map((s) => s.sid);
    let _tags = [];
    let polygonsToReveal = [];
    let vsItemsToReveal = [];
    let vsVideosToReveal = [];
    let vsImagesToReveal = [];
    let sweeps = [];
    let popups = [];
    const currentRevealedConditions = [];

    conditions.forEach((condition: GameCondition) => {
      if (!condition.entity_ids) return;
      if (condition.entity_type === EntityType.Tag) {
        _tags = [..._tags, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.Polygon) {
        polygonsToReveal = [...polygonsToReveal, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSItem) {
        vsItemsToReveal = [...vsItemsToReveal, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSVideo) {
        vsVideosToReveal = [...vsVideosToReveal, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSImage) {
        vsImagesToReveal = [...vsImagesToReveal, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.Sweep) {
        sweeps = [...sweeps, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.Popup) {
        popups = [...popups, condition];
      }
      currentRevealedConditions.push(condition.id);
    });
    console.debug('-----------enabling sweeps-----------', sweeps);
    // filter first of all (using map for example)
    // then filter for existing
    const uniqueCondSweeps = new Set(sweeps);
    const availableCondSweeps = Array.from(uniqueCondSweeps).filter((s: string) =>
      availableSweeps.includes(s),
    );
    this.showcase.Sweep.enable(...availableCondSweeps).catch((err) => console.error(err));

    const allTagsArray = Array.from(allTags, ([, value]: any) => value);

    const tagsToShow = _tags.map((tag: string) =>
      allTagsArray.find(
        (allTagItem: any) =>
          allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag,
      ),
    );
    tagsToShow.forEach((_tag: any) => _tag && this._changeTagPos(_tag, true));

    if (polygons && polygons.map) {
      await Promise.all(
        polygons.map(async (item: Polygon) => {
          if (
            polygonsToReveal.indexOf(item?.id?.toString()) !== -1 ||
            polygonsToReveal.indexOf(item?.id) !== -1
          ) {
            if (!item.active) {
              console.debug('-----------not revealing polygons (inactive)----------', item);
            }
            console.debug('-----------revealing polygons ----------', item);
            if (!item.uuid) {
              const node = await this.initPolygonNode(item);
              this.modelNodes.push(node);
              item.uuid = node[0].obj3D.uuid;
            }
          }
        }),
      );
    }

    await Promise.all(
      (this.vsObjects || []).map(async (item: VSTourAsset) => {
        let targetObjToReveal;

        if (item instanceof TourImage) {
          targetObjToReveal = vsImagesToReveal;
        } else if (item instanceof TourVideo) {
          targetObjToReveal = vsVideosToReveal;
        } else {
          targetObjToReveal = vsItemsToReveal;
        }

        if (
          targetObjToReveal &&
          (targetObjToReveal.indexOf(item?.id?.toString()) !== -1 ||
            targetObjToReveal.indexOf(item?.id) !== -1)
        ) {
          // console.log('game item, item.active', item, item.active);
          if (item && !item.active) return item;
          console.debug('-----------revealing vsItem ----------', item);
          await this.setVSVisible(item, true, vsTriggerType.revealCondition);

          return {
            ...item,
          };
        }
      }),
    );
  };

  showElements = async ({
    tagsToReveal,
    polygonsToReveal,
    vsImagesToReveal,
    vsVideosToReveal,
    vsHTMLsToReveal,
    vsItemsToReveal,
    sweepsToReveal,
  }) => {
    const { allTags, polygons, sweeps } = this.state;
    if (sweepsToReveal && sweepsToReveal?.length > 0) {
      const availableSweeps = sweeps?.map((s) => s.sid);
      const uniqueCondSweeps = new Set(sweepsToReveal);
      const availableCondSweeps = Array.from(uniqueCondSweeps).filter((s: string) =>
        availableSweeps.includes(s),
      );
      this.showcase.Sweep.enable(...availableCondSweeps).catch((err) => console.error(err));
    }
    const allTagsArray = Array.from(allTags, ([, value]: any) => value);

    const tagsToShow = tagsToReveal?.map((tag: string) =>
      allTagsArray.find(
        (allTagItem: any) =>
          allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag,
      ),
    );
    tagsToShow?.forEach((_tag: any) => _tag && this._changeTagPos(_tag, true));

    let currentObjUuid: any = null;

    if (polygons && polygons.map && polygonsToReveal) {
      await Promise.all(
        polygons.map(async (item: Polygon) => {
          if (polygonsToReveal?.indexOf(item?.id?.toString()) !== -1) {
            if (item.active && !item.uuid) {
              const node = await this.initPolygonNode(item);
              this.modelNodes.push(node);
              item.uuid = node[0].obj3D.uuid;
              item.hiddenFromFlows = false;
              currentObjUuid = item.uuid;
            }
          }
        }),
      );
    }

    await Promise.all(
      (this.vsObjects || []).map(async (item: VSTourAsset) => {
        // TODO: Change this to this.vsObjects

        let targetObjToReveal;

        if (item instanceof TourImage) {
          targetObjToReveal = vsImagesToReveal;
        } else if (item instanceof TourVideo) {
          targetObjToReveal = vsVideosToReveal;
        } else if (item instanceof TourVSHtml) {
          targetObjToReveal = vsHTMLsToReveal;
        } else {
          targetObjToReveal = vsItemsToReveal;
        }

        if (targetObjToReveal && targetObjToReveal?.indexOf(item?.id?.toString()) !== -1) {
          if (item && !item.active) return item;
          item.hiddenFromFlows = false;
          await this.setVSVisible(item, true);
        }
      }),
    );

    return currentObjUuid;
  };

  sendTagToGA = (sid: string) => {
    const { allTags } = this.state;
    const allTagsArray = Array.from(allTags, ([, value]: any) => value);
    const foundTag = allTagsArray.find((tag) => tag.sid === sid || tag.defaultSid === sid);
    sendToGA('event', {
      eventCategory: 'Mattertag',
      eventAction: 'click',
      eventLabel: foundTag.title,
      eventType: foundTag.type,
    });
  };

  hideElements = async (
    {
      hideTags,
      polygonsToHide,
      vsImagesToHide,
      vsVideosToHide,
      vsHTMLsToHide,
      vsItemsToHide,
      sweepsToHide,
    },
    hiddenFromFlows = false,
  ) => {
    const { allTags, polygons, sweeps } = this.state;
    if (sweepsToHide && sweepsToHide?.length > 0) {
      const availableSweeps = sweeps?.map((s) => s.sid);
      const uniqueCondSweeps = new Set(sweepsToHide);
      const availableCondSweeps = Array.from(uniqueCondSweeps).filter((s: string) =>
        availableSweeps.includes(s),
      );
      this.showcase.Sweep.disable(...availableCondSweeps).catch((err) => console.error(err));
    }

    const allTagsArray = Array.from(allTags, ([, value]: any) => value);

    const tagsToHide = hideTags?.map((tag: string) =>
      allTagsArray.find(
        (allTagItem: any) =>
          allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag,
      ),
    );

    console.debug('-----------disabling tags-----------', tagsToHide);
    tagsToHide?.forEach((_tag: any) => _tag && this._changeTagPos(_tag, false));

    if (polygons && polygons.map) {
      console.debug('(hideElements) Polygons to hide', polygonsToHide, polygons);
      const res = await Promise.all(
        polygons.map(async (item: Polygon) => {
          if (polygonsToHide?.indexOf(item?.id?.toString()) !== -1) {
            if (!item?.active) {
              console.debug('-----------not hiding polygon (inactive) ----------', item);
            }
            console.debug('-----------hiding polygon ----------', item);
            const nodeIndex = this.modelNodes.findIndex(
              (node: any) => node?.[0]?.obj3D?.uuid === item.uuid,
            );
            if (nodeIndex >= 0) {
              this.modelNodes[nodeIndex][0].stop();
              item.uuid = null;
              item.hiddenFromFlows = hiddenFromFlows;
              this.modelNodes.splice(nodeIndex, 1);
            }
          }
          return item;
        }),
      );
      this.setState({ polygons: res });
    }

    await Promise.all(
      (this.vsObjects || []).map(async (item: VSTourAsset) => {
        let targetObjToHide;

        if (item instanceof TourImage) {
          targetObjToHide = vsImagesToHide;
        } else if (item instanceof TourVideo) {
          targetObjToHide = vsVideosToHide;
        } else if (item instanceof TourVSHtml) {
          targetObjToHide = vsHTMLsToHide;
        } else {
          targetObjToHide = vsItemsToHide;
        }

        if (targetObjToHide && targetObjToHide?.indexOf(item?.id?.toString()) !== -1) {
          if (item && !item.active) return item;
          console.debug('-----------hiding setVSVisible vs ----------', item);
          await this.setVSVisible(item, false);
          item.hiddenFromFlows = hiddenFromFlows;
          return {
            ...item,
          };
        }
      }),
    );
  };

  updateCssMenuWidth = (width?: number) => {
    const menuWidth = this.state.menuOpen ? width || this.state.menuWidth : 0;
    document.documentElement.style.setProperty('--menu-width', `${menuWidth}px`);
    document.documentElement.style.setProperty(
      '--pano-close-btn-width',
      `${this.state.panoramaOn ? 60 : 0}px`,
    );
  };

  initPathDistanceUpdates() {
    this.showCaseTemp.navigationManager.component.inputs.onDistanceChanged = (distance: number) => {
      this.setState({
        actionPathNavbarDistance: distance,
      });
    };
  }

  setIotModalOpen(open, showDescr) {
    this.setState({ iotModalOpen: open, iotModalShowDescription: showDescr });
  }

  setTagPopupOpen(open, showDescr) {
    this.setState({ tagPopupOpen: open, tagPopupShowDescription: showDescr });
  }

  setGalleryOpen() {
    this.setState({ galleryArr: [] });
  }

  calculateAIAvatarPanelBottomPosition() {
    const flowbarWrapper = document.querySelector('.flowbar-wrapper');
    let actualFlowbarHeight = 0;

    if (flowbarWrapper) {
      const rect = flowbarWrapper.getBoundingClientRect();
      actualFlowbarHeight = rect.height;
    }

    if (actualFlowbarHeight === 0) {
      const flowbarPadding = 12; // From FlowbarBodyStyle p: '12px'
      const minContentHeight = 50; // Minimum content height
      actualFlowbarHeight = (flowbarPadding * 2) + minContentHeight; // Fallback: 74px
    }

    const flowbarBottomOffset = DeviceManager.isMobile() && !DeviceManager.isHorizontalMobileView() ? 80 : 50;
    const additionalSpacing = 10; // Additional spacing above the flowbar for better visual separation
    const totalBottomPosition = flowbarBottomOffset + actualFlowbarHeight + additionalSpacing;
    return `${totalBottomPosition}px`;
  }

  setDocumentOpen() {
    this.setState({ document: null });
  }

  getValueOnWindowLocationObject(key: string) {
    let value = '';
    try {
      value = this.iframe?.contentWindow?.location?.[key] || '';
    } catch (e) {
      value = '';
    }
    return value;
  }

  setAllSweepsEnabled(enabled: boolean) {
    if (!this.state.sweeps) {
      console.error(
        this.state.sweeps,
        'Attempted to enable/disable sweeps before they were initialized',
      );
      return;
    }
    if (enabled) this.showCaseTemp.showcase.Sweep.enable(...this.state.sweeps.map((s) => s.sid));
    if (!enabled) this.showCaseTemp.showcase.Sweep.disable(...this.state.sweeps.map((s) => s.sid));
  }

  handleUserVideoActions = ({ chatOn }) => {
    this.setState({
      ...(chatOn !== undefined ? { videoChatOn: chatOn } : {}),
    });
  };

  handleUserBottomBarActions = ({ chatOn }) => {
    this.setState({
      ...(chatOn !== undefined ? { bottomBarChatOn: chatOn } : {}),
    });
  };

  hideTreedisTagTooltip = (event, forceClose = false) => {
    if (forceClose) {
      this.resetTagHoverAndPopupView();
      return;
    }
    const tagTooltip = document.getElementById('base-tag-tooltip');
    if (!(event.target instanceof Node)) return;

    if (tagTooltip && !tagTooltip.contains(event.target)) {
      this.resetTagHoverAndPopupView();
    }
  };

  public render() {
    dLog('BaseTour');
    const {
      tour,
      game,
      gameStatus,
      sweepGroups,
      measurementsOn,
      allowGuestBeforeHost,
      room,
      activeSweepGroup,
      sharePopupOn,
      overlayOn,
      showcaseLoaded,
      currentSweep,
      tokenRemainingTime,
      tokenExpiresAt,
      showSketchfabPopup,
      whiteLabelData,
      minimapVisible,
      minimapOn,
      minimaps,
      selectedMinimap,
      mapWalkerX,
      mapWalkerY,
      mapWalkerRotation,
      lock,
      tagPopOn,
      panoPopOn,
      openedTag,
      openedPanoHotspot,
      vsActionPopOn,
      openedVSAction,
      contactPopupOn,
      externalPopupOn,
      externalPopupUrl,
      panoramaOn,
      host,
      selectedMarker,
      showHelpModal,
      showTermsModal,
      panoramas,
      interacted,
      showIntro, // intro clip
      containerId,
      loadingTags,
      agents,
      tourEmail,
      translation,
      tourType,
      reelVideos,
      experiencePopUpIsOpen,
      initialDuplicates,
      experiencePopUpData,
      forcePlayGameIntro,
      menuSettings,
      iot,

      // --- to add
      avatar,
      chatParticipant,
      iframeUrl,
      audioOnly,
      showBottomBar,
      iframeSettings,
      startScreenOn,
      isThreadsDrawerOpen,
      confirmDialog,
      isShowProduct,
      gameLockPopOn,
      flowIsActive,
      flows,
      mainFlow,
      videoChatOn,
      bottomBarChatOn,
      startFlowFromAsset,
      isRemoteControlled,
    } = this.state;
    const { _tour, tourImage, tourData } = this.props;
    const tourForIS = tour || tourData?.tour;
    const preview = !!_tour;
    const loadSweeps =
      !showIntro &&
      !startScreenOn &&
      !loadingTags &&
      showcaseLoaded &&
      sweepGroups &&
      sweepGroups.length > 0;
    const isEcommerceTour = tourType === TourType.ECommerce;
    const showMinimap = this.isGameTour()
      ? gameStatus !== GameStatus.NotStarted
      : showcaseLoaded && !flowIsActive;
    // For tours with MP pass, we show panorama only after password was entered and showcase is loaded
    const showPanorama =
      panoramaOn &&
      panoramas?.length > 0 &&
      (tour.mpPasswordActive ? showcaseLoaded : true) &&
      !flowIsActive;
    const commonConditions =
      showcaseLoaded && !measurementsOn && !startScreenOn && !showIntro && (room ? host : true);
    const overlapMenu = this.state.menuOpen && (showHelpModal || showTermsModal);
    // If room is set, it means it's a Hub call and we show menu only to the host
    const showMenu =
      !this.isGameTour() &&
      (tour?.menuEnabled || iot?.menuSettings?.active) &&
      commonConditions &&
      !flowIsActive &&
      !overlapMenu;
    const showIot = tour?.enableIot && commonConditions;

    const { hasAcceptedCookies } = this.context as any;

    const isMobile = DeviceManager.isMobile();
    const isChrome = DeviceManager.isChrome();
    const isIOS = DeviceManager.isIOS();
    const tourStarted = this.isTourReadyForAudio();

    const isBusinessOrEnterprise =
      this.state.tour?.user?.enterprise ||
      this.state.tour?.user?.subscription ===
        (UserSubscription.Business || UserSubscription.Enterprise);

    const chatsOverlap = (videoChatOn || bottomBarChatOn) && DeviceManager.isMobile();

    const renderTagTooltip = (tag) => {
      let { selectedTag, lastTagHovered, isTagHovered, tour, traneData } = this.state;

      //TODO: REMOVE, this is for trane only
      if (tour?.slug === 'trane-demo') {
        const devices = [];
        traneData?.data?.sensors.map((sensor) => {
          devices.push({
            id: 1,
            providerId: 1,
            tourId: tour.id,
            value: sensor.value,
            name: sensor.name,
          });
        });

        tag = Object.assign({}, tag, { iotDevices: devices, title: traneData?.data?.date });
        selectedTag = tag;
        lastTagHovered = tag;
      }

      if (
        !tag ||
        experiencePopUpIsOpen ||
        showPanorama ||
        this.state.tagPopupOpen ||
        this.state.iotModalOpen
      )
        return null;
      if (tag.iotDevices?.length) {
        return (
          <TagTooltipCustom
            tag={isTagHovered && lastTagHovered ? lastTagHovered : selectedTag}
            camera={this.camera}
            THREE={this.THREE}
            renderer={this.renderer}
            setIotModalOpen={(open, showDescr) => {
              this.setIotModalOpen(open, showDescr);
              this.updateIotState({
                openCamera: lastTagHovered?.iotDevices?.filter((d) => d.videoUrl)?.[0],
                openFavouriteCameras: null,
              });
            }}
            providers={iot?.providers}
            sidebarWidth={null}
            handleUnlock={(d) => this.updateIotState({ lockDeviceId: d.id })}
            iotDevices={iot?.devices}
          />
        );
      }
      if (tag.treedisStyle) {
        let tagToShow = null;
        const hideTooltipOnMove = () => {
          this.showcase.Sweep.current.subscribe((currentSweep) => {
            if (currentSweep.sid === '') {
              this.setState({ isTagHovered: false });
            }
          });

          this.renderer.domElement.removeEventListener('click', hideTooltipOnMove);
        };

        if (isTagHovered && tag.hoverTooltip) {
          tagToShow = lastTagHovered;
        } else if (tag.clickPopup && selectedTag) {
          tagToShow = selectedTag;
        }

        if (tagToShow) {
          this.renderer.domElement.addEventListener('click', hideTooltipOnMove);

          return (
            <BaseTagTooltip
              setTagPopupOpen={(open, showDescr) => {
                this.setTagPopupOpen(open, showDescr);
              }}
              tag={tagToShow}
              camera={this.camera}
              renderer={this.renderer}
              handleClickDescriptionLink={this.handleClickDescriptionLink}
              pauseTourMusic={audioHandler.stopTourMusic}
              playTourMusic={audioHandler.resumeMusic}
              translation={this.state.translation}
              tagNotesEnabled={this.state.tour?.tagNotesEnabled}
              onNoteClick={() => {
                this.setState({
                  selectedNoteTag: tagToShow,
                  isThreadsDrawerOpen: true,
                  selectedThread: null,
                });
              }}
            />
          );
        }
      }
    };

    // Off intro screen if navigation enabled
    if (tour && tour?.navigationWebEnabled && startScreenOn) {
      this.setState({ startScreenOn: false });
    }

    return (
      <>
        {!this.state.interacted && (
          <InteractedListener
            onInteracted={() => {
              this.setState({ interacted: true });
            }}
            showcase={this.showcase}
          />
        )}
        <FullScreen
          attrs={{ id: 'global-fullscreen', class: classnames(tour?.client?.rtl && 'rtl') }}
          rootBody
        >
          {({ isFullScreen, toggleFullscreen }) => (
            <>
              {/* Specific temporary functionality for a Mondelez tour */}
              {this.state.mondelezTabletVideo.videoId && (
                <MondelezTabletVideo
                  videoId={this.state.mondelezTabletVideo.videoId}
                  onClose={() =>
                    this.setState({
                      mondelezTabletVideo: {
                        videoId: undefined,
                        sweepsHistory: this.state.mondelezTabletVideo.sweepsHistory,
                      },
                    })
                  }
                />
              )}

              {(this.state.selectedTag || this.state.isTagHovered) &&
                !startScreenOn &&
                !isShowProduct &&
                !tagPopOn &&
                !gameLockPopOn &&
                this.state.appState === 'playing' &&
                renderTagTooltip(this.state.tagHovered || this.state.selectedTag)}

              {this.state.tagPopupOpen && (this.state.tagHovered || this.state.selectedTag) && (
                <div className="tag-popup-container">
                  <TagPopup
                    open={this.state.tagPopupOpen}
                    setOpen={(open, showDescr) => {
                      this.setTagPopupOpen(open, showDescr);
                      const { showcaseLoaded, host, room, isRemoteControlled } = this.state;
                      if (
                        !open &&
                        showcaseLoaded &&
                        room &&
                        socket &&
                        socket.connected &&
                        (host || isRemoteControlled)
                      ) {
                        socket.emit('close-tag');
                      }
                    }}
                    showDescription={this.state.tagPopupShowDescription}
                    tag={this.state.tagHovered || this.state.selectedTag}
                    pauseTourMusic={audioHandler.stopTourMusic}
                    playTourMusic={audioHandler.resumeMusic}
                    translation={this.state.translation}
                  />
                </div>
              )}

              {this.state.tour?.enableIot &&
                this.state.tour?.iot2FAEnabled &&
                !this.state.tour?.isSample && <IotLoginModal tour={this.state.tour} />}

              {this.state.galleryArr?.length > 0 && (
                <GalleryDialog
                  open={this.state.galleryArr?.length > 0}
                  setOpen={() => this.setGalleryOpen()}
                  gallery={this.state.galleryArr}
                  title={this.state.galleryName}
                  type={this.state.galleryType}
                />
              )}

              {this.state.document && (
                <FileDialogProps
                  open={this.state.document}
                  setOpen={() => this.setDocumentOpen()}
                  document={this.state.document}
                  title={this.state.documentName}
                  type={this.state.documentType}
                  tourId={this.state.tour.id}
                />
              )}

              {this.state.tour?.enableIot && (
                <IotTourModal
                  open={this.state.iotModalOpen}
                  setOpen={(open, showDescr) => {
                    this.setIotModalOpen(open, showDescr);
                    this.updateIotState({ openCamera: null, openFavouriteCameras: null });
                  }}
                  tag={this.state.lastTagHovered || this.state.selectedTag}
                  providers={iot?.providers}
                  moveToTagIO={(tag) => {
                    this.moveToTagIO(tag, false);
                  }}
                  handleUnlock={(d) => this.updateIotState({ lockDeviceId: d.id })}
                  iotDevices={iot?.devices}
                  openCamera={iot.openCamera}
                  openFavouriteCameras={iot.openFavouriteCameras}
                  newDoorNotification={iot.newDoorNotification}
                  handleMoveToLock={(d) => this.updateIotState({ moveToDevice: d })}
                  tags={Array.from(this.state.allTags.values())}
                />
              )}

              {showMenu && !this.state.isThreadsDrawerOpen && (
                <MenuWrapper
                  tour={this.state.tour}
                  sendTagToGA={this.sendTagToGA}
                  menuSettings={menuSettings}
                  rtl={tour?.client?.rtl}
                  open={this.state.menuOpen && !isThreadsDrawerOpen}
                  parentMenus={this.state.parentMenus}
                  toggleContactPopup={this.toggleContactPopup}
                  toggleExternalPopup={this.toggleExternalPopup}
                  moveToMPLabels={this.moveToMPLabels}
                  loadModel={this.loadModelMenu}
                  tourEmail={tourEmail}
                  iotMenu={iot?.menuSettings}
                  iotDevices={iot?.devices}
                  providers={iot?.providers?.map((provider) => ({
                    ...provider,
                    icon: provider?.icon
                      ? `${process.env.NEXT_PUBLIC_API}/v1/public/icons/${provider?.icon}`
                      : '',
                  }))}
                  sendToGA={sendToGA}
                  whitelabel={whiteLabelData}
                  hideTriggerButton={isEcommerceTour || isThreadsDrawerOpen}
                  currentSid={currentSweep?.sid}
                  // If minimap is ON, we subtract it's height from Menu's height so they don't overlap
                  minimapHeight={
                    minimapVisible && !!tourForIS?.minimap ? (minimapOn ? 450 : 200) : 0
                  }
                  translation={this.state.translation}
                  onClose={this.closeMenu}
                  onOpen={this.openMenu}
                  onWidthChange={this.changeWidthMenu}
                  handleLock={this.handleLockMenu}
                  handleMoveToLock={this.handleMoveToLockMenu}
                  handleOpenCamera={this.handleOpenCameraMenu}
                  favouriteCameras={iot?.favouriteCameras}
                  activeMenuId={
                    this.state?.activeMenu?.subSubMenuId ||
                    this.state?.activeMenu?.subMenuId ||
                    this.state?.activeMenu?.menuId
                  }
                  libraryIconsBaseUrl={`${process.env.NEXT_PUBLIC_API}/v1/public/icons/`}
                  awsIconUrl={`${process.env.NEXT_PUBLIC_CDN}/tours/${tour?.id}/parentMenus/icons`}
                />
              )}
              {showIot && (
                <IotLogic
                  showcase={this.showCaseTemp}
                  iot={iot}
                  tourId={tour?.id}
                  tourSlug={tour?.slug}
                  updateIotState={this.updateIotState}
                  setState={(newState: any) => this.setState(newState)}
                  moveToTagIO={(tagSid) => {
                    const tags = Array.from(this.state.allTags.values());
                    const foundTag: any = tags.find((t: any) => {
                      return tagSid && (t.sid === tagSid || t.defaultSid === tagSid);
                    });
                    if (!foundTag) return;
                    this.moveToTagIO(foundTag, false);
                  }}
                  tags={this.state.allTags}
                />
              )}

              {!chatsOverlap &&
                !tour?.menuEnabled &&
                showcaseLoaded &&
                tour?.contactForm &&
                ((tour?.client && tour?.client.email) || tourEmail?.menuGetInTouch) &&
                tourType === TourType.Regular &&
                !isThreadsDrawerOpen &&
                !tour.navigationWebEnabled &&
                !flowIsActive && (
                  <GetInTouchButton
                    onClick={this.toggleContactPopup}
                    tooltipOn={tour?.getInTouchTooltipOn}
                    translation={translation}
                    rightOffset={this.state.menuOpen ? this.state.menuWidth : 0}
                  />
                )}

              {!chatsOverlap &&
                showcaseLoaded &&
                tour?.customButton &&
                tourType === TourType.Regular &&
                !measurementsOn &&
                !startScreenOn &&
                !showIntro &&
                !isThreadsDrawerOpen &&
                !flowIsActive && (
                  <Box
                    sx={{
                      padding: '4px 0px 4px 4px',
                      position: 'absolute',
                      top: '190px',
                      transition: 'all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
                      right: `${this.state.menuOpen ? `${this.state.menuWidth}px` : '0px'}`,
                      zIndex: 1,
                      overflow: 'hidden',
                    }}
                  >
                    <CustomButton
                      onClick={this.handleCustomButton}
                      tourId={tour?.id}
                      customButtonIcon={tour?.customButtonIcon}
                    />
                  </Box>
                )}

              <ScreenNavigationArrow refProp={this.pathArrowRefBaseTour} />
              {!stopLogs && <DebugWindow />}
              {this.state.gameTrialErr && this.state.tourType === TourType.Game && (
                <div className="gameTrialErr">
                  <div className="gameTrialErr-text">{this.state.gameTrialErr}</div>
                  <Button onClick={() => window.close()}>Close</Button>
                </div>
              )}
              {experiencePopUpIsOpen && (
                <ExperiencePopUp
                  isRtl={tour.client?.rtl}
                  onInit={async () => {
                    audioHandler.pauseAllMusic();
                  }}
                  tourId={tour?.id}
                  getCurrentLanguage={this.getCurrentLanguage}
                  tryButtonPlaySound={this.tryButtonPlaySound}
                  experiencePopUpData={experiencePopUpData}
                  isOpen={experiencePopUpIsOpen}
                  setIsOpen={(status) => {
                    // as I understand this using only for closing experience from itself
                    audioHandler.resumeMusic();
                    this.state.onExperienceCloseCallback();
                    this.setState({
                      experiencePopUpIsOpen: status,
                      closedElementPopup: !status,
                      onExperienceCloseCallback: () => undefined,
                    });
                  }}
                />
              )}
              {this.state.vsHTMLPopup.show && DeviceManager.isMobile() && (
                <VSHTMLPopup setShow={this.setVsHTMLPopupShow} src={this.state.vsHTMLPopup.src} />
              )}

              <div
                id={`${containerId}-tour-root`}
                className={classnames(
                  preview ? 'preview base-tour tour-container' : 'base-tour tour-container',
                  isMobile && 'no-visible-scrollbar',
                  tourType === TourType.Game && host && 'game-container',
                )}
                // eslint-disable-next-line no-return-assign
                ref={(el: HTMLDivElement | null) => {
                  this.root = el;
                }}
              >
                {tokenRemainingTime > 0 && (
                  <div className="countDownWrap">
                    <div className="countDown">
                      <Countdown
                        date={tokenExpiresAt}
                        zeroPadDays={0}
                        onComplete={() => {
                          this.props.history.push('/');
                        }}
                      />
                    </div>
                  </div>
                )}

                {tour && (
                  <>
                    {this.isRenderAuth() && this.isGameTour() ? (
                      this.renderAuth()
                    ) : (
                      <div
                        className={classnames('inner', {
                          mobile: isMobile,
                          isChromeInIOS: isIOS && isChrome,
                        })}
                      >
                        {/* @ts-ignore - Multiple children in div is fine in React 18 */}
                        <div className="ui-wrap">
                          {this.state.showActionPathBar &&
                            !this.isGameTour() &&
                            this.showCaseTemp &&
                            this.showCaseTemp.navigationManager && (
                              <ActionPathNavbarWithRecoil
                                tourType={this.state.tourType}
                                navigationMode={
                                  this.state.tourType === TourType.Kiosk ||
                                  tour.navigationWebEnabled
                                }
                                measurementsOn={this.state.measurementsOn}
                                pathFinderLine={this.showCaseTemp.navigationManager}
                                setVisible={this.setActionPathNavbarVisible}
                                sdk={this.showCaseTemp.showcase}
                                enableNavBar={this.state.actionPathNavbarData.enableNavBar}
                                destinationTitle={this.state.actionPathNavbarData.destinationTitle}
                                icon={this.state.actionPathNavbarData.icon}
                                autoNavigation={this.state.actionPathNavbarData.autoNavigation}
                                enableTeleportBtn={
                                  this.state.actionPathNavbarData.enableTeleportBtn
                                }
                                distance={this.state.actionPathNavbarDistance}
                                playButtonType={this.state.actionPathNavbarPlayButtonType}
                                setPlayButtonType={this.setActionPathNavbarPlayButtonType}
                                setActionPathFinished={this.setActionPathFinished}
                                setTeleportFinished={this.setTeleportFinished}
                                rtl={tour.client?.rtl}
                                translation={this.state.translation}
                                resetNavigationByCloseButton={this.resetNavigationByCloseButton}
                              />
                            )}
                          {tour.messengerLink &&
                            tour.messengerGreeting &&
                            this.messenger !== 0 &&
                            !room && (
                              <MessengerCustomerChat
                                pageId={tour.messengerLink}
                                loggedInGreeting={tour.messengerGreeting}
                                loggedOutGreeting={tour.messengerGreeting}
                                themeColor={whiteLabelData?.secondaryColor || '#ea475c'}
                              />
                            )}
                          {externalPopupUrl && externalPopupOn && (
                            <ExternalPopup
                              show={externalPopupUrl && externalPopupOn}
                              url={externalPopupUrl}
                              onClose={this.toggleExternalPopupNull}
                              logo={whiteLabelData?.active ? whiteLabelData?.logo : defaultLogo}
                              iframeSettings={iframeSettings}
                            />
                          )}

                          {this.injectChildComponents()}

                          {this.state.aiAvatarStatusPanel.visible && (
                              <AIAvatarStatusPanel
                                  overrideStyles={
                                    this.state.flowIsActive
                                    ? { bottom: this.calculateAIAvatarPanelBottomPosition() }
                                    : {}
                                  }
                                  status={this.state.aiAvatarStatusPanel.status}
                                  visible={this.state.aiAvatarStatusPanel.visible}
                                  onEndChat={this.handleAIAvatarStatusEndChat}
                              />
                          )}

                          {!this.isGameTour() &&
                            !this.state.panoramaOn &&
                            tour?.gameId &&
                            this.state?.game?.paths?.length === 1 &&
                            !this.state.showIntro &&
                            this.isTourReadyForAudio() && (
                              <RegularPaths
                                panoIsOpen={panoramaOn}
                                pathfinderDataState={this.state.pathfinderDataState}
                                setPathfinderDataState={this.setPathfinderDataState}
                                isRtl={tour.client?.rtl}
                                translation={this.state.translation}
                                gameId={game.id}
                                gamePaths={this.state.game.paths}
                                allTags={this.state.allTags}
                                polygons={this.state.polygons}
                                showcase={this.showCaseTemp}
                                vsObjects={this.vsObjects}
                                sweeps={this.state.sweeps}
                                currentSweep={this.state.currentSweep}
                                clickedElement={this.state.clickedElement}
                                onAction={this.onPathAction}
                                __hideItems={this.__hideConditions}
                                __revealItems={this.__revealConditions}
                                showElements={this.showElements}
                                hideElements={this.hideElements}
                              />
                            )}

                          {tagPopOn && (
                            <TagsPopup
                              logo={whiteLabelData?.logo}
                              obj={openedTag}
                              type="tags"
                              tourId={tour.id}
                              closePop={this.closeTagPop}
                            />
                          )}

                          {openedPanoHotspot && panoPopOn && (
                            <PanoPopup
                              hotspot={openedPanoHotspot}
                              show={panoPopOn}
                              onClose={this.closePanoPop}
                              logo={whiteLabelData?.logo}
                            />
                          )}
                          {this.state.showPathFinderPopup && (
                            <PathFinderPopup
                              open={this.state.showPathFinderPopup}
                              closePopup={this.closePathFinderPop}
                            />
                          )}
                          {vsActionPopOn && (
                            <VSActionsPopup
                              tourId={tour.id}
                              object={openedVSAction}
                              onClose={this.closeActionPop}
                            />
                          )}

                          {this.state.showLayers && this.state.layers?.length > 0 && (
                            <LayersOverlay
                              layers={this.state.layers}
                              onLayerClick={this.handleLayerClick}
                              tourLoaded={this.state.showcaseLoaded && this.state.loadedOnce}
                            />
                          )}

                          {contactPopupOn && showcaseLoaded && (
                            <ContactPopup
                              agents={agents}
                              rtl={tour.client?.rtl}
                              translation={translation}
                              to={tourEmail?.menuGetInTouch || tour?.client?.email}
                              legalBookingBox={tour.legalBookingBox}
                              legalBookingBox2={tour.legalBookingBox2}
                              userId={tour.userId}
                              tourId={tour.id}
                              title={tour.title}
                              client={tour.client}
                              hideClientContact={tour.hideClientContact}
                              phone={tourEmail?.contactPhone}
                              name={tourEmail?.contactName}
                              toggleContactPopup={this.toggleContactPopup}
                            />
                          )}
                          {!room && tour.ad && (
                            <AdRedesigned
                              to={
                                (tourEmail && tourEmail.leadForms) ||
                                (tour.client && tour.client.email)
                              }
                              tour={tour}
                              translation={translation}
                              rtl={this.state.rtl}
                              whitelabel={whiteLabelData}
                              form={{
                                imageSrc: `${process.env.NEXT_PUBLIC_CDN}/tours/${
                                  tour.id
                                }/ad.webp${getVersion(tour.updatedAt)}`,
                                phone: tour.leadsTimedPhone,
                                name: tour.leadsTimedName,
                                email: tour.leadsTimedEmail,
                                checkbox1: tour.legalBookingBox,
                                checkbox2: tour.legalBookingBox2,
                                url: tour.adUrl,
                                time: tour.adTime,
                              }}
                            />
                          )}

                          {showPanorama && this.renderPanorama()}

                          <div className={`overlay ${overlayOn ? 'open' : ''}`} />
                          {room && this.showCaseTemp && this.pose && !startScreenOn && (
                            <MemoizedVideo
                              iframeId={this.state.iframeId}
                              sdk={this.showCaseTemp.showcase}
                              tour={tour}
                              host={host}
                              audioOnly={audioOnly}
                              measurementsOn={measurementsOn}
                              room={room}
                              slug={tour.slug}
                              name={chatParticipant?.name}
                              avatar={chatParticipant}
                              reelVideos={reelVideos}
                              endCall={this.videoEndCall}
                              clientId={tour.clientId}
                              tourId={tour.id}
                              enterprise={isBusinessOrEnterprise}
                              translation={translation}
                              allowGuestBeforeHost={allowGuestBeforeHost}
                              changeTour={this.videoChangeTour}
                              addTrack={this.addTrack}
                              removeTrack={this.removeTrack}
                              pinnedVideos={this.state.pinnedVideos}
                              removePinnedVideo={this.removePinnedVideo}
                              onToggleMute={this.toggleMuteParticipants}
                              onToggleFullscreen={this.toggleFullscreenVideo}
                              dominantSpeaker={this.state.dominantSpeaker}
                              fullscreenVideo={this.state.fullscreenVideo}
                              addVideoReel={this.addVideoReel}
                              enableAvatar={tour?.enableAvatar}
                              imageInsteadOfAvatar={tour?.imageInsteadOfAvatar}
                              setAvatar={this.setAvatar}
                              getAvatarImage={this.getAvatarImage}
                              setAvatarImage={this.setAvatarImage}
                              updateAvatarsInList={this.updateAvatarsInList}
                              isWalkieTalkieOn={
                                this.props?.tourData?.tour?.isWalkieTalkieOn && audioOnly
                              }
                              onToggleVideoActions={this.handleUserVideoActions}
                              isRemoteControlled={isRemoteControlled}
                              selflockToggle={() => this.setState({ lock: !this.state.lock })}
                              selfLocked={this.state.lock}
                              allowFlowStart={() => this.setState({ enableFlowRunOnLaunch: true })}
                            />
                          )}

                          {this.showCaseTemp &&
                            !this.state.startScreenOn &&
                            !avatar &&
                            !room &&
                            tour?.enableAvatar && (
                              <div id="video-name-overlay" className="overlay">
                                <IntroPopup
                                  sdk={this.showCaseTemp.showcase}
                                  enableAvatar={tour?.enableAvatar}
                                  avatarType={tour?.imageInsteadOfAvatar ? 'image' : 'model'}
                                  translation={translation}
                                  setAvatar={this.setAvatar}
                                  setAvatarImage={this.setAvatarImage}
                                  getAvatarImage={this.getAvatarImage}
                                  audioOnly={audioOnly}
                                />
                              </div>
                            )}

                          {tour.legalNote && !this.state.startScreenOn && (
                            <LegalNote
                              note={tour.legalNote}
                              clientLogoWidth={this.state.clientLogoWidth}
                            />
                          )}

                          {showcaseLoaded &&
                            !tour.unbranded &&
                            tour.client &&
                            tour.client.logo &&
                            !room &&
                            !this.state.startScreenOn &&
                            !this.state.showNewHintModal &&
                            !this.state.hideLogo &&
                            (!tour.navigationWebEnabled ||
                              (tour.navigationWebEnabled &&
                                this.state.isNavigationBackgroundVisible)) && (
                              <a
                                href={
                                  tour.client?.website
                                    ? tour.client.website?.includes('https://')
                                      ? tour.client.website
                                      : `https://${tour.client.website}`
                                    : ''
                                }
                                target="_blank"
                                rel="noreferrer"
                                id="tour-logo"
                              >
                                <img
                                  className={tour.client.widthLogo ? 'logo width' : 'logo'}
                                  style={{ display: 'block', zIndex: 100 }}
                                  src={`${process.env.NEXT_PUBLIC_CDN}/clients/${
                                    tour.client.id
                                  }/logo.png${all.getVersion(tour.client.updatedAt)}`}
                                  alt=""
                                  onLoad={(event: any) => {
                                    this.setState({ clientLogoWidth: event.target.width });
                                  }}
                                />
                              </a>
                            )}

                          {this.state.markerPopupOn && (
                            <MarkerPopup
                              onClose={() => {
                                this.setState({
                                  overlayOn: false,
                                  markerPopupOn: false,
                                });
                              }}
                              primaryAction={this.toggleExternalPopup.bind(
                                this,
                                this.state.selectedMarker.external,
                              )}
                              secondaryAction={() => this.moveModel(selectedMarker.url)}
                            />
                          )}

                          {showMinimap && (
                            <Minimap
                              tour={tour}
                              minimapOn={minimapOn}
                              minimapVisible={minimapVisible}
                              minimaps={minimaps}
                              navigationSweeps={this.state.navigationSweeps}
                              selectedMinimap={selectedMinimap}
                              mapWalkerX={mapWalkerX}
                              mapWalkerY={mapWalkerY}
                              mapWalkerRotation={mapWalkerRotation}
                              iot={this.state.iot}
                              handleMoveToDevice={(device) => {
                                const fullDevice = this.state.iot.devices.find(
                                  (d) => d.id === device.deviceId,
                                );
                                if (fullDevice) {
                                  this.updateIotState({ moveToDevice: fullDevice });
                                }
                              }}
                              markerClick={this.markerClick}
                              onClick={() => {
                                this.setState({ minimapOn: !minimapOn });
                              }}
                              currentFloor={this.state.currentFloor}
                            />
                          )}
                          {this.state.appointmentsModal && (
                            <Appointment
                              tour={tour}
                              translation={translation}
                              tourEmail={tourEmail}
                              rtl={tour.client && tour.client.rtl}
                              appointmentsModal={this.state.appointmentsModal}
                              toggleAppointmentsModal={this.toggleAppointmentsModal}
                              appointmentTime={tour.appointmentTime}
                            />
                          )}

                          {sharePopupOn && (
                            <Share
                              tourType={tourType}
                              closeOnOutsideClick={tourType === TourType.ECommerce}
                              getLocation={this.getShareLocation}
                              onClose={() => {
                                this.setState({
                                  sharePopupOn: false,
                                });
                              }}
                              tour={tour}
                              translation={translation}
                              onColor={whiteLabelData?.secondaryColor || '#ea475c'}
                            />
                          )}
                          {showBottomBar &&
                            this.showCaseTemp?.showcase &&
                            this.renderBottomBar(isFullScreen, toggleFullscreen)}

                          <Sweep
                            show={
                              loadSweeps &&
                              currentSweep &&
                              !panoramaOn &&
                              (avatar || !room || !tour?.enableAvatar)
                            }
                            flowIsActive={flowIsActive}
                            renderer={this.renderer}
                            interacted={this.state.interacted}
                            tourReadyForAudio={tourStarted}
                            hideSubtitlesGroupId={this.state.hideSubtitlesGroupId}
                            videoContainer={{
                              pause: audioHandler.stopTourMusic,
                              play: this.resumeTourMusic,
                            }}
                            tour={tour}
                            tourEmail={tourEmail}
                            whitelabel={whiteLabelData}
                            groups={sweepGroups}
                            selectedGroup={this.state.activeSweepGroup}
                            noAudioMode={tour.noAudioMode && room}
                            translation={translation}
                            setIsSubtitleVisible={(status) =>
                              this.setState({ isSubtitleVisible: status })
                            }
                            showPanoramaClick={(panoramaId: number) => {
                              const pIndex = panoramas.findIndex((p: any) => p.id === panoramaId);
                              panoramas[pIndex].default = true;
                              this.setState({
                                panoramas,
                                panoramaOn: !panoramaOn,
                              });
                            }}
                            onInteractedChange={(interacted: boolean) => {
                              this.setState({ interacted });
                            }}
                            logo={whiteLabelData?.logo}
                          />

                          {showHelpModal && (
                            <Help
                              translation={translation}
                              onClose={() => {
                                this.setState({
                                  showHelpModal: false,
                                });
                              }}
                            />
                          )}

                          {showTermsModal && (
                            <Terms
                              translation={translation}
                              tourId={tour.id}
                              onClose={() => {
                                this.setState({
                                  showTermsModal: false,
                                });
                              }}
                            />
                          )}

                          {lock && <div className="lock-layer" />}

                          {!showIntro &&
                            !startScreenOn &&
                            showcaseLoaded &&
                            ((tour.music && tour.autoplayMusic) || activeSweepGroup) &&
                            !room &&
                            !interacted && (
                              <div
                                id="music-cover"
                                style={{
                                  zIndex: 2,
                                  position: 'fixed',
                                  height: '100vh',
                                  width: '100vw',
                                  top: 0,
                                  left: 0,
                                }}
                                onClick={() => {
                                  this.setState({ interacted: true });
                                }}
                              />
                            )}
                          {/* {tourForIS && tourForIS.mpPasswordActive && !showIntro && !startScreenOn &&  <LoadingScreen tour={tourForIS} />} */}
                          {tourForIS &&
                            startScreenOn &&
                            (this.isRenderAuth() || tourForIS.introScreen || this.isGameTour()) && (
                              <IntroScreen
                                rtl={tourForIS.client?.rtl}
                                tour={tourForIS}
                                initialDuplicates={initialDuplicates}
                                introScreen={tourForIS.introScreen}
                                whiteLabelData={{
                                  ...whiteLabelData,
                                  isWLUser: !!tourForIS?.user?.whitelabelId,
                                }}
                                translation={translation}
                                onStart={this.onPlayClick}
                                isGameTour={this.isGameTour}
                                onFinish={this.onIntroScreenFinished}
                                onUnmount={this.onIntroScreenUnmount}
                                preventSubmit={
                                  tourForIS?.cookieIsMandatory &&
                                  !allowUsesCookie() &&
                                  window.self === window.top
                                } // window self and top compares if it's embedded into iframe or not
                                preventSubmitCallback={() =>
                                  this.setState({ showCookieFullScreen: true })
                                }
                                inputs={
                                  this.isGameTour() && !tourForIS?.collectLeads
                                    ? {
                                        name: !!game?.registration,
                                        email: false,
                                        phone: false,
                                      }
                                    : {
                                        name: tourForIS?.collectLeads,
                                        phone: tourForIS?.collectLeads && tourForIS?.leadsPhone,
                                        email: tourForIS?.collectLeads && tourForIS?.leadsEmail,
                                      }
                                }
                                checkbox={
                                  this.isGameTour() && !tourForIS?.collectLeads
                                    ? { legal1: '', legal2: '' }
                                    : {
                                        legal1: tourForIS?.collectLeads
                                          ? tourForIS?.legalBookingBox || ''
                                          : '',
                                        legal2: tourForIS?.collectLeads
                                          ? tourForIS?.legalBookingBox2 || ''
                                          : '',
                                      }
                                }
                              />
                            )}

                          {showIntro && (!tour?.enableAvatar || (tour?.enableAvatar && avatar)) ? (
                            <ClipScreen
                              videoUrl={
                                game?.introClipUrl ||
                                `${process.env.NEXT_PUBLIC_CDN}/tours/${tour.id}/game/${game.id}/${
                                  game.uploadedIntroUrl
                                }${all.getVersion(game.updatedAt)}` ||
                                ''
                              }
                              close={() => {
                                this.onCloseIntro();
                              }}
                              hideSkipBtn={game?.hideSkipBtn}
                              forcePlay={forcePlayGameIntro}
                              subtitles={this.getCurrentLanguage()?.languageCode}
                              onStartEvent={() => {}}
                              iframe={this.iframe}
                            />
                          ) : (
                            this.renderGameContent()
                          )}
                          {!this.isGameTour() && game?.book && tourStarted && (
                            <GameBookHandle
                              isEcommerce={tourType === TourType.ECommerce}
                              gameBook={game.book}
                              onToggleGameBookModal={() =>
                                this.setState((state) => ({ showBook: !state.showBook }))
                              }
                              showBook={this.state.showBook}
                              showBookBtn={game?.gameBookOn && game?.book && !this.state.showBook}
                              closeGameBook={() => this.setState({ showBook: false })}
                              unlockedChapterIds={this.state.unlockedChapterIds}
                              tryButtonPlaySound={this.tryButtonPlaySound}
                              moveToSweep={this.moveToSweep}
                              tourType={tourType}
                            />
                          )}
                        </div>

                        {/* We load the iframe only after the intro is done */}
                        {!showIntro && iframeUrl && (
                          <LoadTourIframe
                            iframeId={this.state.iframeId}
                            mesurementsOn={measurementsOn}
                            iframeStyle={getIframeStyle({
                              tour: this.state.tour,
                              activeSweepGroup: this.state.activeSweepGroup,
                              sweepGroups: this.state.sweepGroups,
                            })}
                            cb={(el: HTMLIFrameElement | null) => {
                              this.iframe = el;
                              this.hideIframeButtons();
                            }}
                            iframeUrl={iframeUrl}
                            isFullScreen={isFullScreen}
                          />
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
              {tour && !tour.hideCookie && (
                <CustomCookieConsent
                  tour={tour}
                  loaded={showcaseLoaded}
                  message={tour && translation?.cookieConsentText}
                  messageMandatoryTitle={tour && translation?.cookieConsentTextMandatoryTitle}
                  messageMandatoryDescription={
                    tour && translation?.cookieConsentTextMandatoryDescription
                  }
                  accept={tour && translation?.cookieConsentAccept}
                  acceptMandatory={tour && translation?.cookieConsentAcceptMandatory}
                  decline={tour && translation?.cookieConsentDecline}
                  declineMandatory={tour && translation?.cookieConsentDeclineMandatory}
                  showFullScreen={
                    this.state.showCookieFullScreen || (tour.cookieIsMandatory && !startScreenOn)
                  }
                  startScreenOn={startScreenOn}
                  onAccept={() => {
                    // If loadTourAfterCookie is true, it means that tour loading was paused until user accept the cookie, so on accept we need to load the tour
                    if (tour.cookieIsMandatory && tour.loadTourAfterCookie) {
                      this.getTour({
                        slug: this.props.matterId,
                        tourData,
                        bypassCookieCheck: true,
                        url: getLocationUrl(),
                      });
                    }
                  }}
                />
              )}
              {tour &&
                tour.navigationWebEnabled &&
                tourType === TourType.Regular &&
                !startScreenOn &&
                !showIntro && (
                  <NavigationWrapper
                    showTeleportLoading={this.state.showTeleportLoading}
                    endTeleportName={this.state.endTeleportName}
                    endTpType={this.state.endTpType}
                    setShowTeleportLoading={(val) => this.setState({ showTeleportLoading: val })}
                    appState={this.state.appState}
                    isBackgroundVisible={this.state.isNavigationBackgroundVisible}
                    setBackgroundVisible={(val: boolean) =>
                      this.setState({ isNavigationBackgroundVisible: val })
                    }
                    targetLocation={this.state.navigationTarget}
                    tour={tour}
                    setDestination={this.setNavigationDestination}
                    moveToStartingPoint={this.moveToNavigationStartingPoint}
                    actionPathFinished={this.state.actionPathFinished}
                    tourType={tourType}
                    setActionPathFinished={this.setActionPathFinished}
                    pathFinderLine={this.showCaseTemp?.navigationManager}
                    rtl={tour.client?.rtl}
                    translation={this.state.translation}
                    setDescriptionEnabled={(val: boolean) =>
                      this.setState({ descriptionEnabled: val })
                    }
                    allSweeps={this.state.allSweeps}
                    currentSweep={this.currentSweep}
                    THREE={this.THREE}
                    setActionPathNavbarPlayButtonType={this.setActionPathNavbarPlayButtonType}
                    showcaseLoaded={showcaseLoaded}
                    allTags={this.state.allTags}
                    teleportPoints={this.teleportPoints}
                    showActionPathBar={this.state.showActionPathBar}
                    resetNavigationByCloseButton={this.resetNavigationByCloseButton}
                    shouldNavReset={this.state.shouldNavReset}
                    showCaseTemp={this.showCaseTemp}
                    setIsTpUp={(val) => this.setState({ isTpUp: val })}
                    isTpUp={this.state.isTpUp}
                    setPathResult={this.setPathResult}
                  />
                )}
              {/* Flows */}
              {flows?.length > 0 &&
                showcaseLoaded &&
                tour &&
                !showIntro &&
                !startScreenOn &&
                !tour.navigationWebEnabled &&
                tourType === TourType.Regular && (
                  // this.state.appState === 'playing' &&
                  <FlowsContainer
                    setFlowActive={(flow) =>
                      this.setState({ flowIsActive: flow, contactPopupOn: false, overlayOn: false })
                    }
                    moveToSweep={this.moveToSweep}
                    hideElements={this.hideElements}
                    showElements={this.showElements}
                    showCaseTemp={this.showCaseTemp}
                    showcase={this.showcase}
                    tags={Array.from(this.state.allTags.values())}
                    setFlowsObjects={(data) => this.setState(data)}
                    polygons={this.state.polygons}
                    vsObjects={this.vsObjects}
                    navigationManager={this.showCaseTemp.navigationManager}
                    sweeps={this.state.sweeps}
                    allSweeps={this.state.allSweeps}
                    currentFloor={this.state.currentFloor}
                    appState={this.state.appState}
                    flowsProps={flows}
                    mainFlow={mainFlow}
                    flowsVisibleAssets={this.state.flowsVisibleAssets}
                    tourCustomButton={tour?.customButton}
                    tour={tour}
                    flowsMenuMeshComponent={this.flowsMenuMeshComponent}
                    flowsBarMeshComponent={this.flowsBarMeshComponent}
                    vrEventManager={this.vrEventManager}
                    startFlowFromAsset={startFlowFromAsset}
                    setSelectedFlowAsset={(val) => this.setState({ startFlowFromAsset: val })}
                    socket={socket}
                    isLocked={this.state.lock}
                    isRemoteControlled={isRemoteControlled}
                    enableFlowRunOnLaunch={this.state.enableFlowRunOnLaunch}
                  />
                )}
              {showSketchfabPopup && (
                <SketchfabPopup
                  show={showSketchfabPopup}
                  vsObjects={this.vsObjects}
                  onClose={this.toggleSketchfabPopup(false)}
                />
              )}
              <SetDataToZustand
                translation={translation}
                tourConfigsInput={{ rtl: tour?.client?.rtl, tourType }}
              />
              {
                // Disabled on Georgia Pacific due to closing VR mode crashing tour during outro. Remove condition when fixed
                !this.getValueOnWindowLocationObject('href').includes('m=mEMx41aqAaq') &&
                  this.renderCrashScreen()
              }
              {tour &&
                (!tour.loadTourAfterCookie || (tour.loadTourAfterCookie && hasAcceptedCookies)) && (
                  <>
                    <Script src="https://www.googletagmanager.com/gtag/js?id=G-R2FVP1NTYY" />
                    <Script
                      dangerouslySetInnerHTML={{
                        __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());

                    gtag('config', 'G-R2FVP1NTYY');
                  `,
                      }}
                    />
                    <Script
                      id="google-leapis"
                      strategy="afterInteractive"
                      type="text/javascript"
                      src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAxJYg1iR0WMy4vpFa3zB7E0Dx7lz8h5dk&libraries=places"
                    />
                  </>
                )}
            </>
          )}
        </FullScreen>
        {confirmDialog.open && <ConfirmDialog {...confirmDialog} />}
      </>
    );
  }
}






